(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-share-copy]');
    if (!btn) return;
    var label = btn.querySelector('[data-share-copy-label]');
    var defaultText = label ? label.textContent : '';
    var copiedText = btn.getAttribute('data-share-copied-text') || 'Link copied';
    var url = btn.getAttribute('data-share-url') || window.location.href;
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      var done = function () {
        btn.setAttribute('data-share-copied', '');
        if (label) label.textContent = copiedText;
        setTimeout(function () {
          btn.removeAttribute('data-share-copied');
          if (label) label.textContent = defaultText;
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bike-cfg-header"]) return;
  try {
    
  (function () {
    document.addEventListener('cart:updated', function (e) {
      var countEl = document.querySelector('.bike-cfg-header__cart-count');
      if (!countEl) return;
      var count = e.detail && e.detail.item_count != null
        ? e.detail.item_count
        : (parseInt(countEl.textContent, 10) || 0);
      countEl.textContent = String(count);
      countEl.style.display = count > 0 ? '' : 'none';
    });
  })();

  /* Tilbage-pilen. Kom den besøgende fra vores eget site, sendes de tilbage i
     historikken, så de lander præcis hvor de slap. Kom de direkte ind fra en
     annonce, er der ingen historik, og linkets href bruges i stedet.
     Linket er et rigtigt <a href> og virker uden JS — dette er kun ovenpå. */
  (function () {
    var el = document.querySelector('[data-cfg-back]');
    if (!el) return;
    el.addEventListener('click', function (e) {
      var ref = document.referrer || '';
      var sameSite = false;
      try { sameSite = !!ref && new URL(ref).origin === window.location.origin; } catch (err) {}
      if (sameSite && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bike-configurator"] && !Shopify.designMode) return;
  try {
    
  // Clone the global footer status pill into the bike-configurator header so the
  // store status stays in sync everywhere it's shown.
  function mirrorFooterStatus() {
    var mount = document.querySelector('[data-status-mount]');
    if (!mount || mount.firstChild) return;
    var src = document.querySelector('.site-footer__status');
    if (!src) return;
    mount.appendChild(src.cloneNode(true));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mirrorFooterStatus);
  } else {
    mirrorFooterStatus();
  }

  /* ---------- Pris-tælleren (Nichlas 19-10-2026, CONFIGURATOR-STANDARD §13) ----------
     Tæller et beløb fra det tal der STÅR på siden til det nye. Der står intet
     beløb her: start og slut leveres af recalculateBuild() ud fra variantens
     price/compare_at_price og det valgte tilbehør. Den synlige kopi er
     aria-hidden; skærmlæseren får kun slutværdien i et visually-hidden spejl.
     prefers-reduced-motion: ingen tælling, slutværdien står straks. */
  var priceReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var priceEaseFn = null;

  /* Kurven er temaets token --ease-out-expo, læst fra CSS'en, så JS og CSS
     bevæger sig ens. Tallene i fallbacken er kurvens, ikke en pris. */
  function priceEase(x) {
    if (!priceEaseFn) {
      var raw = '';
      try { raw = getComputedStyle(document.documentElement).getPropertyValue('--ease-out-expo'); } catch (e) {}
      var m = /cubic-bezier\(\s*([-\d.]+)\s*,\s*([-\d.]+)\s*,\s*([-\d.]+)\s*,\s*([-\d.]+)\s*\)/.exec(raw || '');
      var p = m ? m.slice(1).map(Number) : [0.16, 1, 0.3, 1];
      priceEaseFn = cubicBezier(p[0], p[1], p[2], p[3]);
    }
    return Math.min(1, Math.max(0, priceEaseFn(x)));
  }
  function cubicBezier(x1, y1, x2, y2) {
    function A(a, b) { return 1 - 3 * b + 3 * a; }
    function B(a, b) { return 3 * b - 6 * a; }
    function C(a) { return 3 * a; }
    function at(t, a, b) { return ((A(a, b) * t + B(a, b)) * t + C(a)) * t; }
    function slope(t, a, b) { return 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a); }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var s = slope(t, x1, x2);
        if (Math.abs(s) < 1e-6) break;
        t -= (at(t, x1, x2) - x) / s;
      }
      if (!(t >= 0 && t <= 1) || Math.abs(at(t, x1, x2) - x) > 1e-4) {
        var lo = 0, hi = 1; t = x;
        for (var j = 0; j < 40; j++) {
          var cx = at(t, x1, x2);
          if (Math.abs(cx - x) < 1e-6) break;
          if (cx < x) lo = t; else hi = t;
          t = (lo + hi) / 2;
        }
      }
      return at(t, y1, y2);
    };
  }

  /* Et priselement får én tilstand: hvad der vises (shown), hvad der er sandt
     (target). plain = overstregningen, som ikke er en live-region og derfor
     ikke behøver spejlet. */
  function pricePrep(el, plain) {
    if (el._pt) return el._pt;
    var st = { el: el, vis: el, sr: null, shown: null, target: null, raf: 0, timer: 0, pending: false };
    if (!plain) {
      var txt = el.textContent.trim();
      el.textContent = '';
      var vis = document.createElement('span');
      vis.className = 'bike-price-tick';
      vis.setAttribute('aria-hidden', 'true');
      vis.textContent = txt;
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = txt;
      el.appendChild(vis);
      el.appendChild(sr);
      st.vis = vis;
      st.sr = sr;
    }
    el._pt = st;
    return st;
  }
  function priceCancel(st) {
    if (st.raf) { cancelAnimationFrame(st.raf); st.raf = 0; }
    if (st.timer) { clearTimeout(st.timer); st.timer = 0; }
    st.vis.style.width = '';
    st.el.classList.remove('is-ticking');
  }
  function priceRender(st, cents, fmt) {
    st.shown = cents;
    st.vis.textContent = fmt(cents);
  }
  function priceFinal(st, cents, fmt) {
    st.target = cents;
    if (st.sr) {
      var s = fmt(cents);
      if (st.sr.textContent !== s) st.sr.textContent = s;
    }
  }
  /* Starter ALTID fra det tal der vises lige nu (st.shown), så hurtige klik
     aldrig giver kapløb. t0 deles af elementer der skal bevæge sig i takt
     (overstregning og pris), så forskellen mellem dem er konstant. */
  function priceTickTo(st, to, ms, fmt, t0, onDone) {
    priceCancel(st);
    priceFinal(st, to, fmt);
    var from = st.shown == null ? to : st.shown;
    if (!ms || priceReducedMotion || from === to) {
      priceRender(st, to, fmt);
      if (onDone) onDone();
      return;
    }
    /* Bredden låses til det bredeste af start og slut, så naboerne ikke hopper. */
    st.vis.textContent = fmt(from);
    var w1 = st.vis.getBoundingClientRect().width;
    st.vis.textContent = fmt(to);
    var w2 = st.vis.getBoundingClientRect().width;
    st.vis.textContent = fmt(from);
    if (w1 || w2) st.vis.style.width = Math.max(w1, w2) + 'px';
    st.el.classList.add('is-ticking');
    var start = t0 || performance.now();
    var diff = to - from;
    function step(now) {
      var t = Math.min(1, Math.max(0, (now - start) / ms));
      /* Mellemtal i hele kroner, slutværdien præcis: ellers flimrer ørerne under tællingen. */
      priceRender(st, t >= 1 ? to : Math.round((from + diff * priceEase(t)) / 100) * 100, fmt);
      if (t < 1) {
        st.raf = requestAnimationFrame(step);
      } else {
        st.raf = 0;
        st.vis.style.width = '';
        st.el.classList.remove('is-ticking');
        if (onDone) onDone();
      }
    }
    st.raf = requestAnimationFrame(step);
  }

  // Gift unlock — versioned + 30-day expiry
  var GIFT_VERSION = 1;
  var GIFT_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  function readGiftState() {
    try {
      var raw = localStorage.getItem('bike_gifts');
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (data.v !== GIFT_VERSION) return false;
      if (Date.now() - data.unlocked_at > GIFT_TTL_MS) return false;
      return true;
    } catch (e) { return false; }
  }
  function writeGiftUnlocked() {
    try {
      localStorage.setItem('bike_gifts', JSON.stringify({ v: GIFT_VERSION, unlocked_at: Date.now() }));
    } catch (e) {}
  }

  // Toast for add-to-cart errors
  function showToast(message) {
    var toast = document.querySelector('.bike-cfg__toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bike-cfg__toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  function initBikeConfigurator() {
    var section = document.querySelector('.bike-cfg');
    if (!section) return;

    var productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;
    var product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      console.error('bike-configurator: product JSON parse failed', e);
      return;
    }
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return;

    /* Er gavekassen slået fra i temaeditoren, er gaverne BETINGELSESLØSE.
       Uden det ville ingen kunde få dem: oplåsningsknappen findes kun inde i
       kassen, og add-to-cart lægger dem kun i kurven `if (state.giftsUnlocked)`.
       Kassen var i forvejen kun ét klik (se «no email» ovenfor), så den
       filtrerede reelt ingen fra. */
    var giftGateOn = section.dataset.giftGate !== 'false';

    var state = {
      selectedOptions: [],
      addons: {},
      addonPrices: {},
      giftsUnlocked: giftGateOn ? readGiftState() : true
    };

    /* Prefer ?variant= from the URL (deep links / shared carts), then fall
       back to first available, then the first variant. */
    var currentVariant = null;
    try {
      var urlVid = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
      if (urlVid) {
        currentVariant = product.variants.find(function (v) { return v.id === urlVid; }) || null;
      }
    } catch (e) { /* URLSearchParams unsupported — skip */ }
    if (!currentVariant) {
      /* 504 Wh først (Website #62), ellers første ledige. */
      currentVariant = product.variants.find(function (v) { return v.available && /504/.test(String(v.option1) + String(v.option2)); })
        || product.variants.find(function (v) { return v.available; }) || product.variants[0];
    }
    state.selectedOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3];

    /* ---------- Variant logic ---------- */
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.option1 === opts[0] &&
          (opts[1] == null || v.option2 === opts[1]) &&
          (opts[2] == null || v.option3 === opts[2]);
      });
    }

    function selectOption(position, value) {
      state.selectedOptions[position - 1] = value;
      var variant = findVariant(state.selectedOptions);
      if (variant) updateVariant(variant);
    }

    var lastVariantId = null;
    var lastBaseCents = currentVariant ? currentVariant.price : 0;
    var lastTotalCents = lastBaseCents;

    /* ---------- Slide-up confirmation toast (for add-on toggles) ---------- */
    var toastEl = section.querySelector('[data-addon-toast]');
    var toastImgEl = toastEl ? toastEl.querySelector('[data-addon-toast-img]') : null;
    var toastNameEl = toastEl ? toastEl.querySelector('[data-addon-toast-name]') : null;
    var toastSubEl = toastEl ? toastEl.querySelector('[data-addon-toast-sub]') : null;
    var toastCloseEls = toastEl ? toastEl.querySelectorAll('[data-addon-toast-close]') : [];
    var toastDismissTimer = null;

    function hideAddonToast() {
      if (!toastEl) return;
      toastEl.classList.remove('is-open');
      toastEl.setAttribute('aria-hidden', 'true');
      toastEl.setAttribute('inert', '');
      if (toastDismissTimer) { clearTimeout(toastDismissTimer); toastDismissTimer = null; }
    }
    function showAddonToast(blockId) {
      if (!toastEl) return;
      /* No "added" toast on mobile — it overlaps the sticky CTA and gifts. */
      if (window.matchMedia('(max-width: 900px)').matches) return;
      var addon = (window._bikeAddonData || []).find(function (a) { return a.id === blockId; });
      if (!addon) return;

      if (toastImgEl) {
        if (addon.image) {
          toastImgEl.style.backgroundImage = 'url("' + addon.image + '")';
          toastImgEl.classList.remove('is-empty');
        } else {
          toastImgEl.style.backgroundImage = '';
          toastImgEl.classList.add('is-empty');
        }
      }
      if (toastNameEl) toastNameEl.textContent = addon.label || 'Added';
      if (toastSubEl) {
        var priceLabel = addon.price ? addon.price : '';
        toastSubEl.textContent = priceLabel
          ? 'Added · ' + priceLabel
          : 'Added to your build';
      }
      toastEl.classList.add('is-open');
      toastEl.removeAttribute('inert');
      toastEl.setAttribute('aria-hidden', 'false');
      if (toastDismissTimer) clearTimeout(toastDismissTimer);
      toastDismissTimer = setTimeout(hideAddonToast, 3200);
    }
    toastCloseEls.forEach(function (btn) {
      btn.addEventListener('click', hideAddonToast);
    });

    function updateVariant(variant) {
      var prevPrice = currentVariant ? currentVariant.price : variant.price;
      currentVariant = variant;

      var idInput = section.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      updatePrice(variant, prevPrice);
      updateGallery(variant);
      updateAddButton(variant);
      updateUrl(variant);
      recalculateBuild();
    }

    /* ---------- Price ---------- */
    var BIKE_CURRENCY = (section.getAttribute('data-currency') || 'DKK').toUpperCase();
    /* Anyday's contract locks 4 interest-free instalments. Not a monthly plan. */
    var INSTALMENT_COUNT = 4;
    function moneyFormat(cents) {
      /* Ører vises kun når der ER ører (50 % af 1.275 kr = 637,50 kr). Før 26-10-2026 blev
         alt rundet til hele kroner, og så havde siden vist 638 kr for en linje kassen tager
         637,50 kr for. Hele beløb ser ud som før. */
      var c = Math.round(cents);
      var dec = (c % 100 !== 0) ? 2 : 0;
      var n = (c / 100).toLocaleString('da-DK', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      if (BIKE_CURRENCY === 'EUR') return '€' + n;
      if (BIKE_CURRENCY === 'DKK') return n + ' kr';
      try { return new Intl.NumberFormat('da-DK', { style: 'currency', currency: BIKE_CURRENCY, maximumFractionDigits: 0 }).format(cents / 100); }
      catch (e) { return n + ' ' + BIKE_CURRENCY; }
    }

    function updatePrice(variant, prevPrice) {
      // The current-price element is animated inside recalculateBuild(),
      // so it reflects the variant price PLUS active add-ons.
      var compareEl = section.querySelector('[data-price-compare]');
      var hasCompare = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (compareEl) {
        /* Beløbet skrives af recalculateBuild() gennem pris-tælleren (cyklens
           compare_at + tilbehør), så overstregning og pris bevæger sig i takt. */
        if (hasCompare) {
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          if (compareEl._pt) compareEl._pt.shown = null;
        }
      }

      /* Spare-badget vises når varianten har en førpris. Beløbet skrives af
         recalculateBuild(), fordi det også afhænger af tilbehøret (26-10-2026). */
      var saveEl = section.querySelector('[data-price-save]');
      if (saveEl) saveEl.style.display = hasCompare ? '' : 'none';
    }

    /* ---------- Build summary + total ---------- */
    function parsePriceString(str) {
      // Fallback parser: formatted money string → integer minor units (cents).
      // Handles BOTH decimal currencies ("€87,95" → 8795) and whole-unit charm
      // currencies ("1.295 kr" → 129500). The old version stripped all non-digits
      // and ×100, so "87,95" became 8795 *major* units (€8 795 — a 100× bug in any
      // currency that shows cents). We detect a 2-digit decimal tail instead.
      // Primary path uses the raw `priceCents` injected from Liquid; this only runs
      // if that's ever missing.
      if (!str) return 0;
      var s = String(str).replace(/[^\d.,]/g, '');
      var digits = s.replace(/[^\d]/g, '');
      if (!digits) return 0;
      if (/[.,]\d{2}$/.test(s)) return parseInt(digits, 10);
      return parseInt(digits, 10) * 100;
    }

    /* ---------- Pris-tælleren: hvem viser hvad (CONFIGURATOR-STANDARD §13) ----------
       Nichlas 19-10-2026: prisen tæller ned fra førprisen til totalen når
       konfiguratoren åbner, og ned igen når et tilvalg fravælges.
       1. Åbning: én gang pr. sidevisning. De prisflader der er i viewport første
          gang en af dem ses, tæller fra den førpris der står overstreget
          (compare_at + valgt tilbehør) til totalen. Flader der først ses senere,
          står allerede på totalen. Ingen førpris = ingen tælling.
       2. Fravalg tæller ned (PRICE_MS.down), tilvalg opdaterer hurtigt (up).
          Overstregningen bevæger sig i takt, så forskellen altid er «Spar»-beløbet.
       3. «Spar …» er skjult (opacity, pladsen står) mens åbningen tæller, og
          toner frem når hovedprisen lander: ingen mellemtilstand viser en
          forkert besparelse. */
    /* Kontakten price_countdown (default false, §3 og §12): slukket = ingen
       åbningstælling, og tilvalg/fravalg glider på 600 ms som før 19-10-2026. */
    var priceCountdownOn = section.dataset.priceCountdown === 'true';
    var PRICE_MS = priceCountdownOn ? { intro: 1400, down: 750, up: 300 } : { intro: 0, down: 600, up: 600 };
    var PRICE_INTRO_DELAY = 250;
    var priceIntro = 'init';          /* init → armed → done */
    var priceShownTotal = null;
    var priceShownCompare = null;
    var priceSaveEl = section.querySelector('[data-price-save]');

    function priceTotalEls() {
      return ['[data-price-current]', '[data-price-total]', '[data-sticky-price]']
        .map(function (q) { return section.querySelector(q); })
        .filter(Boolean);
    }
    function priceIntroPossible(total, compareTotal) {
      return priceCountdownOn && compareTotal != null && compareTotal > total && !priceReducedMotion && 'IntersectionObserver' in window;
    }
    function priceHoldSave() { if (priceSaveEl) priceSaveEl.classList.add('is-price-waiting'); }
    function priceRevealSave() { if (priceSaveEl) priceSaveEl.classList.remove('is-price-waiting'); }

    function paintPrices(total, compareTotal) {
      var prev = priceShownTotal;
      priceShownTotal = total;
      priceShownCompare = compareTotal;
      var introOk = priceIntroPossible(total, compareTotal);
      var ms = (priceIntro === 'init' || prev == null) ? 0
        : total < prev ? PRICE_MS.down
        : total > prev ? PRICE_MS.up : 0;
      var t0 = performance.now();

      var cmpEl = section.querySelector('[data-price-compare]');
      if (cmpEl && compareTotal != null) priceTickTo(pricePrep(cmpEl, true), compareTotal, ms, moneyFormat, t0);

      if (priceIntro === 'init' && introOk) priceHoldSave();

      priceTotalEls().forEach(function (el) {
        var st = pricePrep(el);
        var waiting = (priceIntro === 'init' && introOk) || st.pending;
        if (waiting && introOk) {
          /* Endnu ikke set: den synlige kopi står på førprisen, skærmlæseren har totalen. */
          priceCancel(st);
          priceFinal(st, total, moneyFormat);
          priceRender(st, compareTotal, moneyFormat);
          return;
        }
        st.pending = false;
        var isMain = el.hasAttribute('data-price-current');
        priceTickTo(st, total, ms, moneyFormat, t0, isMain ? priceRevealSave : null);
      });
    }

    function armPriceIntro() {
      if (priceIntro !== 'init') return;
      var els = priceTotalEls();
      if (!els.length || !priceIntroPossible(priceShownTotal, priceShownCompare)) {
        priceIntro = 'done';
        els.forEach(function (el) { var st = pricePrep(el); priceCancel(st); priceRender(st, priceShownTotal, moneyFormat); });
        priceRevealSave();
        return;
      }
      priceIntro = 'armed';
      els.forEach(function (el) { pricePrep(el).pending = true; });
      var io = new IntersectionObserver(function (entries) {
        if (priceIntro !== 'armed') return;
        var seen = entries
          .filter(function (e) { return e.isIntersecting && e.intersectionRatio >= 0.6; })
          .map(function (e) { return e.target; });
        if (!seen.length) return;
        io.disconnect();
        priceIntro = 'done';
        var mainSeen = false;
        var starters = [];
        priceTotalEls().forEach(function (el) {
          var st = pricePrep(el);
          st.pending = false;
          if (seen.indexOf(el) === -1) { priceCancel(st); priceRender(st, st.target, moneyFormat); return; }
          if (el.hasAttribute('data-price-current')) mainSeen = true;
          starters.push(st);
        });
        if (!mainSeen) priceRevealSave();
        /* Et kort øjeblik på førprisen, så øjet når at læse hvor den starter. Én
           fælles timer og ét t0, så hovedpris og knap viser samme tal i hver frame.
           Et klik i ventetiden rydder timeren (priceCancel) og maler alle flader selv. */
        var introTimer = setTimeout(function () {
          var t0 = performance.now();
          starters.forEach(function (st) {
            if (st.timer !== introTimer) return;
            st.timer = 0;
            priceTickTo(st, st.target, PRICE_MS.intro, moneyFormat, t0, st.el.hasAttribute('data-price-current') ? priceRevealSave : null);
          });
        }, PRICE_INTRO_DELAY);
        starters.forEach(function (st) { st.timer = introTimer; });
      }, { threshold: [0.6] });
      els.forEach(function (el) { io.observe(el); });
    }

    function recalculateBuild() {
      var baseCents = currentVariant.price;
      var addonNames = [];
      var addonRows = [];
      var addonsCents = 0;
      var addonsListCents = 0;
      Object.keys(state.addons).forEach(function (blockId) {
        if (!state.addons[blockId]) return;
        var data = (window._bikeAddonData || []).find(function (a) { return a.id === blockId; });
        if (!data) return;
        addonNames.push(data.label);
        var cents = (typeof data.priceCents === 'number' ? data.priceCents : parsePriceString(data.price));
        addonRows.push({ label: data.label, cents: cents });
        addonsCents += cents;
        /* listCents findes kun når tilbehøret er nedsat (carrier_offer, §15). */
        addonsListCents += (typeof data.listCents === 'number' ? data.listCents : cents);
      });
      var total = baseCents + addonsCents;

      /* Førprisen er cyklens compare_at, ikke mere (Website #62, Nichlas 03-11-2026): kurvens og
         ladets værdi ligger nu i førprisen (PRICING.md §1), så bærerens pris lægges IKKE oveni.
         Spar = førpris minus total, altid, uanset om kunden vælger kurv, lad eller ingen. */
      var compareTotal = (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price)
        ? currentVariant.compare_at_price
        : null;
      var saveEl = section.querySelector('[data-price-save]');
      if (saveEl && compareTotal != null) {
        saveEl.textContent = saveEl.dataset.template.replace('__AMT__', moneyFormat(compareTotal - total));
      }
      paintPrices(total, compareTotal);

      /* Prislinjen under hovedprisen (carrier_preselect): hvad totalen består af. */
      var breakdownEl = section.querySelector('[data-price-breakdown]');
      if (breakdownEl) {
        breakdownEl.textContent = addonRows.length
          ? (breakdownEl.dataset.model || '') + ' ' + moneyFormat(baseCents) + addonRows.map(function (r) { return ' + ' + r.label + ' ' + (r.cents === 0 && (section.dataset.includedWord || '') ? section.dataset.includedWord.toLowerCase() : moneyFormat(r.cents)); }).join('')
          : '';
      }

      /* Hovedprisen, købsknappen og den klæbende købsbar skrives alle af
         paintPrices() ovenfor: samme total, samme tæller (CONFIGURATOR-STANDARD §13). */

      /* Anyday-widgetten læser [data-anyday-price] (price-selector) og regner selv
         om. Ren decimal uden tusindtalsseparator, sat direkte og ikke animeret, så
         widgetten ikke regner om for hvert trin i prisanimationen. */
      var anydayPriceEl = section.querySelector('[data-anyday-price]');
      if (anydayPriceEl) anydayPriceEl.textContent = (total / 100).toFixed(2);


      /* Update the instalment line. Anyday is LOCKED at 4 interest-free instalments
         (contract signed 04-09-2026), so the divisor is 4 — not the 12 months the old
         Klarna line used. Change the divisor here and nowhere else.
         The span is kept separate from the provider label to allow a 2-line layout. */
      var instalmentEl = section.querySelector('[data-klarna-amount]');
      if (instalmentEl) {
        if (!instalmentEl.dataset.template) instalmentEl.dataset.template = instalmentEl.textContent;
        var instalmentCents = Math.round(total / INSTALMENT_COUNT);
        var tpl = instalmentEl.dataset.template;
        /* Preferred: the setting carries a {amount} placeholder, so the text can say
           "4 rentefri rater" without the regex eating the 4. Fall back to the old
           currency-stripping pattern for any setting that has not been migrated —
           it handles € or kr, before OR after the number, because Danish puts the
           symbol after ("138 €/måned") and a before-only pattern left it behind. */
        instalmentEl.textContent = tpl.indexOf('{amount}') > -1
          ? tpl.replace('{amount}', moneyFormat(instalmentCents))
          : tpl.replace(/(€\s?)?\d[\d.,]*(\s?(kr|€))?/, moneyFormat(instalmentCents));
      }

      /* Receipt — show/hide the Add-ons line and update Today's price.
         Today's price = bike (variant) price + add-ons. The "Bike price"
         and "Early supporter saving" lines are server-rendered statics
         that don't change with add-ons. */
      var receiptAddons = section.querySelector('[data-receipt-addons]');
      /* Tilvalg listes ét pr. linje med sin egen pris — en samlet klump siger
         ikke kunden hvad hun har valgt. Listen bygges forfra hver gang, så den
         aldrig kan komme ud af trit med hvad der er slået til. */
      var addonListEl = section.querySelector('[data-receipt-addon-list]');
      if (addonListEl) {
        addonListEl.textContent = '';
        addonRows.forEach(function (row) {
          var r = document.createElement('div');
          r.className = 'bike-build__addon-row';
          var n = document.createElement('span'); n.textContent = row.label;
          var p = document.createElement('span'); p.textContent = row.cents === 0 ? (section.dataset.includedWord || '') : '+' + moneyFormat(row.cents);
          r.appendChild(n); r.appendChild(p);
          addonListEl.appendChild(r);
        });
      }
      if (receiptAddons) {
        if (addonsCents > 0) {
          receiptAddons.hidden = false;
          var addonsValueEl = receiptAddons.querySelector('[data-receipt-addons-value]');
          if (addonsValueEl) addonsValueEl.textContent = '+' + moneyFormat(addonsCents);
        } else {
          receiptAddons.hidden = true;
        }
      }
      var receiptTodayEl = section.querySelector('[data-receipt-today]');
      if (receiptTodayEl) receiptTodayEl.textContent = moneyFormat(total);

      lastBaseCents = baseCents;
      lastTotalCents = total;

      publishBuildContext();
    }

    /* Publish the live build → window.bycycleBuildContext. The contact-channels
       snippet reads this at click-time to pre-fill the WhatsApp message and the
       Messenger ref with the visitor's current configuration + price. */
    function publishBuildContext() {
      var model = (product && product.title) || 'City U';
      var color = (typeof getActiveColor === 'function' && getActiveColor()) || state.selectedOptions[0] || '';
      var battery = (typeof getActiveBattery === 'function' && getActiveBattery()) || state.selectedOptions[1] || '';
      var batch = state.selectedOptions[2] || '';
      var carrierBlockId = (typeof getActiveCarrierBlockId === 'function') ? getActiveCarrierBlockId() : null;
      var carrier = '';
      var addons = [];
      Object.keys(state.addons).forEach(function (id) {
        if (!state.addons[id]) return;
        var d = (window._bikeAddonData || []).find(function (a) { return a.id === id; });
        if (!d || !d.label) return;
        if (id === carrierBlockId) { carrier = d.label; return; }
        addons.push(d.label);
      });
      var total = moneyFormat(lastTotalCents);
      var build = [color, battery, carrier, addons.join(', '), batch].filter(Boolean).join(' · ');
      var ref = ('cfg|' + [color, battery, carrier, batch].filter(Boolean).join('~') + '|' + total)
        .replace(/[^A-Za-z0-9_~.\- ]/g, '').slice(0, 180);
      window.bycycleBuildContext = {
        model: model,
        build: build,
        total: total,
        summary: model + ' - ' + build + ' · ' + total,
        refToken: ref,
        variantId: currentVariant ? currentVariant.id : null,
        url: (section.dataset.productUrl || '') + (currentVariant ? '?variant=' + currentVariant.id : '')
      };
    }

    /* ---------- Gallery ---------- */
    function updateGallery(variant) {
      if (typeof syncPictured === 'function') syncPictured();
      /* Per-combo slider (variant_galleries) owns the gallery when present —
         just tell it the new colour + carrier and let it swap the whole set. */
      if (window._bikeVGalleryActive) { notifyCombo(); return; }
      /* If a carrier is active, swap directly to the per-color carrier image
         and skip the variant's base image. Setting it first would briefly
         flash the bike-without-carrier between the old image and the fade. */
      var activeBlockId = (typeof getActiveCarrierBlockId === 'function') ? getActiveCarrierBlockId() : null;
      if (activeBlockId) {
        var carrierImg = resolveCarrierImage(getActiveColor(), activeBlockId);
        if (carrierImg) {
          swapGalleryImage(carrierImg);
          return;
        }
      }
      if (variant.featured_media_id) {
        var idx = product.media.findIndex(function (m) { return m.id === variant.featured_media_id; });
        if (idx >= 0) galleryGoTo(idx);
      }
    }

    /* ---------- Add to Cart button ---------- */
    function updateAddButton(variant) {
      var btn = section.querySelector('[data-add-btn]');
      if (!btn) return;
      btn.disabled = !variant.available;
      /* Skriv KUN i etiket-spannet. btn.textContent fladede hele knappen ud og
         slettede prisspannet, så prisen hverken kunne opdateres eller få sin
         bindestreg. */
      var lbl = btn.querySelector('[data-add-label]');
      var txt = variant.available ? (btn.dataset.textAdd || 'Add to cart') : (btn.dataset.textSold || 'Sold out');
      if (lbl) { lbl.textContent = txt; } else { btn.textContent = txt; }
      /* Købsbaren følger knappen: samme etiket, samme spærring. */
      var stickyBtn = section.querySelector('[data-sticky-buy-btn]');
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        var stickyLbl = stickyBtn.querySelector('[data-sticky-buy-label]');
        if (stickyLbl) stickyLbl.textContent = txt;
      }
    }

    /* ---------- URL ----------
       Preserves existing query params (utm_*, fbclid, gclid, etc.) so
       attribution survives a variant swap. Only the `variant` key is
       touched. */
    function updateUrl(variant) {
      var url = section.dataset.productUrl;
      if (!url) return;
      if (lastVariantId === variant.id) return;
      lastVariantId = variant.id;
      var params = new URLSearchParams(window.location.search);
      params.set('variant', variant.id);
      window.history.replaceState({}, '', url + '?' + params.toString());
    }

    /* ---------- «Konfigurator brugt» (customize_product) ----------
       Første ÆGTE klik pr. sidevisning på farve eller frontbærer går til
       dataLayer, præcis én gang. GTM-ejer: tag «FB CustomizeProduct» + GA4-event
       på customEvent customize_product (ad_storage påkrævet på FB-tagget).
       e.isTrusted holder sidens egen opstart ude: selectOption(), notifyCombo()
       og en ?build=-gendannelse kalder funktionerne direkte, uden et klik.
       Clarity får HVERT ægte klik, når Clarity er indlæst (efter samtykke). */
    var cfgPushed = false;
    /* «Vist på billedet» (se «?look=» og carrier_pictured_default under Init).
       En bærer kan VISES på cyklen uden at være VALGT: den står på billedet og
       kortet bærer mærket, men den er ikke i pris eller kurv (forbrugerrettigheds-
       direktivet art. 22). Den bliver vist indtil kunden selv træffer et valg,
       bærer eller «uden», også når hun skifter farve. Defineret her, fordi
       notifyCombo og updateGallery kalder den. */
    var picturedBlockId = null;
    var carrierChoiceMade = false;
    var noneChosen = false;
    var carrierPicturedDefault = section.dataset.carrierPicturedDefault === 'true';
    /* carrier_preselect: frontkurven er VALGT ved ankomst (Nichlas 12-10-2026, se
       CONFIGURATOR-STANDARD §14). Valget sker med selectCarrier(opt, true) uden et
       klik, så det tæller hverken som customize_product eller i Clarity. */
    var carrierPreselect = section.dataset.carrierPreselect === 'true';
    function picturedCarrier() {
      if (!picturedBlockId || carrierChoiceMade) return null;
      if (section.querySelector('[data-carrier-opt].is-active')) return null;
      return picturedBlockId;
    }
    function syncPictured() {
      var bid = picturedCarrier();
      section.querySelectorAll('[data-carrier-opt]').forEach(function (o) {
        var on = !!bid && o.dataset.blockId === bid;
        o.classList.toggle('is-pictured', on);
        var tag = o.querySelector('[data-carrier-pictured]');
        if (tag) tag.hidden = !on;
      });
    }
    function cfgTrack(e, choice, value, clarityEvent) {
      if (!e || !e.isTrusted) return;
      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', clarityEvent);
          if (choice === 'frontbaerer') window.clarity('set', 'cfg_baerer', value);
          if (choice === 'farve') window.clarity('set', 'cfg_farve', String(value));
        }
      } catch (err) { /* måling må aldrig vælte konfiguratoren */ }
      if (cfgPushed) return;
      cfgPushed = true;
      (window.dataLayer = window.dataLayer || []).push({
        event: 'customize_product',
        cfg_choice: choice,
        cfg_value: value,
        event_id: 'cfg_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
      });
    }
    /* Bærerens navn efter blok-id (addon-basket / addon-carrier), ikke efter den
       oversatte produkttitel, så værdien er den samme på dansk og engelsk. */
    function cfgTrackCarrier(e, forceNone) {
      var bid = forceNone ? null : getActiveCarrierBlockId();
      var v = !bid ? 'uden' : (/basket|kurv/i.test(bid) ? 'kurv' : 'lad');
      cfgTrack(e, 'frontbaerer', v, v === 'kurv' ? 'cfg_frontkurv' : (v === 'lad' ? 'cfg_frontlad' : 'cfg_uden'));
    }

    /* ---------- Color swatches ---------- */
    var swatches = section.querySelectorAll('[data-swatch]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        var value = this.dataset.optionValue;
        var position = Number(this.dataset.optionPosition);
        var hex = this.dataset.swatchHex;
        swatches.forEach(function (s) {
          if (Number(s.dataset.optionPosition) === position) {
            s.classList.toggle('is-active', s.dataset.optionValue === value);
          }
        });
        selectOption(position, value);

        /* Sync every label that mirrors the colour name — inline panel
           label + mobile trigger row both use [data-color-name]. */
        section.querySelectorAll('[data-color-name]').forEach(function (el) {
          el.textContent = value;
        });
        if (hex) {
          section.querySelectorAll('[data-color-dot]').forEach(function (dot) {
            dot.style.setProperty('--swatch-color', hex);
          });
        }
        setBikeColorAttr();
        cfgTrack(e, 'farve', value, 'cfg_farve');
      });
    });

    /* ---------- Battery segmented selector ---------- */
    var batteryCards = section.querySelectorAll('[data-battery]');
    var batterySeg = section.querySelector('[data-battery-seg]');
    batteryCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (this.dataset.disabled === 'true') return;
        var value = this.dataset.optionValue;
        var position = Number(this.dataset.optionPosition);
        var idx = Number(this.dataset.idx || 0);
        batteryCards.forEach(function (c) {
          c.classList.toggle('is-active', c.dataset.optionValue === value);
        });
        if (batterySeg) batterySeg.style.setProperty('--idx', idx);
        selectOption(position, value);
      });
    });

    /* ---------- Delivery batch (active card click) ----------
       Only one batch is "active" at a time in the rolling-reveal UI; clicking
       it re-asserts the selection (idempotent) and ensures the variant lookup
       lands on the active batch. The locked teaser is rendered as a non-button
       div so it doesn't end up here. */
    var batchCards = section.querySelectorAll('[data-batch]');
    batchCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var value = this.dataset.optionValue;
        var position = Number(this.dataset.optionPosition);
        if (!value || !position) return;
        selectOption(position, value);
      });
    });

    /* ---------- Delivery batch (notify-me on locked teaser) ----------
       Lead capture now lives in the Reserve flow (the gift gate no longer
       collects email), so interest in a locked/future batch opens Reserve —
       which captures the buyer's email + build. */
    var batchNotify = section.querySelector('[data-batch-notify]');
    if (batchNotify) {
      batchNotify.addEventListener('click', function () {
        var holdBtn = section.querySelector('[data-hold-open]');
        if (holdBtn) holdBtn.click();
      });
    }

    /* ---------- On init: if the current variant's batch isn't the merchant's
       active_batch, re-select to the active one so the price/CTA always
       reflects the active batch (not whatever ?variant= URL the buyer landed on). */
    var firstActiveBatchCard = section.querySelector('[data-batch]');
    if (firstActiveBatchCard) {
      var activePos = Number(firstActiveBatchCard.dataset.optionPosition);
      var activeVal = firstActiveBatchCard.dataset.optionValue;
      if (activePos && activeVal && state.selectedOptions[activePos - 1] !== activeVal) {
        selectOption(activePos, activeVal);
      }
    }

    /* ---------- Add-on toggles ---------- */
    var addonToggles = section.querySelectorAll('[data-addon-toggle]');
    addonToggles.forEach(function (toggle) {
      var blockId = toggle.dataset.addonToggle;
      state.addons[blockId] = false;
      toggle.addEventListener('change', function () {
        var wasAdded = !state.addons[blockId] && this.checked;
        state.addons[blockId] = this.checked;
        recalculateBuild();
        if (wasAdded) showAddonToast(blockId);
      });
    });

    /* ---------- Carrier segmented selector (mutually exclusive + gallery swap) ---------- */
    var carrierOpts = section.querySelectorAll('[data-carrier-opt]');
    var carrierSeg = section.querySelector('[data-carrier-seg]');
    var galleryImg = section.querySelector('.bike-gallery__main img');

    /* Per-color × per-carrier image map from product metafield. */
    var carrierGalleryEl = section.querySelector('[data-carrier-gallery]');
    var carrierGalleryMap = {};
    if (carrierGalleryEl) {
      try { carrierGalleryMap = JSON.parse((carrierGalleryEl.textContent || '').trim() || '{}'); }
      catch (e) { carrierGalleryMap = {}; }
    }

    /* Collect all carrier block ids so we can clear them when switching. */
    var carrierBlockIds = [];
    carrierOpts.forEach(function (opt) {
      var bid = opt.dataset.blockId;
      if (bid) {
        carrierBlockIds.push(bid);
        if (!(bid in state.addons)) state.addons[bid] = false;
      }
    });

    /* Bærerkortenes billeder (card_art) følger cyklens farve via data-bike-color. */
    function setBikeColorAttr() {
      var c = getActiveColor() || '';
      section.dataset.bikeColor = /black|sort/i.test(c) ? 'black' : 'white';
    }

    function getActiveColor() {
      var sw = section.querySelector('[data-swatch].is-active');
      return sw ? sw.dataset.optionValue : null;
    }

    /* Read battery from the active battery button rather than a fixed
       option index — the variant option order isn't guaranteed to be
       [color, battery, batch], so a hardcoded index can pick up the
       wrong value (e.g. the colour name) in the build summary. */
    function getActiveBattery() {
      var b = section.querySelector('[data-battery].is-active');
      return b ? b.dataset.optionValue : null;
    }

    function getActiveCarrierBlockId() {
      var opt = section.querySelector('[data-carrier-opt].is-active');
      return opt && opt.dataset.blockId ? opt.dataset.blockId : null;
    }

    /* Tell the variant-gallery slider (bike-gallery snippet) to swap to the
       current colour × carrier combo. Carrier key = block id, or 'none'. */
    function notifyCombo() {
      syncPictured();
      document.dispatchEvent(new CustomEvent('bike:combo', {
        detail: { color: getActiveColor(), carrier: getActiveCarrierBlockId() || picturedCarrier() || 'none' }
      }));
    }

    function resolveCarrierImage(color, blockId) {
      if (!blockId) return null;
      /* 1. Per-color override from product metafield. */
      if (color && carrierGalleryMap[color] && carrierGalleryMap[color][blockId]) {
        return carrierGalleryMap[color][blockId];
      }
      /* 2. Universal fallback: the carrier block's gallery_image setting. */
      var data = (window._bikeAddonData || []).find(function (a) { return a.id === blockId; });
      return data && data.galleryImage ? data.galleryImage : null;
    }

    function swapGalleryImage(src) {
      if (window._bikeVGalleryActive) return; /* slider owns the gallery */
      if (!galleryImg || !src) return;
      if (galleryImg.getAttribute('src') === src) return;

      var FADE_MS = 320;
      galleryImg.style.transition = 'opacity ' + FADE_MS + 'ms cubic-bezier(0.65, 0, 0.35, 1)';
      // Cancel any in-flight swap so it doesn't race this one.
      galleryImg.dataset.pendingSwap = src;
      galleryImg.style.opacity = '0';

      var fadeDone = false;
      var loaded = false;

      function applyIfReady() {
        if (!fadeDone || !loaded) return;
        if (galleryImg.dataset.pendingSwap !== src) return; /* superseded */
        galleryImg.setAttribute('src', src);
        galleryImg.style.opacity = '1';
        delete galleryImg.dataset.pendingSwap;

        var main = galleryImg.closest('.bike-gallery__main');
        if (main) {
          main.classList.remove('is-pulsing');
          void main.offsetWidth; /* reflow so animation restarts on rapid swaps */
          main.classList.add('is-pulsing');
          setTimeout(function () { main.classList.remove('is-pulsing'); }, 700);
        }
      }

      setTimeout(function () { fadeDone = true; applyIfReady(); }, FADE_MS);

      var next = new Image();
      next.onload = function () {
        loaded = true;
        applyIfReady();
      };
      next.onerror = function () {
        if (galleryImg.dataset.pendingSwap !== src) return;
        galleryImg.style.opacity = '1';
        delete galleryImg.dataset.pendingSwap;
      };
      next.src = src;
    }

    /* Re-apply the active carrier image for the current color, called after variant changes. */
    function applyActiveCarrierImage() {
      var blockId = getActiveCarrierBlockId();
      if (!blockId) return; /* "None" — let updateGallery's variant image stand. */
      var img = resolveCarrierImage(getActiveColor(), blockId);
      if (img) swapGalleryImage(img);
    }
    window._bikeApplyCarrierImage = applyActiveCarrierImage;

    function positionCarrierThumb() {
      if (!carrierSeg) return;
      var active = carrierSeg.querySelector('[data-carrier-opt].is-active');
      if (!active) return;
      var segRect = carrierSeg.getBoundingClientRect();
      var optRect = active.getBoundingClientRect();
      carrierSeg.style.setProperty('--thumb-x', (optRect.left - segRect.left) + 'px');
      carrierSeg.style.setProperty('--thumb-w', optRect.width + 'px');
    }

    /* Refresh the mobile trigger row label to reflect the current carrier
       selection, or fall back to the snippet-rendered 'no carrier' label
       captured at init — Liquid is not evaluated inside javascript blocks. */
    var firstCarrierRowEl = section.querySelector('[data-carrier-row-name]');
    var noCarrierLabel = firstCarrierRowEl ? firstCarrierRowEl.textContent : 'None';
    /* «Uden frontbærer»-kortet. Både select og deselect ender i
       refreshCarrierRowLabel(), så tilstanden sættes ét sted. */
    var carrierNoneBtn = section.querySelector('[data-carrier-none]');
    function syncCarrierNone() {
      if (!carrierNoneBtn) return;
      var any = !!section.querySelector('[data-carrier-opt].is-active');
      /* Med carrier_pictured_default er «uden» kun valgt når kunden selv har
         valgt det. Før stod den grøn og afkrydset som standard og lignede det
         forvalgte valg (Nichlas 12-10-2026). */
      var on = carrierPicturedDefault ? (noneChosen && !any) : !any;
      carrierNoneBtn.classList.toggle('is-active', on);
      carrierNoneBtn.setAttribute('aria-pressed', String(on));
    }
    if (carrierNoneBtn) {
      carrierNoneBtn.addEventListener('click', function (e) {
        if (typeof deselectCarrier === 'function') deselectCarrier();
        cfgTrackCarrier(e, true);
      });
    }

    function refreshCarrierRowLabel() {
      syncCarrierNone();
      var active = section.querySelector('[data-carrier-opt].is-active');
      var name = active && active.dataset.carrierName ? active.dataset.carrierName : '';
      section.querySelectorAll('[data-carrier-row-name]').forEach(function (el) {
        el.textContent = name || noCarrierLabel;
      });
      /* Desktop heading suffix — "Front Carrier — <name>", or the
         "Select your carrier" prompt when nothing is chosen. */
      /* Har kunden selv valgt «Uden frontløsning», står valget i etiketten. Før stod
         prompten der, og det lignede at intet var valgt (brand-voice 26-10-2026). */
      var noneTextEl = section.querySelector('.bike-carrier__none-text');
      var noneText = (carrierPicturedDefault && noneChosen && !active && noneTextEl) ? noneTextEl.textContent.trim() : '';
      section.querySelectorAll('[data-carrier-label-name]').forEach(function (el) {
        var prompt = el.getAttribute('data-select-prompt') || 'Select your carrier';
        el.textContent = ' - ' + (name || noneText || prompt);
      });
      /* Modal "No carrier" segment is active exactly when nothing is chosen. */
      section.querySelectorAll('[data-carrier-none]').forEach(function (el) {
        el.classList.toggle('is-active', carrierPicturedDefault ? (noneChosen && !active) : !active);
      });
    }

    function deselectCarrier() {
      carrierChoiceMade = true;
      noneChosen = true;
      carrierOpts.forEach(function (o) { o.classList.remove('is-active'); });
      carrierBlockIds.forEach(function (bid) { state.addons[bid] = false; });
      /* Revert gallery to the current variant's plain bike image. */
      if (currentVariant && currentVariant.featured_media_id) {
        var i = product.media.findIndex(function (m) { return m.id === currentVariant.featured_media_id; });
        if (i >= 0) galleryGoTo(i);
      }
      recalculateBuild();
      refreshCarrierRowLabel();
      notifyCombo();
    }

    function selectCarrier(opt, silent) {
      /* Click an already-active option → deselect (no carrier is the default). */
      if (opt.classList.contains('is-active')) {
        deselectCarrier();
        return;
      }

      var blockId = opt.dataset.blockId;
      var idx = Number(opt.dataset.idx || 0);
      carrierChoiceMade = true;
      noneChosen = false;

      /* Sync by block-id so the desktop control + the combined-modal option for
         the same carrier both reflect the selection (mobile renders the modal). */
      carrierOpts.forEach(function (o) { o.classList.toggle('is-active', o.dataset.blockId === blockId); });
      if (carrierSeg) carrierSeg.style.setProperty('--idx', idx);
      positionCarrierThumb();

      /* Reset every carrier in the group, then enable the chosen one. */
      carrierBlockIds.forEach(function (bid) { state.addons[bid] = false; });
      state.addons[blockId] = true;

      var img = resolveCarrierImage(getActiveColor(), blockId);
      if (img) swapGalleryImage(img);

      recalculateBuild();
      if (!silent) showAddonToast(blockId);
      refreshCarrierRowLabel();
      notifyCombo();
    }

    carrierOpts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        /* Ignore clicks that originated on the Read-more button (it stops propagation, but defensive). */
        if (e.target.closest('[data-addon-detail]')) return;
        selectCarrier(opt);
        cfgTrackCarrier(e);
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          if (e.target.closest('[data-addon-detail]')) return;
          e.preventDefault();
          selectCarrier(opt);
          cfgTrackCarrier(e);
        }
      });
    });

    /* ---------- Restore a shared / edited build from ?build= ----------
       The bike variant is already restored from ?variant= above; here we
       re-apply the selected add-ons + carrier so "Edit build" (and any shared
       build link) reopens the exact configuration. */
    try {
      var buildParam = new URLSearchParams(window.location.search).get('build');
      if (buildParam) {
        requestAnimationFrame(function () {
          buildParam.split(',').forEach(function (rawId) {
            var bid = rawId.trim();
            if (!bid) return;
            var carrierOpt = section.querySelector('[data-carrier-opt][data-block-id="' + bid + '"]');
            if (carrierOpt) {
              if (!carrierOpt.classList.contains('is-active')) selectCarrier(carrierOpt, true);
              return;
            }
            var toggle = section.querySelector('[data-addon-toggle="' + bid + '"]');
            if (toggle && !toggle.checked) {
              toggle.checked = true;
              state.addons[bid] = true;
            }
          });
          recalculateBuild();
        });
      }
    } catch (e) { /* URLSearchParams unsupported — skip restore */ }

    /* ---------- Add-on modal ---------- */
    var addonDataEl = section.querySelector('[data-addon-data]');
    var addonData = addonDataEl ? JSON.parse(addonDataEl.textContent) : [];
    window._bikeAddonData = addonData;

    /* ---------- Tilbuddet på bærerne (CONFIGURATOR-STANDARD §15, Website #33) ----------
       Kilden er shop-metafeltet custom.carrier_offer, som sync-carrier-offer.js skriver ud
       fra den automatiske rabat i Shopify. Rabatten er det kassen regner med; dette er kun
       visningen af den. Derfor:
       1. Intet tal her. Procent, start, slut og produkter kommer fra metafeltet, prisen fra
          produktet, og tilbudsprisen regnes som kassen: listepris minus afrundet rabat.
       2. Kundens ur afgør start og slut, så en cachet side ikke viser tilbuddet efter
          rabatten er udløbet, og visningen slukker af sig selv hvis siden står åben.
       3. Kun på den cykel rabatten kræver (buys), og kun på de bærere den giver (gets).
       4. Mærkets og linjens tekst står i metafeltet, skrevet af scriptet fra GODKENDTE
          linjer i budskabsbank.json. Mangler teksten, vises intet mærke og ingen linje. */
    var carrierOffer = null;
    function readCarrierOffer() {
      var el = section.querySelector('[data-carrier-offer]');
      if (!el) return null;
      var o;
      try { o = JSON.parse(el.textContent); } catch (e) { return null; }
      /* Black Month-forhåndsvisning (Website #62): kun staging, se data-carrier-offer-preview i markup. */
      var pv = section.querySelector('[data-carrier-offer-preview]');
      if (pv && o) { try { var pj = JSON.parse(pv.textContent); o.percent = pj.percent; o.badge = pj.badge; o.line = pj.line; o.note = pj.note; } catch (e) { /* ingen forhåndsvisning */ } }
      /* 100 % er gyldigt (Website #62: kurv eller lad følger med i prisen). */
      if (!o || typeof o.percent !== 'number' || !(o.percent > 0 && o.percent <= 100)) return null;
      if (!Array.isArray(o.gets) || !o.gets.length) return null;
      if (Array.isArray(o.buys) && o.buys.length && o.buys.indexOf(product.handle) === -1) return null;
      var end = Date.parse(o.ends_at);
      var start = o.starts_at ? Date.parse(o.starts_at) : 0;
      var now = Date.now();
      if (!end || isNaN(end) || now >= end || (start && now < start)) return null;
      o._end = end;
      return o;
    }
    function offerText(t) {
      if (!t) return '';
      if (typeof t === 'string') return t;
      var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
      return t[lang] || t.en || '';
    }
    function paintCarrierOffer(on) {
      addonData.forEach(function (a) {
        if (typeof a.listCents !== 'number') return;
        section.querySelectorAll('[data-carrier-opt][data-block-id="' + a.id + '"]').forEach(function (card) {
          var was = card.querySelector('[data-carrier-was]');
          var cur = card.querySelector('[data-carrier-price]');
          var off = card.querySelector('[data-carrier-off]');
          var badge = on ? offerText(carrierOffer.badge) : '';
          if (cur) {
            /* Med i prisen (100 %): ingen «+0 kr», kun den overstregede værdi og mærket «Inkluderet». */
            cur.textContent = (on && a.priceCents === 0) ? '' : '+' + moneyFormat(a.priceCents);
            cur.hidden = !!(on && a.priceCents === 0);
          }
          if (was) { was.textContent = on ? '+' + moneyFormat(a.listCents) : ''; was.hidden = !on; }
          if (off) { off.textContent = badge; off.hidden = !badge; }
          card.classList.toggle('has-offer', on);
        });
      });
      var lineEl = section.querySelector('[data-carrier-offer-line]');
      if (lineEl) {
        var line = on ? offerText(carrierOffer.line) : '';
        lineEl.textContent = line;
        lineEl.hidden = !line;
      }
      var noteEl = section.querySelector('[data-carrier-offer-note]');
      if (noteEl) {
        var note = '';  /* KF62-2-01 alene (Nichlas 03-11): noten under linjen vises ikke mere */
        noteEl.textContent = note;
        noteEl.hidden = !note;
      }
      /* Novemberblokken står i batterivælgerens sted (Nichlas 03-11-2026): vælgeren skjules, 14 Ah er forvalgt og låst. */
      var bandEl = section.querySelector('[data-gifts-band]');
      var segEl = section.querySelector('[data-battery-seg]');
      if (bandEl) { bandEl.hidden = !on; if (segEl) segEl.hidden = !!on; }
    }
    function applyCarrierOffer() {
      addonData.forEach(function (a) {
        if (!a.handle || carrierOffer.gets.indexOf(a.handle) === -1 || typeof a.priceCents !== 'number') return;
        a.listCents = a.priceCents;
        a.priceCents = a.listCents - Math.round(a.listCents * carrierOffer.percent / 100);
        a.price = moneyFormat(a.priceCents);
      });
      paintCarrierOffer(true);
      /* Udløber tilbuddet mens siden står åben, går kort og total tilbage til listeprisen. */
      var ms = carrierOffer._end - Date.now();
      if (ms > 0 && ms < 2147483647) setTimeout(endCarrierOffer, ms);
    }
    function endCarrierOffer() {
      addonData.forEach(function (a) {
        if (typeof a.listCents !== 'number') return;
        a.priceCents = a.listCents;
        a.price = moneyFormat(a.listCents);
      });
      paintCarrierOffer(false);
      addonData.forEach(function (a) { delete a.listCents; });
      carrierOffer = null;
      recalculateBuild();
    }
    carrierOffer = readCarrierOffer();
    if (carrierOffer) applyCarrierOffer();
    var modal = section.querySelector('[data-addon-modal]');
    var modalLastFocus = null;

    function openAddonModal(blockId) {
      if (!modal) return;
      var data = addonData.find(function (a) { return a.id === blockId; });
      if (!data) return;

      var imgContainer = modal.querySelector('[data-addon-modal-image]');
      var titleEl = modal.querySelector('[data-addon-modal-title]');
      var priceEl = modal.querySelector('[data-addon-modal-price]');
      var bodyEl = modal.querySelector('[data-addon-modal-body]');

      if (imgContainer) {
        if (data.image) {
          var img = document.createElement('img');
          img.src = data.image;
          img.alt = data.label || '';
          imgContainer.innerHTML = '';
          imgContainer.appendChild(img);
        } else {
          imgContainer.innerHTML = '';
        }
      }
      if (titleEl) titleEl.textContent = data.label || '';
      if (priceEl) priceEl.textContent = data.price ? '+ ' + data.price : '';
      if (bodyEl) bodyEl.innerHTML = data.description || '';

      modalLastFocus = document.activeElement;
      modal.removeAttribute('inert');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      // Move focus into the modal
      var firstFocusable = modal.querySelector('[data-addon-modal-close], button, a, input, [tabindex]');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeAddonModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      document.documentElement.removeAttribute('scroll-lock');
      if (modalLastFocus && typeof modalLastFocus.focus === 'function') {
        modalLastFocus.focus();
      }
    }

    function trapModalFocus(e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    var detailBtns = section.querySelectorAll('[data-addon-detail]');
    detailBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openAddonModal(this.dataset.addonDetail);
      });
    });

    function openIncludedModal(btn) {
      if (!modal) return;
      var imgContainer = modal.querySelector('[data-addon-modal-image]');
      var titleEl = modal.querySelector('[data-addon-modal-title]');
      var priceEl = modal.querySelector('[data-addon-modal-price]');
      var bodyEl = modal.querySelector('[data-addon-modal-body]');
      if (imgContainer) {
        var photo = btn.dataset.includedImage || '';
        if (photo) {
          var imgEl = document.createElement('img');
          imgEl.src = photo;
          imgEl.alt = btn.dataset.includedTitle || '';
          imgContainer.innerHTML = '';
          imgContainer.appendChild(imgEl);
        } else {
          imgContainer.innerHTML = '';
        }
      }
      if (titleEl) titleEl.textContent = btn.dataset.includedTitle || '';
      if (priceEl) priceEl.textContent = '';
      if (bodyEl) bodyEl.innerHTML = '<p>' + (btn.dataset.includedBody || '') + '</p>';

      modalLastFocus = btn;
      modal.removeAttribute('inert');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      var firstFocusable = modal.querySelector('[data-addon-modal-close], button, a, input, [tabindex]');
      if (firstFocusable) firstFocusable.focus();
    }

    var includedBtns = section.querySelectorAll('[data-included-detail]');
    includedBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        includedBtns.forEach(function (b) { if (b !== btn) b.classList.remove('is-open'); });
        btn.classList.add('is-open');
        openIncludedModal(btn);
      });
    });

    if (modal) {
      modal.addEventListener('transitionend', function () {
        if (!modal.classList.contains('is-open')) {
          includedBtns.forEach(function (b) { b.classList.remove('is-open'); });
        }
      });
    }

    if (modal) {
      var modalOverlay = modal.querySelector('[data-addon-modal-overlay]');
      var modalClose = modal.querySelector('[data-addon-modal-close]');
      if (modalOverlay) modalOverlay.addEventListener('click', closeAddonModal);
      if (modalClose) modalClose.addEventListener('click', closeAddonModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeAddonModal();
        else trapModalFocus(e);
      });
    }

    /* ---------- Gallery: thumbnails + arrows ---------- */
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    var prevArrow = section.querySelector('[data-gallery-prev]');
    var nextArrow = section.querySelector('[data-gallery-next]');
    var galleryIndex = 0;

    function galleryGoTo(index) {
      if (window._bikeVGalleryActive) return; /* slider owns the gallery */
      if (index < 0 || index >= product.media.length) return;
      galleryIndex = index;
      var mediaObj = product.media[galleryIndex];
      var mainImg = section.querySelector('[data-gallery-main] img');
      if (mainImg && mediaObj) {
        mainImg.alt = mediaObj.alt || product.title;
        swapGalleryImage(mediaObj.src);
      }
      thumbs.forEach(function (t) {
        var active = Number(t.dataset.galleryIndex) === galleryIndex;
        t.classList.toggle('is-active', active);
        if (active) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      updateGalleryArrows();
    }

    function updateGalleryArrows() {
      if (prevArrow) prevArrow.disabled = galleryIndex === 0;
      if (nextArrow) nextArrow.disabled = galleryIndex === product.media.length - 1;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryGoTo(Number(this.dataset.galleryIndex));
      });
    });

    if (prevArrow) prevArrow.addEventListener('click', function () { galleryGoTo(galleryIndex - 1); });
    if (nextArrow) nextArrow.addEventListener('click', function () { galleryGoTo(galleryIndex + 1); });

    updateGalleryArrows();

    /* ---------- Form submission ---------- */
    var form = section.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var btn = section.querySelector('[data-add-btn]');
        if (btn) btn.disabled = true;

        var selectedAddonIds = Object.keys(state.addons).filter(function (id) { return state.addons[id]; });
        /* Unique id stamped on every line of THIS build so a second/third
           pre-order never quantity-merges add-ons across builds and each build
           can be grouped + edited on its own. */
        var buildId = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        var items = [{ id: currentVariant.id, quantity: 1, properties: { _build_role: 'bike', _build_id: buildId, _build_addons: selectedAddonIds.join(',') } }];

        function getAddonVariantId(blockId) {
          /* Regular addon-card toggle */
          var cardEl = section.querySelector('[data-addon-block="' + blockId + '"] [data-addon-variant-id]');
          if (cardEl && cardEl.value) return parseInt(cardEl.value, 10);
          /* Carrier segmented option */
          var carrierEl = section.querySelector('[data-carrier-opt][data-block-id="' + blockId + '"]');
          if (carrierEl) {
            /* Tilbehøret følger cyklens farve. Uden dette blev den første variant
               (Matte White) altid lagt i kurven, også til en sort cykel. Matcher
               ingen variant farven, bruges fallbacken i data-variant-id. */
            var color = getActiveColor();
            if (color && carrierEl.dataset.variants) {
              try {
                var want = String(color).toLowerCase();
                var list = JSON.parse(carrierEl.dataset.variants);
                for (var i = 0; i < list.length; i++) {
                  var opts = list[i].o || [];
                  for (var j = 0; j < opts.length; j++) {
                    if (String(opts[j]).toLowerCase() === want) return parseInt(list[i].id, 10);
                  }
                }
              } catch (e) { /* falder igennem til fallbacken */ }
            }
            if (carrierEl.dataset.variantId) return parseInt(carrierEl.dataset.variantId, 10);
          }
          return null;
        }

        Object.keys(state.addons).forEach(function (blockId) {
          if (!state.addons[blockId]) return;
          var vid = getAddonVariantId(blockId);
          if (vid) items.push({ id: vid, quantity: 1, properties: { _build_role: 'addon', _build_id: buildId } });
        });

        if (state.giftsUnlocked) {
          var bonusIdsEl = section.querySelector('[data-bonus-variant-ids]');
          if (bonusIdsEl && bonusIdsEl.value) {
            bonusIdsEl.value.split(',').forEach(function (id) {
              var parsed = parseInt(id.trim(), 10);
              if (parsed) items.push({ id: parsed, quantity: 1, properties: { _build_role: 'gift', _build_id: buildId } });
            });
          }
        }

        /* Ét AddToCart pr. «Køb nu» (Website #55, målt 30-10-2026). Shopifys Meta-kanal og GA4
           sender ét product_added_to_cart pr. kurvlinje, så 6 linjer (cykel, kurv, 4 gaver til 0 kr)
           blev til 6 AddToCart i pixlen. Cyklen lægges i kurven på normal vis og tæller som ét event
           med cyklens værdi. Tilbehør og gaver lægges i kurven fra en skjult same-origin iframe: samme
           kurv, samme cookie, men Shopifys sporing hænger på sidens egen fetch/XHR og ser den ikke.
           Fejler iframen, falder vi tilbage til sidens fetch, så kurven aldrig bliver ufuldstændig
           (så tæller de ekstra linjer som før). Hold cyklen først: rækkefølgen i kurven er uændret. */
        var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        function postCartAdd(win, list) {
          return win.fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: list })
          }).then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                throw new Error(err.description || err.message || 'Could not add to cart');
              });
            }
            return r.json();
          });
        }
        function postCartAddUntracked(list) {
          var frame = null;
          try {
            frame = document.createElement('iframe');
            frame.setAttribute('aria-hidden', 'true');
            frame.tabIndex = -1;
            frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
            document.body.appendChild(frame);
            if (!frame.contentWindow || typeof frame.contentWindow.fetch !== 'function') throw new Error('no iframe fetch');
            return postCartAdd(frame.contentWindow, list).then(function (res) {
              frame.remove();
              return res;
            }, function (err) {
              frame.remove();
              throw err;
            });
          } catch (e) {
            if (frame && frame.parentNode) frame.remove();
            return postCartAdd(window, list);
          }
        }

        postCartAdd(window, items.slice(0, 1))
          .then(function () {
            return items.length > 1 ? postCartAddUntracked(items.slice(1)) : null;
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            var useModal = section.dataset.preorderModalEnabled !== 'false';
            if (window.refreshCartDrawer) {
              window.refreshCartDrawer().then(function (cart) {
                /* §15: kurven er sandheden. Giver kurven ikke den tilbudspris kortet
                   viste (metafeltet og rabatten er drevet fra hinanden), meldes det til
                   dataLayer, så det ses i målingen og ikke kun af kunden. */
                if (carrierOffer && cart && Array.isArray(cart.items) && !section.querySelector('[data-carrier-offer-preview]')) {
                  cart.items.forEach(function (it) {
                    if (!it.properties || it.properties._build_id !== buildId) return;
                    if (carrierOffer.gets.indexOf(it.handle) === -1 || !it.quantity) return;
                    var expected = it.original_price - Math.round(it.original_price * carrierOffer.percent / 100);
                    var unit = Math.round(it.final_line_price / it.quantity);
                    if (unit > expected + 1) {
                      (window.dataLayer = window.dataLayer || []).push({ event: 'carrier_offer_mismatch', carrier: it.handle, expected_cents: expected, cart_cents: unit });
                      console.warn('carrier offer: cart price', unit, 'expected', expected, it.handle);
                    }
                  });
                }
                if (useModal && typeof openPreorderModal === 'function') {
                  /* Mirror the drawer — show all builds (the just-added + any others). */
                  openPreorderModal(cart);
                } else if (window.openCartDrawer) {
                  window.openCartDrawer();
                }
              });
            }
          })
          .catch(function (err) {
            console.error('Add to cart failed:', err);
            showToast(err && err.message ? err.message : 'Could not add to cart. Please try again.');
          })
          .finally(function () {
            if (btn) btn.disabled = !currentVariant.available;
          });
      });
    }

    /* ---------- Reservation ----------
       Sælger ét fast reservationsprodukt uanset konfiguration, men stempler
       kundens valg på ordrelinjen. Det er hele pointen: uden konfigurationen
       ved vi ikke hvad tilbuddet på restbeløbet skal lyde på, når vi ringer.
       Synlig egenskab = det sælger skal læse. _-præfiks = skjult for kunden. */
    var reserveBtn = section.querySelector('[data-reserve-btn]');
    if (reserveBtn) {
      reserveBtn.addEventListener('click', function () {
        var vid = parseInt(reserveBtn.dataset.reserveVariantId, 10);
        if (!vid) { showToast('Reservation is not configured.'); return; }

        reserveBtn.disabled = true;

        /* Genberegn, så vi altid stempler det der står på skærmen lige nu. */
        publishBuildContext();
        var ctx = window.bycycleBuildContext || {};
        var label = reserveBtn.dataset.reservePropLabel || 'Configuration';

        var props = {};
        props[label] = ctx.build || '';
        /* Samme værdi i et fast felt: kurvens JS må ikke skulle gætte
           egenskabens navn, som skifter med sprog og indstilling. */
        props['_bike_build'] = ctx.build || '';

        /* Struktureret kopi af opsætningen. Reservationen er ÉN kurvlinje, så
           kurven kan ikke udlede tilvalg og gaver som den kan for cyklen, hvor
           hver ting er sin egen linje. Uden det her kan kortet kun vise chips.
           Format: "Navn|ører|billedURL(encodet);…" — bevidst fladt, fordi Shopifys
           linjeegenskaber kun kan bære tekst. Billedet er tredje felt (31-08-2026),
           encodet; gamle kurve uden felt falder tilbage til prikken. */
        var resAddons = [], resGifts = [];
        try {
          var carrierId = (typeof getActiveCarrierBlockId === 'function') ? getActiveCarrierBlockId() : null;
          Object.keys(state.addons).forEach(function (id) {
            if (!state.addons[id]) return;
            var d = (window._bikeAddonData || []).find(function (a) { return a.id === id; });
            if (!d || !d.label) return;
            var c = (typeof d.priceCents === 'number') ? d.priceCents : 0;
            /* Tredje felt: billed-URL, encodet så '|' og ';' aldrig kan brække
               formatet. Skuffen viser tilvalgets FOTO frem for en grøn prik. */
            var im = d.image ? encodeURIComponent(d.image) : '';
            resAddons.push(d.label + '|' + c + '|' + im);
          });
          var giftLabelsEl = section.querySelector('[data-bonus-labels]');
          if (state.giftsUnlocked && giftLabelsEl && giftLabelsEl.value) {
            giftLabelsEl.value.split(';').forEach(function (g) {
              if (g && g.trim()) resGifts.push(g.trim());
            });
          }
        } catch (err) {}
        props['_bike_addons'] = resAddons.join(';');
        props['_bike_gifts'] = resGifts.join(';');
        props['_build_role'] = 'reservation';
        props['_bike_model'] = ctx.model || '';
        props['_bike_variant_id'] = ctx.variantId ? String(ctx.variantId) : '';
        props['_bike_total'] = ctx.total || '';
        props['_bike_url'] = ctx.url || '';

        /* Én reservation ad gangen. Uden dette kan kunden lægge to i kurven
           og betale 1.000 kr for én cykel. Fjern eksisterende først, læg så til. */
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var updates = {};
            (cart.items || []).forEach(function (it) {
              if (it.properties && it.properties._build_role === 'reservation') updates[it.key] = 0;
            });
            if (!Object.keys(updates).length) return null;
            return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .catch(function () { /* kunne ikke rydde op — læg alligevel til */ })
          .then(function () {
            return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
            });
          })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                throw new Error(err.description || err.message || 'Could not reserve');
              });
            }
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (window.refreshCartDrawer) {
              window.refreshCartDrawer().then(function () {
                if (window.openCartDrawer) window.openCartDrawer();
              });
            } else if (window.openCartDrawer) {
              window.openCartDrawer();
            }
          })
          .catch(function (err) {
            console.error('Reserve failed:', err);
            showToast(err && err.message ? err.message : 'Could not reserve. Please try again.');
          })
          .finally(function () { reserveBtn.disabled = false; });
      });
    }

    /* ---------- Pre-order overview modal ----------
       Shown (instead of the cart drawer) after a successful add. Mirrors the
       drawer: renders ALL builds via window.bycycleRenderBuilds, with each
       card's own Edit (+ confirm) and per-add-on remove handled by the
       document-level cart-drawer handlers. Re-renders live on cart:updated. */
    var preorderModalEl = section.querySelector('[data-preorder-modal]');
    var preorderBuildEl = preorderModalEl && preorderModalEl.querySelector('[data-preorder-build]');
    var preorderTitleEl = preorderModalEl && preorderModalEl.querySelector('[data-preorder-title]');
    var preorderOverlay = preorderModalEl && preorderModalEl.querySelector('[data-preorder-overlay]');
    var preorderLastFocus = null;

    function preorderBuildCount(buildItems) {
      var ids = {};
      buildItems.forEach(function (it) {
        ids[(it.properties && it.properties._build_id) || '_legacy'] = true;
      });
      return Object.keys(ids).length;
    }

    /* Render every build into the modal and set a count-aware title.
       Returns the number of build lines (0 = nothing to show). */
    function renderPreorderBuilds(cart) {
      var items = (cart && cart.items) || [];
      var buildItems = items.filter(function (it) { return it.properties && it.properties._build_role; });
      if (preorderBuildEl) {
        preorderBuildEl.innerHTML = (buildItems.length && typeof window.bycycleRenderBuilds === 'function')
          ? window.bycycleRenderBuilds(items)
          : '';
      }
      if (preorderTitleEl) {
        var many = preorderBuildCount(buildItems) > 1;
        var t = many
          ? preorderTitleEl.getAttribute('data-preorder-title-many')
          : preorderTitleEl.getAttribute('data-preorder-title-one');
        if (t) preorderTitleEl.textContent = t;
      }
      return buildItems.length;
    }

    function openPreorderModal(cart) {
      if (!preorderModalEl) {
        if (window.openCartDrawer) window.openCartDrawer();
        return;
      }
      if (!renderPreorderBuilds(cart)) {
        /* Nothing tagged as a build — fall back to the drawer, not an empty modal. */
        if (window.openCartDrawer) window.openCartDrawer();
        return;
      }
      preorderLastFocus = document.activeElement;
      preorderModalEl.classList.add('is-open');
      preorderModalEl.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
      document.documentElement.setAttribute('scroll-lock', '');
      var focusTarget = preorderModalEl.querySelector('[data-preorder-checkout]');
      if (focusTarget) focusTarget.focus();
    }

    function closePreorderModal() {
      if (!preorderModalEl) return;
      preorderModalEl.classList.remove('is-open');
      preorderModalEl.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      document.documentElement.style.removeProperty('--scrollbar-width');
      if (preorderLastFocus && typeof preorderLastFocus.focus === 'function') preorderLastFocus.focus();
    }

    if (preorderModalEl) {
      preorderModalEl.querySelectorAll('[data-preorder-close]').forEach(function (el) {
        el.addEventListener('click', closePreorderModal);
      });
      if (preorderOverlay) preorderOverlay.addEventListener('click', closePreorderModal);
      document.addEventListener('keydown', function (e) {
        if (!preorderModalEl.classList.contains('is-open')) return;
        if (e.key === 'Escape') { closePreorderModal(); return; }
        if (e.key === 'Tab') {
          var focusables = preorderModalEl.querySelectorAll('button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])');
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      /* Live mirror: a per-add-on remove (×) inside a card calls
         refreshCartDrawer() which dispatches cart:updated with the fresh cart —
         re-render the open modal so it stays in sync; close once empty.
         (Per-card Edit navigates away, so it doesn't rely on this.) */
      document.addEventListener('cart:updated', function (e) {
        if (!preorderModalEl.classList.contains('is-open')) return;
        var cart = e.detail && e.detail.cart;
        if (!cart) return;
        if (!renderPreorderBuilds(cart)) closePreorderModal();
      });
    }

    /* ---------- Reviews dropdown ---------- */
    var reviewsToggle = section.querySelector('[data-reviews-toggle]');
    var reviewsPanel = section.querySelector('[data-reviews-panel]');
    var reviewsCluster = section.querySelector('[data-reviews-cluster]');
    if (reviewsToggle && reviewsPanel) {
      function setReviewsOpen(open) {
        reviewsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        reviewsPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
        reviewsPanel.classList.toggle('is-open', open);
      }
      reviewsToggle.addEventListener('click', function () {
        var nextOpen = reviewsToggle.getAttribute('aria-expanded') !== 'true';
        setReviewsOpen(nextOpen);
      });
      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!reviewsCluster) return;
        if (reviewsToggle.getAttribute('aria-expanded') !== 'true') return;
        if (reviewsCluster.contains(e.target)) return;
        setReviewsOpen(false);
      });
      // Close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && reviewsToggle.getAttribute('aria-expanded') === 'true') {
          setReviewsOpen(false);
          reviewsToggle.focus();
        }
      });
    }

    /* ---------- Gift unlock (simple one-click reveal — no email) ----------
       The free add-ons are shown openly; "unlock" is a light delight, not a
       lead gate. Real lead capture now lives in the "Reserve your bike" flow. */
    var gateReveal = section.querySelector('[data-gifts-reveal]');
    var gateUnlockBtn = section.querySelector('[data-gift-unlock]');

    function unlockGifts() {
      var locked = section.querySelector('[data-gifts-locked]');
      var unlocked = section.querySelector('[data-gifts-unlocked]');
      if (locked) locked.style.display = 'none';
      if (unlocked) unlocked.style.display = '';
    }

    /* Cinematic reveal: fade + stagger the gifts in.
       animate=false for returning visitors (show instantly). */
    function revealGifts(animate) {
      if (gateReveal) {
        gateReveal.style.display = '';
        if (animate) {
          void gateReveal.offsetWidth; /* reflow so the CSS animation plays */
          gateReveal.classList.add('is-revealing');
        }
      }
    }

    if (state.giftsUnlocked) {
      unlockGifts();
      revealGifts(false);
    } else if (gateUnlockBtn) {
      gateUnlockBtn.addEventListener('click', function () {
        state.giftsUnlocked = true;
        writeGiftUnlocked();
        unlockGifts();
        revealGifts(true);
      });
    }

    /* ---------- Hold my bike (lead capture → Klaviyo) ----------
       Secondary CTA. Captures name + email (+ optional phone) and the current
       build, then subscribes the profile to the configurator list (tagged
       lead_type: hold_my_bike) and fires a "Held Build" event. Reuses the same
       Klaviyo credentials and pattern as the email gate above. */
    var holdModal = document.querySelector('[data-hold-modal]');
    var holdOpenBtn = section.querySelector('[data-hold-open]');
    if (holdModal && holdOpenBtn) {
      var holdForm = holdModal.querySelector('[data-hold-form]');
      var holdSummaryEl = holdModal.querySelector('[data-hold-summary]');
      var holdFormView = holdModal.querySelector('[data-hold-view="form"]');
      var holdSuccessView = holdModal.querySelector('[data-hold-view="success"]');
      var holdErrorEl = holdModal.querySelector('[data-hold-error]');
      var holdErrorMsg = (holdForm && holdForm.dataset.errorMsg) || 'Something went wrong - please try again.';
      var carrierNoneText = (holdSummaryEl && holdSummaryEl.dataset.carrierNone) || 'No carrier';
      var holdLastFocus = null;

      /* Mirror the chosen country's number format into the phone-number
         placeholder (e.g. Denmark → "XX XX XX XX") so people see the
         expected shape for their dial code. */
      var holdPhoneCodeEl = holdModal.querySelector('[data-hold-phone-code]');
      var holdPhoneNumEl = holdModal.querySelector('[data-hold-phone]');
      function syncPhonePlaceholder() {
        if (!holdPhoneCodeEl || !holdPhoneNumEl) return;
        var opt = holdPhoneCodeEl.options[holdPhoneCodeEl.selectedIndex];
        var fmt = opt && opt.getAttribute('data-format');
        if (fmt) holdPhoneNumEl.setAttribute('placeholder', fmt);
      }
      if (holdPhoneCodeEl) {
        holdPhoneCodeEl.addEventListener('change', syncPhonePlaceholder);
        syncPhonePlaceholder();
      }

      function buildSummary() {
        var carrierBlockId = (typeof getActiveCarrierBlockId === 'function') ? getActiveCarrierBlockId() : null;
        var carrierLabel = null;
        var addonNames = [];
        Object.keys(state.addons).forEach(function (blockId) {
          if (!state.addons[blockId]) return;
          var data = (window._bikeAddonData || []).find(function (a) { return a.id === blockId; });
          if (!data || !data.label) return;
          if (blockId === carrierBlockId) { carrierLabel = data.label; return; }
          addonNames.push(data.label);
        });
        return {
          model: (product && product.title) || '',
          color: (typeof getActiveColor === 'function' && getActiveColor()) || state.selectedOptions[0] || '',
          battery: (typeof getActiveBattery === 'function' && getActiveBattery()) || state.selectedOptions[1] || '',
          carrier: carrierLabel,
          addons: addonNames,
          batch: state.selectedOptions[2] || '',
          total: moneyFormat(lastTotalCents),
          variant_id: currentVariant ? currentVariant.id : null,
          url: (section.dataset.productUrl || '') + (currentVariant ? '?variant=' + currentVariant.id : '')
        };
      }

      function summaryString(b) {
        var parts = [b.color, b.battery];
        if (b.carrier) parts.push(b.carrier);
        if (b.addons.length) parts.push(b.addons.join(', '));
        if (b.batch) parts.push(b.batch);
        var detail = parts.filter(Boolean).join(' · ');
        return (b.model ? b.model + ' - ' : '') + detail + ' · ' + b.total;
      }

      function setSummaryRow(key, value, toggleRow) {
        var cell = holdSummaryEl ? holdSummaryEl.querySelector('[data-hold-val="' + key + '"]') : null;
        if (cell) cell.textContent = value || '';
        if (toggleRow) {
          var row = holdSummaryEl ? holdSummaryEl.querySelector('[data-hold-row="' + key + '"]') : null;
          if (row) row.hidden = !value;
        }
      }

      function renderSummary(b) {
        if (!holdSummaryEl) return;
        setSummaryRow('model', b.model, true);
        setSummaryRow('color', b.color);
        setSummaryRow('battery', b.battery);
        setSummaryRow('carrier', b.carrier || carrierNoneText);
        setSummaryRow('addons', b.addons.join('\n'), true);
        setSummaryRow('batch', b.batch);
        setSummaryRow('total', b.total);
      }

      function openHold() {
        holdLastFocus = document.activeElement;
        renderSummary(buildSummary());
        if (holdFormView) holdFormView.hidden = false;
        if (holdSuccessView) holdSuccessView.hidden = true;
        if (holdErrorEl) { holdErrorEl.hidden = true; holdErrorEl.textContent = ''; }
        holdModal.classList.add('is-open');
        holdModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var firstInput = holdModal.querySelector('[data-hold-name]');
        if (firstInput) setTimeout(function () { firstInput.focus(); }, 80);
      }

      function closeHold() {
        holdModal.classList.remove('is-open');
        holdModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (holdLastFocus && typeof holdLastFocus.focus === 'function') holdLastFocus.focus();
      }

      holdOpenBtn.addEventListener('click', openHold);
      holdModal.querySelectorAll('[data-hold-close]').forEach(function (btn) {
        btn.addEventListener('click', closeHold);
      });
      var holdOverlay = holdModal.querySelector('[data-hold-modal-overlay]');
      if (holdOverlay) holdOverlay.addEventListener('click', closeHold);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && holdModal.classList.contains('is-open')) closeHold();
      });

      /* The country code now comes from a dedicated <select>, so the number
         box holds the national part only. Strip everything but digits, drop
         any national trunk "0", and prefix the chosen dial code. */
      function normalizePhone(raw, code) {
        var local = (raw || '').replace(/\D/g, '').replace(/^0+/, '');
        if (!local) return '';
        return (code || '+45') + local;
      }

      if (holdForm) {
        holdForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var nameInput = holdForm.querySelector('[data-hold-name]');
          var emailInput = holdForm.querySelector('[data-hold-email]');
          var phoneInput = holdForm.querySelector('[data-hold-phone]');
          var phoneCodeInput = holdForm.querySelector('[data-hold-phone-code]');
          var submitBtn = holdForm.querySelector('[data-hold-submit]');
          var listId = holdForm.dataset.klaviyoList;
          var companyId = holdForm.dataset.klaviyoCompany;

          var name = nameInput ? nameInput.value.trim() : '';
          var email = emailInput ? emailInput.value.trim() : '';
          var phone = phoneInput ? normalizePhone(phoneInput.value, phoneCodeInput ? phoneCodeInput.value : '+45') : '';

          function showError(el) {
            if (holdErrorEl) { holdErrorEl.textContent = holdErrorMsg; holdErrorEl.hidden = false; }
            if (el) el.classList.add('is-invalid');
          }
          if (holdErrorEl) holdErrorEl.hidden = true;
          [nameInput, emailInput].forEach(function (el) { if (el) el.classList.remove('is-invalid'); });

          if (!name) { showError(nameInput); return; }
          if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { showError(emailInput); return; }
          if (!companyId || !listId) { showError(); return; }

          var nameParts = name.split(/\s+/);
          var firstName = nameParts.shift();
          var lastName = nameParts.join(' ');

          var build = buildSummary();
          var heldBuild = {
            model: build.model,
            color: build.color,
            battery: build.battery,
            carrier: build.carrier || '',
            addons: build.addons,
            batch: build.batch,
            total: build.total,
            variant_id: build.variant_id,
            url: build.url
          };
          var heldSummary = summaryString(build);

          if (submitBtn) submitBtn.disabled = true;

          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'hold-my-bike',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        first_name: firstName,
                        last_name: lastName,
                        properties: {
                          source: 'hold-my-bike',
                          lead_type: 'hold_my_bike',
                          whatsapp_phone: phone,
                          held_build: heldBuild,
                          held_build_summary: heldSummary,
                          last_held_at: new Date().toISOString()
                        }
                      }
                    }
                  }
                },
                relationships: {
                  list: { data: { type: 'list', id: listId } }
                }
              }
            })
          })
            .then(function (r) {
              if (!(r.ok || r.status === 202)) {
                return r.text().then(function (txt) { throw new Error('Klaviyo ' + r.status + ': ' + txt); });
              }
              /* Best-effort: log a "Held Build" event (build history + flow trigger). */
              fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                body: JSON.stringify({
                  data: {
                    type: 'event',
                    attributes: {
                      properties: heldBuild,
                      metric: { data: { type: 'metric', attributes: { name: 'Held Build' } } },
                      profile: { data: { type: 'profile', attributes: { email: email, properties: { whatsapp_phone: phone } } } }
                    }
                  }
                })
              }).catch(function (err) { console.error('Held Build event failed:', err); });

              if (holdFormView) holdFormView.hidden = true;
              if (holdSuccessView) holdSuccessView.hidden = false;
            })
            .catch(function (err) {
              console.error('Hold my bike failed:', err);
              showError();
            })
            .finally(function () {
              if (submitBtn) submitBtn.disabled = false;
            });
        });
      }
    }


    /* ---------- «Gem din opsætning» (Website #61, 01-11-2026) ----------
       Valgfrit felt. Knappen sender opsætningen: profil + eventet «Setup Saved» via Klaviyos client API
       (uden om onsite-scriptet, som i «Hold my bike»). KUN hvis samtykkeboksen er krydset af tilmeldes
       profilen markedsføring, og kun på den dedikerede liste (gem_list_id). Aldrig newsletter-listen:
       den starter velkomstflowet. Uden flueben: profil + event, ingen tilmelding.
       Eventet bærer det kurv-flowets mails læser: $extra.line_items (title, product.properties med
       _build_role/_build_addons, product.variant_options), Items, $value og checkout_url
       (her: URL der genskaber opsætningen via ?variant= og ?build=). */
    var gemEl = section.querySelector('[data-gem]');
    if (gemEl) {
      var gemCompany = section.dataset.gemCompany;
      var gemList = section.dataset.gemList;
      var gemRevision = '2026-07-15';
      var gemForm = gemEl.querySelector('[data-gem-form]');
      var gemRow = gemEl.querySelector('.bike-gem__row');
      var gemEmail = gemEl.querySelector('[data-gem-email]');
      var gemConsent = gemEl.querySelector('[data-gem-consent]');
      var gemBtn = gemEl.querySelector('[data-gem-submit]');
      var gemErr = gemEl.querySelector('[data-gem-error]');
      var gemOk = gemEl.querySelector('[data-gem-success]');
      var gemFormView = gemEl.querySelector('[data-gem-form-view]');
      gemEl.hidden = false;

      function gemBuild() {
        var ids = Object.keys(state.addons).filter(function (id) { return state.addons[id]; });
        /* Samme nøgler som Shopifys Checkout Started (engelske: Colour, Battery), uanset sidens sprog:
           kurv-mailene slår op på variant_options|lookup:'Colour'. */
        var opts = { Colour: getActiveColor() || (currentVariant && currentVariant.option1) || '', Battery: getActiveBattery() || '' };
        var img = null;
        (product.media || []).forEach(function (m) {
          if (currentVariant && m.id === currentVariant.featured_media_id) img = m.src;
        });
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var buildId = 'g' + Date.now().toString(36);
        var lines = [{
          title: product.title, quantity: 1, price: currentVariant ? currentVariant.price / 100 : null,
          properties: { _build_role: 'bike', _build_id: buildId, _build_addons: ids.join(',') },
          product: {
            handle: product.handle, variant_options: opts, images: img ? [{ src: img }] : [],
            properties: { _build_role: 'bike', _build_id: buildId, _build_addons: ids.join(',') }
          }
        }];
        ids.forEach(function (id) {
          var d = (window._bikeAddonData || []).find(function (a) { return a.id === id; });
          if (!d || !d.label) return;
          lines.push({
            title: d.label, quantity: 1, price: typeof d.priceCents === 'number' ? d.priceCents / 100 : null,
            properties: { _build_role: 'addon', _build_id: buildId },
            product: { handle: d.handle || '', variant_options: {}, images: [], properties: { _build_role: 'addon', _build_id: buildId } }
          });
        });
        var q = new URLSearchParams();
        if (currentVariant) q.set('variant', currentVariant.id);
        if (ids.length) q.set('build', ids.join(','));
        var url = window.location.origin + (section.dataset.productUrl || window.location.pathname) + '?' + q.toString();
        return {
          lines: lines, url: url, ids: ids, opts: opts,
          total: lastTotalCents / 100,
          currency: (section.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK')
        };
      }

      function gemFail(invalidEmail) {
        if (invalidEmail && gemRow) gemRow.classList.add('is-invalid');
        if (gemErr) gemErr.hidden = false;
      }

      gemEmail.addEventListener('input', function () {
        if (gemRow) gemRow.classList.remove('is-invalid');
        if (gemErr) gemErr.hidden = true;
      });

      gemForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (gemRow) gemRow.classList.remove('is-invalid');
        if (gemErr) gemErr.hidden = true;
        var email = (gemEmail.value || '').trim();
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { gemFail(true); return; }
        var consent = !!gemConsent.checked;
        /* Krydset af, men ingen dedikeret liste: luk ned frem for at gætte en liste. */
        if (!gemCompany || (consent && !gemList)) { gemFail(false); return; }

        var b = gemBuild();
        var nowIso = new Date().toISOString();
        var profileProps = { source: 'gem-din-opsaetning', gem_marketing_consent: consent, last_setup_saved_at: nowIso };
        var eventBody = {
          data: {
            type: 'event',
            attributes: {
              properties: {
                Items: b.lines.map(function (l) { return l.title; }),
                'Item Count': b.lines.length,
                'Customer Locale': document.documentElement.lang || 'da',
                Source: 'gem-din-opsaetning',
                Consent: consent,
                _bike_model: product.title,
                _bike_build: b.ids.join(','),
                _bike_addons: b.ids.join(','),
                _bike_total: b.total,
                _bike_url: b.url,
                $extra: { checkout_url: b.url, responsive_checkout_url: b.url, line_items: b.lines }
              },
              value: b.total,
              value_currency: b.currency,
              unique_id: 'gem-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
              time: nowIso,
              metric: { data: { type: 'metric', attributes: { name: 'Setup Saved' } } },
              profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } }
            }
          }
        };
        var hdr = { 'Content-Type': 'application/json', 'revision': gemRevision };
        var base = 'https://a.klaviyo.com/client/';
        var q = '/?company_id=' + encodeURIComponent(gemCompany);
        function ok(r) {
          if (r.ok || r.status === 202) return r;
          return r.text().then(function (t) { throw new Error('Klaviyo ' + r.status + ': ' + t); });
        }
        function sendEvent() {
          return fetch(base + 'events' + q, { method: 'POST', headers: hdr, body: JSON.stringify(eventBody) }).then(ok);
        }
        function subscribe() {
          return fetch(base + 'subscriptions' + q, {
            method: 'POST', headers: hdr,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'gem-din-opsaetning',
                  profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } }
                },
                relationships: { list: { data: { type: 'list', id: gemList } } }
              }
            })
          }).then(ok);
        }

        gemBtn.disabled = true;
        /* Event først (opsætningen er det hun bad om), så tilmelding hvis hun satte flueben. */
        sendEvent()
          .then(function () { return consent ? subscribe() : null; })
          .then(function () {
            if (gemFormView) gemFormView.hidden = true;
            if (gemOk) gemOk.hidden = false;
          })
          .catch(function (err) {
            console.error('Gem din opsaetning failed:', err);
            gemFail(false);
          })
          .finally(function () { gemBtn.disabled = false; });
      });
    }

    /* ---------- Farve og bærer vælges INLINE ----------
       Den kombinerede «Vælg farve og bærer»-modal er fjernet 02-09-2026.
       Den åbnede hver gang man trykkede på en farve eller en bærer på mobil,
       og stjal dermed fokus i præcis det sekund valget skulle mærkes på
       cyklen. Nu er galleriet klæbende (se RESPONSIVE), så billedet skifter
       for øjnene af én uden at noget lægger sig ovenpå.

       Trigger-rækkerne (.bike-cfg__opt-row) var i forvejen døde: de stod
       display:none uden nogen regel der satte dem tilbage. Og `bike:expand`
       blev aldrig udsendt af galleriet.

       Fravalg af bærer sker inline: tryk igen på den valgte (selectCarrier). */

    /* ---------- Init ---------- */
    var addBtn = section.querySelector('[data-add-btn]');
    if (addBtn) {
      /* Kun etiketten, ikke hele knappen — ellers bliver prisen en del af den
         tekst der skrives tilbage ved hvert variantskift. */
      var addLbl = addBtn.querySelector('[data-add-label]');
      addBtn.dataset.textAdd = (addLbl ? addLbl.textContent : addBtn.textContent).trim();
      /* Liquid har allerede lagt den oversatte tekst i data-text-sold («Udsolgt»).
         Før 12-10-2026 blev den overskrevet med engelsk her. */
      addBtn.dataset.textSold = addBtn.dataset.textSold || 'Sold out';
    }

    /* updateVariant() already calls recalculateBuild() — don't double-render. */
    updateVariant(currentVariant);
    refreshCarrierRowLabel();
    setBikeColorAttr();

    /* ---------- ?look=<bærer>-<farve>: siden åbner som annoncen ----------
       ?look=kurv-hvid  → Matte White, galleriet med frontkurv
       ?look=lad-sort   → Matte Black, galleriet med frontlad
       ?look=uden-hvid  → Matte White, «Uden frontløsning» valgt (uden-sort: Matte Black)
       🔴 Bæreren lægges IKKE i pris eller kurv (forbrugerrettighedsdirektivet
       art. 22: intet forvalg af tillægsbetaling). Kun billedet skifter, og kortet
       får mærket [data-carrier-pictured]. Først et ægte tryk vælger bæreren.
       Farven vælges med et programmatisk .click(), som har isTrusted=false og
       derfor hverken tæller som customize_product eller går til Clarity.
       Mærket fjernes ved første ændring af kombinationen (notifyCombo /
       updateGallery), for så viser billedet ikke længere den bærer.
       Ukendt eller manglende look = siden som i dag. */
    try {
      var lookParam = (new URLSearchParams(window.location.search).get('look') || '').toLowerCase();
      var lookMatch = lookParam.match(/^(kurv|lad|uden)-(hvid|sort)$/);
      var lookSwatch = null;
      var lookWantBasket = null;
      var lookNone = false;
      if (lookMatch) {
        var lookColorRe = lookMatch[2] === 'hvid' ? /white|hvid/i : /black|sort/i;
        lookWantBasket = lookMatch[1] === 'kurv';
        lookNone = lookMatch[1] === 'uden';
        swatches.forEach(function (sw) { if (!lookSwatch && lookColorRe.test(sw.dataset.optionValue || '')) lookSwatch = sw; });
      } else if ((carrierPicturedDefault || carrierPreselect) && !section.querySelector('[data-carrier-opt].is-active')) {
        /* Standardvisningen (carrier_pictured_default): cyklen vises med
           frontkurven i sin egen farve, som ?look=kurv-<farve>. Ikke valgt. */
        lookWantBasket = true;
      }
      if (lookNone) {
        /* ?look=uden-<farve>: farven vælges, og «Uden frontløsning» er valgt. Et ægte fravalg (samme
           kode som et tryk på knappen), så et forvalgt tilbehør (carrier_preselect) ikke ligger i pris eller kurv. */
        if (lookSwatch && !lookSwatch.classList.contains('is-active')) lookSwatch.click();
        if (typeof deselectCarrier === 'function') deselectCarrier();
      } else if (lookWantBasket !== null) {
        var lookBlockId = null;
        carrierBlockIds.forEach(function (bid) { if (!lookBlockId && /basket|kurv/i.test(bid) === lookWantBasket) lookBlockId = bid; });
        if (lookBlockId && (lookSwatch || !lookMatch)) {
          if (lookSwatch && !lookSwatch.classList.contains('is-active')) lookSwatch.click();
          var preOpt = carrierPreselect ? section.querySelector('[data-carrier-opt][data-block-id="' + lookBlockId + '"]') : null;
          if (preOpt) {
            /* Rigtigt forvalg: i pris, bar, Anyday og /cart/add. Kurvens variant følger
               farven af sig selv (getAddonVariantId læser den aktive farve ved køb). */
            if (!preOpt.classList.contains('is-active')) selectCarrier(preOpt, true);
          } else {
          picturedBlockId = lookBlockId;
          if (window._bikeVGalleryActive) {
            notifyCombo();
          } else {
            var lookImg = resolveCarrierImage(getActiveColor(), lookBlockId);
            if (lookImg) swapGalleryImage(lookImg);
            syncPictured();
          }
          }
        }
      }
    } catch (err) { /* en forkert parameter må aldrig vælte siden */ }

    /* ---------- Klæbende købsbar på mobil (mobile_sticky_buy) ----------
       Synlig fra farvevalget (.bike-swatches) står HELT fremme over baren, og
       indtil den rigtige købsblok nærmer sig (96 px under skærmen), så de to
       aldrig står samtidig. 12-10-2026: ankeret var frontbæreren, men det
       klæbende galleri skjuler den længe før dens boks forlader viewporten, så
       baren kom først ved scrollY ca. 1.500, mens Clarity måler 59 % scrolldybde.
       Målt med getBoundingClientRect ved scroll frem for IntersectionObserver:
       betingelsen er «bunden af farvevalget over barens overkant», og den
       grænse flytter sig med barens højde. */
    /* ---------- Cookiebanneret må ikke dække købsknapperne (Website #62, 03-11-2026) ----------
       Målt 03-11: Shopifys banner (#shopify-pc__banner, z-index 2.000.000, fixed i bunden) lå
       over «Køb nu» og «Til kassen» på mobil, og et tryk ramte banneret (0 cart/add). Banneret
       er Shopifys og kan ikke flyttes fra vores kode, så vi MÅLER dets højde og lader siden vige:
       --pc-h på <html> er bannerets højde i px (0 når der intet banner er). Den klæbende købsbar
       løftes over banneret, modalen får bundluft svarende til det, og siden får bundpolstring,
       så den rigtige knap kan rulles op over banneret. Virker for begge bannerudgaver (kompakt
       bundark og kort), fordi den måler i stedet for at gætte. */
    (function () {
      var root = document.documentElement;
      var watched = null, ro = null, last = -1;
      function measure() {
        var b = document.getElementById('shopify-pc__banner');
        var h = 0;
        if (b && b.isConnected && b.offsetHeight > 0) {
          var cs = window.getComputedStyle(b);
          var r = b.getBoundingClientRect();
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top > window.innerHeight * 0.3 && r.bottom > window.innerHeight - 48) {
            h = Math.ceil(window.innerHeight - r.top);
          }
        }
        if (b !== watched) {
          if (ro) ro.disconnect();
          watched = b;
          if (b && window.ResizeObserver) { ro = new ResizeObserver(measure); ro.observe(b); }
        }
        if (h !== last) {
          last = h;
          root.style.setProperty('--pc-h', h + 'px');
          window.dispatchEvent(new CustomEvent('bycycle:pc-h', { detail: { h: h } }));
        }
      }
      new MutationObserver(measure).observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', measure);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', measure);
      measure();
      /* Banneret fades ind efter første maling: mål igen, til det har sat sig. */
      var tries = 0;
      var iv = setInterval(function () { measure(); if (++tries > 20) clearInterval(iv); }, 500);
    })();

    var stickyBuy = section.querySelector('[data-sticky-buy]');
    var stickyAnchor = section.querySelector('.bike-swatches') || section.querySelector('[data-swatch]');
    var buyBlock = section.querySelector('.bike-cfg__cta-floating');
    if (stickyBuy && stickyAnchor && buyBlock) {
      var stickyMq = window.matchMedia('(max-width: 768px)');
      var stickyQueued = false;
      var syncStickyBuy = function () {
        stickyQueued = false;
        var pcH = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--pc-h')) || 0;
        var vh = window.innerHeight - pcH;
        var barH = stickyBuy.offsetHeight || 68;
        var anchorReached = stickyAnchor.getBoundingClientRect().bottom <= vh - barH;
        var buyRect = buyBlock.getBoundingClientRect();
        /* Med et banner i bunden regnes den rigtige knap først for «nær», når den står frit OVER banneret;
           ellers gemte baren sig netop når knappen lå under banneret (Website #62). */
        var buyNear = buyRect.top < vh + (pcH > 0 ? -40 : 96) && buyRect.bottom > 0;
        var show = stickyMq.matches && anchorReached && !buyNear;
        if (show === stickyBuy.classList.contains('is-visible')) return;
        stickyBuy.classList.toggle('is-visible', show);
        stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) { stickyBuy.removeAttribute('inert'); } else { stickyBuy.setAttribute('inert', ''); }
      };
      var queueStickyBuy = function () {
        if (stickyQueued) return;
        stickyQueued = true;
        requestAnimationFrame(syncStickyBuy);
      };
      window.addEventListener('scroll', queueStickyBuy, { passive: true });
      window.addEventListener('resize', queueStickyBuy);
      window.addEventListener('bycycle:pc-h', queueStickyBuy);
      if (stickyMq.addEventListener) stickyMq.addEventListener('change', queueStickyBuy);
      queueStickyBuy();

      /* Ingen ny kurv-sti: baren trykker på den rigtige købsknap, så formularen,
         tilbehøret, farvematchen og forudbestillingsmodalen kører uændret. */
      var stickyBuyBtn = stickyBuy.querySelector('[data-sticky-buy-btn]');
      if (stickyBuyBtn && addBtn) {
        stickyBuyBtn.addEventListener('click', function () {
          if (!addBtn.disabled) addBtn.click();
        });
      }
    }

    /* Position the carrier thumb on initial render + when the layout reflows. */
    if (typeof positionCarrierThumb === 'function') {
      positionCarrierThumb();
      window.addEventListener('resize', positionCarrierThumb);
    }

    /* Pris-tælleren arms efter init, så forvalgt bærer og ?build= er regnet med
       (restore-blokken kører i sin egen requestAnimationFrame, før denne). */
    requestAnimationFrame(armPriceIntro);

    /* Animate cert-pill checkmarks when each pill enters the viewport. */
    var pills = section.querySelectorAll('[data-pill]');
    if (pills.length > 0 && 'IntersectionObserver' in window) {
      var pillObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            pillObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -10% 0px' });
      pills.forEach(function (pill) { pillObserver.observe(pill); });
    } else {
      pills.forEach(function (pill) { pill.classList.add('is-visible'); });
    }
  }

  /* Pris-tælleren: prisfladerne vises når init har malet dem (bike-price-await
     sættes inline i markup'en). rAF registreres efter init, så den kører efter
     armPriceIntro i samme frame, og også hvis init returnerer tidligt. */
  function bootBikeConfigurator() {
    try { initBikeConfigurator(); } finally {
      requestAnimationFrame(function () { document.documentElement.classList.remove('bike-price-await', 'bike-offer-await'); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBikeConfigurator);
  } else {
    bootBikeConfigurator();
  }

  /* ─── Weekly price-rise countdown ───
     Computes "next Monday 03:00 Copenhagen" in the visitor's local clock
     (DST-aware via Intl) and updates the [data-price-timer-value] every
     second so the seconds visibly tick — spelled-out, localised units
     (e.g. "4 dage 15 timer 58 min 12 sek"). Pauses while the tab is
     hidden to stop burning CPU in background tabs. */
  (function () {
    var timers = document.querySelectorAll('[data-price-timer]');
    if (!timers.length) return;

    /* Localised compact unit labels — [singular, plural] for day/hour; min/sec are
       invariant. Rendered into data-timer-units by Liquid (DA vs default/EN). */
    var U = { d: ['d', 'd'], h: ['h', 'h'], m: 'min', s: 'sec' };
    try {
      var rawUnits = timers[0].getAttribute('data-timer-units');
      if (rawUnits) {
        var pu = JSON.parse(rawUnits);
        U = { d: pu.d || U.d, h: pu.h || U.h, m: pu.m || U.m, s: pu.s || U.s };
      }
    } catch (e) { /* keep defaults */ }
    function unitLabel(n, u) { return n + ' ' + (u && u.push ? (n === 1 ? u[0] : u[1]) : u); }

    function nextMonday03Copenhagen() {
      var now = new Date();
      var cphNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
      var offset = now.getTime() - cphNow.getTime();
      var target = new Date(cphNow);
      target.setHours(3, 0, 0, 0);
      var daysToMon = (1 - target.getDay() + 7) % 7;
      if (daysToMon === 0 && target.getTime() <= cphNow.getTime()) daysToMon = 7;
      target.setDate(target.getDate() + daysToMon);
      return new Date(target.getTime() + offset);
    }

    /* Spelled-out, live countdown: e.g. "4 dage 15 timer 58 min 12 sek".
       Minutes + seconds always shown (and seconds always tick) — hours appear
       once there's an hour or more, days once there's a day or more. */
    function fmtCountdown(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      var parts = [];
      if (d > 0) parts.push(unitLabel(d, U.d));
      if (d > 0 || h > 0) parts.push(unitLabel(h, U.h));
      parts.push(unitLabel(m, U.m));
      parts.push(unitLabel(sec, U.s));
      return parts.join(' ');
    }

    var timerId = null;

    function tick() {
      var target = nextMonday03Copenhagen();
      var remaining = target.getTime() - Date.now();
      var label = remaining > 0 ? fmtCountdown(remaining) : ' - ';
      timers.forEach(function (el) {
        var val = el.querySelector('[data-price-timer-value]');
        if (val && val.textContent !== label) val.textContent = label;
      });
      /* Tick every second whenever time remains — the live seconds are the
         credibility cue; the visibilitychange handler pauses it in hidden tabs. */
      var nextDelay = remaining > 0 ? 1000 : 60000;
      schedule(nextDelay);
    }

    function schedule(delay) {
      if (document.hidden) return; /* resumed by visibilitychange */
      clearTimeout(timerId);
      timerId = setTimeout(tick, delay);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timerId);
      } else {
        tick(); /* immediate refresh on return, then re-schedules itself */
      }
    });

    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bike-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bike-showcase]').forEach(function (root) {
      var stage = root.querySelector('[data-bs-stage]');
      var track = root.querySelector('[data-bs-track]');
      if (!stage || !track) return;

      // Carrier A is the default; a colour + carrier are always selected.
      var state = { color: 'a', carrier: 'a' };

      // Hero image per colour×carrier combo (server-rendered on the section tag).
      var hero = {
        'a-a': root.dataset.srcAA,
        'a-b': root.dataset.srcAB,
        'a-none': root.dataset.srcANone,
        'b-a': root.dataset.srcBA,
        'b-b': root.dataset.srcBB,
        'b-none': root.dataset.srcBNone
      };

      // Optional extra gallery photos, tagged with colour + carrier.
      var gallery = [];
      try {
        var gEl = root.querySelector('[data-bs-gallery]');
        if (gEl) gallery = JSON.parse(gEl.textContent || '[]');
      } catch (e) { gallery = []; }

      function heroSrc(color, carrier) {
        var key = color + '-' + carrier;
        if (hero[key]) return hero[key];
        var cf = hero[color + '-a'] || hero[color + '-b'] || hero[color + '-none'];
        if (cf) return cf;
        return hero['a-a'] || hero['a-b'] || hero['a-none'] || hero['b-a'] || hero['b-b'] || hero['b-none'] || '';
      }

      function matches(g, color, carrier) {
        var okC = (g.color === color || g.color === 'any' || !g.color);
        var okK = (g.carrier === carrier || g.carrier === 'any' || !g.carrier);
        return okC && okK;
      }

      function slidesFor(color, carrier) {
        var list = [];
        var h = heroSrc(color, carrier);
        if (h) list.push(h);
        gallery.forEach(function (g) {
          if (g.src && matches(g, color, carrier) && list.indexOf(g.src) === -1) list.push(g.src);
        });
        return list;
      }

      // Preload every source so colour/carrier swaps and the lightbox are instant.
      var seen = {};
      Object.keys(hero).forEach(function (k) { if (hero[k]) seen[hero[k]] = 1; });
      gallery.forEach(function (g) { if (g.src) seen[g.src] = 1; });
      Object.keys(seen).forEach(function (s) { var p = new Image(); p.src = s; });

      /* ---------- main slider ---------- */
      var prevBtn = stage.querySelector('[data-bs-prev]');
      var nextBtn = stage.querySelector('[data-bs-next]');
      var dotsEl = stage.querySelector('[data-bs-dots]');
      var slides = [];
      var index = 0;

      function makeDots(container, count, active, onClick) {
        container.innerHTML = '';
        if (count < 2) { container.hidden = true; return; }
        container.hidden = false;
        for (var i = 0; i < count; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'bike-showcase__dot' + (i === active ? ' is-active' : '');
            d.setAttribute('aria-label', (container.getAttribute('data-dot-label') || 'Go to photo %n').replace('%n', i + 1));
            d.addEventListener('click', function () { onClick(i); });
            container.appendChild(d);
          })(i);
        }
      }

      function setDot(container, active) {
        if (!container) return;
        var kids = container.children;
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === active);
      }

      function buildTrack() {
        slides = slidesFor(state.color, state.carrier);
        track.innerHTML = '';
        slides.forEach(function (src, i) {
          var slide = document.createElement('div');
          slide.className = 'bike-showcase__slide';
          var im = document.createElement('img');
          im.className = 'bike-showcase__img';
          im.src = src;
          im.alt = 'Bycycle City U';
          im.loading = i === 0 ? 'eager' : 'lazy';
          im.decoding = 'async';
          if (i === 0) im.setAttribute('data-bike-showcase-img', '');
          slide.appendChild(im);
          track.appendChild(slide);
        });
        index = 0;
        track.scrollLeft = 0;
        var multi = slides.length > 1;
        if (prevBtn) prevBtn.hidden = !multi;
        if (nextBtn) nextBtn.hidden = !multi;
        if (dotsEl) makeDots(dotsEl, slides.length, 0, goTo);
      }

      var bsReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function bsPreload(arr) { arr.forEach(function (u) { var im = new Image(); im.src = u; }); }

      /* Smooth crossfade on colour/carrier change — mirrors bike-gallery:
         fade the current photo out, decode the new lead image (no half-loaded pop),
         rebuild while hidden, then fade back in. Honours reduced-motion; falls back to
         an instant rebuild where animation isn't possible. */
      function swapCombo() {
        var next = slidesFor(state.color, state.carrier);
        if (!next.length || !track || bsReduceMotion || typeof Promise === 'undefined') {
          buildTrack();
          return;
        }
        bsPreload(next);
        track.classList.add('is-swapping');
        var lead = new Image();
        lead.src = next[0];
        var decoded = lead.decode
          ? lead.decode().catch(function () {})
          : new Promise(function (res) { lead.onload = res; lead.onerror = res; });
        var faded = new Promise(function (res) { setTimeout(res, 200); });
        Promise.all([decoded, faded]).then(function () {
          buildTrack();
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { track.classList.remove('is-swapping'); });
          });
        });
      }

      function goTo(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        setDot(dotsEl, index);
      }

      var scrollTid;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTid);
        scrollTid = window.setTimeout(function () {
          index = Math.round(track.scrollLeft / (track.clientWidth || 1));
          setDot(dotsEl, index);
        }, 60);
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

      /* ---------- colour / carrier controls ---------- */
      function positionThumb(seg) {
        var active = seg.querySelector('.bike-showcase-ctl__opt.is-active');
        if (!active) return;
        var segRect = seg.getBoundingClientRect();
        var optRect = active.getBoundingClientRect();
        seg.style.setProperty('--thumb-x', (optRect.left - segRect.left) + 'px');
        seg.style.setProperty('--thumb-w', optRect.width + 'px');
      }

      function setActive(group, value) {
        root.querySelectorAll('[data-showcase-' + group + ']').forEach(function (btn) {
          var on = btn.getAttribute('data-showcase-' + group) === value;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        requestAnimationFrame(function () {
          root.querySelectorAll('[data-showcase-seg="' + group + '"]').forEach(positionThumb);
        });
      }

      function wireGroup(group) {
        root.querySelectorAll('[data-showcase-' + group + ']').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var value = btn.getAttribute('data-showcase-' + group);
            if (state[group] === value) return;
            state[group] = value;
            setActive(group, value);
            swapCombo();
          });
        });
      }
      wireGroup('color');
      wireGroup('carrier');

      /* ---------- expand-to-inspect lightbox ---------- */
      var lb = root.querySelector('[data-bs-lightbox]');
      var lbTrack = root.querySelector('[data-bs-lb-track]');
      var lbDots = root.querySelector('[data-bs-lb-dots]');
      var lbPrev = root.querySelector('[data-bs-lb-prev]');
      var lbNext = root.querySelector('[data-bs-lb-next]');
      var lbClose = root.querySelector('[data-bs-close]');
      var expandBtn = stage.querySelector('[data-bs-expand]');
      var lbIndex = 0;

      function buildLb(start) {
        if (!lb || !lbTrack) return;
        lbTrack.innerHTML = '';
        slides.forEach(function (src) {
          var s = document.createElement('div');
          s.className = 'bike-showcase__lb-slide';
          var im = document.createElement('img');
          im.src = src;
          im.alt = 'Bycycle City U - enlarged';
          im.decoding = 'async';
          s.appendChild(im);
          lbTrack.appendChild(s);
        });
        var multi = slides.length > 1;
        if (lbPrev) lbPrev.hidden = !multi;
        if (lbNext) lbNext.hidden = !multi;
        if (lbDots) makeDots(lbDots, slides.length, start, lbGoTo);
        lbIndex = start;
        requestAnimationFrame(function () { lbTrack.scrollLeft = lbTrack.clientWidth * start; });
      }

      function lbGoTo(i) {
        lbIndex = Math.max(0, Math.min(slides.length - 1, i));
        lbTrack.scrollTo({ left: lbTrack.clientWidth * lbIndex, behavior: 'smooth' });
        setDot(lbDots, lbIndex);
      }

      var lbScrollTid;
      if (lbTrack) lbTrack.addEventListener('scroll', function () {
        window.clearTimeout(lbScrollTid);
        lbScrollTid = window.setTimeout(function () {
          lbIndex = Math.round(lbTrack.scrollLeft / (lbTrack.clientWidth || 1));
          setDot(lbDots, lbIndex);
        }, 60);
      }, { passive: true });

      function openLb() {
        if (!lb) return;
        buildLb(index);
        lb.hidden = false;
        lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () { lb.classList.add('is-open'); });
      }
      function closeLb() {
        if (!lb) return;
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        window.setTimeout(function () { lb.hidden = true; }, 260);
      }

      if (expandBtn) expandBtn.addEventListener('click', openLb);
      track.addEventListener('click', function (e) {
        if (e.target.closest('.bike-showcase__img')) openLb();
      });
      if (lbClose) lbClose.addEventListener('click', closeLb);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbGoTo(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGoTo(lbIndex + 1); });
      if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') lbGoTo(lbIndex - 1);
        else if (e.key === 'ArrowRight') lbGoTo(lbIndex + 1);
      });

      /* ---------- feature spec sheet (mirrors the specs section) ---------- */
      var sheet = root.querySelector('[data-bs-sheet]');
      var sheetPanel = root.querySelector('[data-bs-sheet-panel]');
      var sheetImg = root.querySelector('[data-bs-sheet-img]');
      var sheetImgWrap = sheetImg ? sheetImg.closest('.bs-sheet__imgwrap') : null;
      var sheetIcon = root.querySelector('[data-bs-sheet-icon]');
      var sheetLabel = root.querySelector('[data-bs-sheet-label]');
      var sheetDesc = root.querySelector('[data-bs-sheet-desc]');

      function openSheet(btn) {
        if (!sheet) return;
        var label = btn.getAttribute('data-feat-label') || '';
        var desc = btn.getAttribute('data-feat-desc') || '';
        var img = btn.getAttribute('data-feat-img') || '';
        var icon = btn.getAttribute('data-feat-icon') || '';
        if (sheetImg && sheetImgWrap) {
          if (img) { sheetImg.src = img; sheetImg.alt = label; sheetImgWrap.classList.remove('is-empty'); }
          else { sheetImg.removeAttribute('src'); sheetImgWrap.classList.add('is-empty'); }
        }
        if (sheetIcon) sheetIcon.innerHTML = icon ? '<img src="' + icon + '" alt="" width="30" height="30">' : '';
        if (sheetLabel) sheetLabel.textContent = label;
        if (sheetDesc) sheetDesc.textContent = desc;
        sheet.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeSheet() {
        if (!sheet) return;
        sheet.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      root.querySelectorAll('[data-feat-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { openSheet(btn); });
      });
      root.querySelectorAll('[data-bs-sheet-close]').forEach(function (el) {
        el.addEventListener('click', closeSheet);
      });
      document.addEventListener('keydown', function (e) {
        if (sheet && sheet.getAttribute('aria-hidden') === 'false' && e.key === 'Escape') closeSheet();
      });

      // Swipe the bottom sheet down to dismiss (only when scrolled to top).
      if (sheetPanel) {
        var sy0 = 0, sy = 0, swiping = false;
        sheetPanel.addEventListener('touchstart', function (e) {
          if (sheetPanel.scrollTop > 0) { swiping = false; return; }
          sy0 = e.touches[0].clientY; sy = sy0; swiping = true;
          sheetPanel.style.transition = 'none';
        }, { passive: true });
        sheetPanel.addEventListener('touchmove', function (e) {
          if (!swiping) return;
          sy = e.touches[0].clientY;
          var dy = sy - sy0;
          if (dy > 0) sheetPanel.style.transform = 'translateY(' + dy + 'px)';
        }, { passive: true });
        sheetPanel.addEventListener('touchend', function () {
          if (!swiping) return;
          swiping = false;
          var dy = sy - sy0;
          sheetPanel.style.transition = '';
          sheetPanel.style.transform = '';
          if (dy > 90) closeSheet();
        });
      }

      /* ---------- feature grid: cinematic staggered reveal ---------- */
      var featuresEl = root.querySelector('[data-bs-features]');
      if (featuresEl) {
        featuresEl.classList.add('reveal-ready');
        if ('IntersectionObserver' in window) {
          var fio = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { featuresEl.classList.add('is-in'); fio.disconnect(); }
            });
          }, { threshold: 0.2 });
          fio.observe(featuresEl);
        } else {
          featuresEl.classList.add('is-in');
        }
      }

      /* ---------- init ---------- */
      buildTrack();

      function initThumbs() {
        requestAnimationFrame(function () {
          root.querySelectorAll('[data-showcase-seg]').forEach(positionThumb);
        });
      }
      initThumbs();
      window.addEventListener('load', initThumbs);
      window.addEventListener('resize', function () {
        initThumbs();
        track.scrollLeft = track.clientWidth * index;
      });

      // Cinematic reveal — arm the hidden state, then play it when in view.
      root.classList.add('reveal-ready');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
          });
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    /* Preserve current query params (preview_theme_id, sort, etc.) when
       jumping between category filters. Otherwise the preview drops out. */
    var chips = document.querySelectorAll('.blog-idx__chip');
    if (chips.length) {
      var currentParams = new URLSearchParams(window.location.search);
      chips.forEach(function (chip) {
        if (!chip.getAttribute('href')) return;
        var url = new URL(chip.getAttribute('href'), window.location.origin);
        currentParams.forEach(function (val, key) {
          if (!url.searchParams.has(key)) url.searchParams.set(key, val);
        });
        chip.setAttribute('href', url.pathname + (url.search ? url.search : ''));
      });
    }

    var sortSelect = document.querySelector('[data-blog-sort]');
    var grid = document.querySelector('[data-blog-grid]');
    var hero = document.querySelector('.blog-idx__hero');
    if (!sortSelect || !grid) return;

    function getParam(name) {
      var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
    function setParam(name, value) {
      var url = new URL(window.location.href);
      if (value && value !== 'newest') {
        url.searchParams.set(name, value);
      } else {
        url.searchParams.delete(name);
      }
      window.history.replaceState({}, '', url.toString());
    }
    function applySort(value) {
      var items = Array.prototype.slice.call(grid.children);
      if (value === 'oldest') {
        items.reverse().forEach(function (el) { grid.appendChild(el); });
        if (hero) hero.style.display = 'none';
      } else {
        var sorted = items.slice().sort(function (a, b) {
          return (a.dataset.order || 0) - (b.dataset.order || 0);
        });
        sorted.forEach(function (el) { grid.appendChild(el); });
        if (hero) hero.style.display = '';
      }
    }

    Array.prototype.slice.call(grid.children).forEach(function (el, i) {
      el.dataset.order = i;
    });

    var initial = getParam('sort') === 'oldest' ? 'oldest' : 'newest';
    sortSelect.value = initial;
    if (initial === 'oldest') applySort('oldest');

    sortSelect.addEventListener('change', function () {
      var v = sortSelect.value;
      setParam('sort', v);
      applySort(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-hero"] && !Shopify.designMode) return;
  try {
    
  /* Prisen tæller ned fra førprisen til prisen, én gang, straks ved DOMContentLoaded (prisen står altid over folden, QC 03-11) (som konfiguratorens pris-tæller,
     CONFIGURATOR-STANDARD §13). Prisen står i HTML fra start, så animationen er kun visuel; reduced motion og manglende
     JS viser slutprisen. Aldrig et tal over førprisen, intet overshoot (kubisk ease-out). */
  (function () {
    var row = document.querySelector('[data-bm-hero] [data-bm-count]');
    if (!row) return;
    var show = function () { row.classList.remove('is-await', 'is-counting'); };
    var el = row.querySelector('[data-bm-price]');
    var from = +row.getAttribute('data-from'), to = +row.getAttribute('data-to');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!el || !(from > to) || reduce) { show(); return; }
    var fmt = function (c) { return Math.round(c / 100).toLocaleString('da-DK') + ' kr'; };
    var run = function () {
      var final = el.textContent; /* malet af bm-black-month.js eller Liquid */
      if (!/kr/.test(final)) { show(); return; } /* kun DKK-visningen tælles; EUR o.l. står stille */
      /* Første synlige tal er førprisen: prisen er skjult (is-await) indtil her, så 14.895 aldrig blinker først (QC 03-11). */
      el.textContent = fmt(from);
      row.classList.add('is-counting'); row.classList.remove('is-await');
      var t0 = performance.now(), D = 1400, done = false;
      var finish = function () { if (done) return; done = true; el.textContent = final; show(); };
      var step = function (t) {
        var x = Math.min(1, Math.max(0, (t - t0) / D)), e = 1 - Math.pow(1 - x, 3); /* rAF-tiden kan ligge før t0 */
        if (x < 1 && !done) { el.textContent = fmt(from - (from - to) * e); requestAnimationFrame(step); } else finish();
      };
      requestAnimationFrame(step);
      setTimeout(finish, 2500);
    };
    /* Efter DOMContentLoaded: så har bm-black-month.js (defer, efter dette script) malet prisen, og intet maler oven i tællingen. */
    var started = false, go = function () { if (!started) { started = true; run(); } };
    if (document.readyState === 'complete') go();
    else { document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 0); }); window.addEventListener('load', go); }
  })();

  /* Evolve (04-11-2026): uden → lad → kurv → forfra. Grundbilledet (uden, LCP) står altid fuldt dækkende nederst, så stellet
     aldrig dæmpes under et skift; lad og kurv er gennemsigtige cutouts der toner ind og ud oven på det. Lagene hentes efter
     load og idle, så LCP er uændret. Ét skift ad gangen, pause når heroen er ude af syne eller fanen skjult. Reduced motion:
     lagene hentes aldrig, stillbilledet står. */
  (function () {
    var hero = document.querySelector('[data-bm-hero]');
    if (!hero) return;
    var layers = hero.querySelectorAll('[data-bm-evo]');
    if (layers.length !== 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var HOLD = 4000, MOVE = 1500;
    var cur = 0, timer = null, visible = true, ready = false, busy = false;
    var show = function (n) {
      busy = true;
      var prev = cur ? layers[cur - 1] : null, next = n ? layers[n - 1] : null;
      if (next) { next.classList.remove('is-on', 'is-out'); void next.offsetWidth; next.classList.add('is-in'); }
      if (prev) { prev.classList.remove('is-in', 'is-on'); prev.classList.add('is-out'); }
      cur = n;
      setTimeout(function () {
        if (next) { next.classList.remove('is-in'); next.classList.add('is-on'); }
        if (prev) prev.classList.remove('is-out');
        busy = false; queue();
      }, MOVE + 120);
    };
    var queue = function () {
      clearTimeout(timer);
      if (!ready || !visible || document.hidden || busy) return;
      timer = setTimeout(function () { show((cur + 1) % 3); }, HOLD);
    };
    var load = function () {
      var waits = [];
      layers.forEach(function (im) {
        im.srcset = im.getAttribute('data-srcset'); im.src = im.getAttribute('data-src');
        waits.push(im.decode ? im.decode().catch(function () {}) : new Promise(function (r) { im.onload = im.onerror = r; }));
      });
      Promise.all(waits).then(function () {
        for (var i = 0; i < layers.length; i++) if (!layers[i].complete || !layers[i].naturalWidth) return; /* et lag fejlede: stillbillede */
        ready = true; queue();
      });
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) queue(); else clearTimeout(timer); }).observe(hero);
    }
    document.addEventListener('visibilitychange', queue);
    var start = function () { if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2000 }); else setTimeout(load, 600); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-receipt"] && !Shopify.designMode) return;
  try {
    
  /* Kvitteringen skrives, når den kommer i syne: rækkerne falder på plads én ad gangen, stregerne tegnes over værdierne,
     og «Du betaler» tæller ned fra førprisen én gang. Indholdet står i HTML fra start; uden JS eller med reduced motion
     står det stille og færdigt. Kun transform/opacity, ingen layoutskift. */
  (function () {
    var sec = document.querySelector('[data-bm-receipt]');
    if (!sec || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sec.classList.add('is-armed');
    var pay = sec.querySelector('[data-rc-count]');
    var count = function () {
      if (!pay || !pay.hasAttribute('data-from')) return;
      var final = pay.textContent; if (!/kr/.test(final)) return; /* kun DKK tælles */
      var from = +pay.getAttribute('data-from'), to = +pay.getAttribute('data-to');
      var fmt = function (c) { return Math.round(c / 100).toLocaleString('da-DK') + ' kr'; };
      var t0 = performance.now(), D = 1300;
      var step = function (t) {
        var x = Math.min(1, Math.max(0, (t - t0) / D)), e = 1 - Math.pow(1 - x, 3);
        if (x < 1) { pay.textContent = fmt(from - (from - to) * e); requestAnimationFrame(step); } else pay.textContent = final;
      };
      setTimeout(function () { requestAnimationFrame(step); }, 650);
      setTimeout(function () { pay.textContent = final; }, 2600);
    };
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect(); sec.classList.add('is-in'); count();
    }, { threshold: 0.3 });
    io.observe(sec.querySelector('.bm-rc__paper'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrier-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('[data-ct-pin]');
    var section = document.querySelector('[data-carrier-teaser]');
    if (!wrapper || !section) return;

    var words = section.querySelectorAll('[data-ct-word]');
    var total = words.length;
    var ticking = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) return;

    var isMobile = window.innerWidth <= 768;
    var startInset = isMobile ? 8 : 35;
    var startInsetV = isMobile ? 12 : 30;
    var startInsetB = isMobile ? 4 : 10;
    var startRadius = isMobile ? 24 : 32;

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function smoothstep(edge0, edge1, x) {
      var t = clamp01((x - edge0) / (edge1 - edge0));
      return t * t * (3 - 2 * t);
    }

    function update() {
      ticking = false;
      var wRect = wrapper.getBoundingClientRect();
      var vh = window.innerHeight;
      var scrollRoom = wrapper.offsetHeight - vh;
      var progress = scrollRoom > 0 ? clamp01(-wRect.top / scrollRoom) : 0;

      var expandProg = clamp01(progress / 0.7);
      var inset = startInset * (1 - expandProg);
      var insetV = startInsetV * (1 - expandProg);
      var insetB = startInsetB * (1 - expandProg);
      var radius = startRadius * (1 - expandProg);

      section.style.setProperty('--ct-inset', inset + '%');
      section.style.setProperty('--ct-inset-v', insetV + '%');
      section.style.setProperty('--ct-inset-b', insetB + '%');
      section.style.setProperty('--ct-radius', radius + 'px');

      var sideO = 1 - clamp01(expandProg / 0.5);
      section.style.setProperty('--ct-side-o', sideO.toFixed(3));

      var overlayO = clamp01((expandProg - 0.6) / 0.4);
      section.style.setProperty('--ct-overlay-o', overlayO.toFixed(3));

      var textRaw = clamp01((progress - 0.75) / 0.25);
      var spread = 0.72;
      var wordWindow = 1 - spread;

      for (var i = 0; i < total; i++) {
        var wordStart = (i / total) * spread;
        var wordEnd = wordStart + wordWindow;
        var wp = smoothstep(wordStart, wordEnd, textRaw);

        words[i].style.setProperty('--word-o', wp.toFixed(3));
        words[i].style.setProperty('--word-blur', ((1 - wp) * 4).toFixed(1) + 'px');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      isMobile = window.innerWidth <= 768;
      startInset = isMobile ? 8 : 35;
      startInsetV = isMobile ? 12 : 30;
      startInsetB = isMobile ? 4 : 10;
      startRadius = isMobile ? 24 : 32;
      onScroll();
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var items = document.getElementById('cart-page-items');
    if (!items) return;
    var busy = false;
    function change(key, qty) {
      if (busy) return; busy = true;
      items.style.opacity = '0.5'; items.style.pointerEvents = 'none';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { busy = false; items.style.opacity = ''; items.style.pointerEvents = ''; });
    }
    items.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]'); if (!btn) return;
      var line = btn.closest('[data-key]'); if (!line) return;
      var key = line.getAttribute('data-key');
      var action = btn.getAttribute('data-action');
      var valEl = line.querySelector('.cart-page__qty-value');
      var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
      if (action === 'increase') change(key, cur + 1);
      else if (action === 'decrease') change(key, Math.max(0, cur - 1));
      else if (action === 'remove') change(key, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-collection]');
    if (!root) return;
    var bar = root.querySelector('[data-filter-bar]');
    var cards = root.querySelectorAll('.acoll__card');
    if (!bar || !cards.length) return;
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('.acoll__chip');
      if (!chip) return;
      var filter = chip.getAttribute('data-filter');
      bar.querySelectorAll('.acoll__chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        var show = (filter === 'all') || (card.getAttribute('data-category') === filter);
        card.style.display = show ? '' : 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["commute-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-commute-calculator]');
    if (!root) return;
    var cfgEl = root.querySelector('[data-calc-config]');
    if (!cfgEl) return;

    var CONFIG;
    try { CONFIG = JSON.parse(cfgEl.textContent); }
    catch (e) { return; }

    // Localised strings for JS-built output (see [data-calc-i18n]); {tokens} are filled per result.
    var I18N = {};
    var i18nEl = root.querySelector('[data-calc-i18n]');
    if (i18nEl) { try { I18N = JSON.parse(i18nEl.textContent); } catch (e) { I18N = {}; } }
    function tpl(s, map) { return (s || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }

    var fmt0 = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 });
    var fmt2 = new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmtH = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 1 });
    function kr(n)  { return fmt0.format(Math.round(n)) + ' kr'; }
    function kr2(n) { return fmt2.format(n) + ' kr'; }
    function km(n)  { return fmt0.format(Math.round(n)) + ' km'; }
    function dur(m) { return m >= 90 ? (fmtH.format(m / 60) + ' h') : (fmt0.format(Math.round(m)) + ' min'); }

    function getPath(obj, path) { return path.split('.').reduce(function (o, k) { return (o == null) ? undefined : o[k]; }, obj); }
    function setPath(obj, path, val) {
      var ks = path.split('.'), last = ks.pop();
      var t = ks.reduce(function (o, k) { if (o[k] == null || typeof o[k] !== 'object') o[k] = {}; return o[k]; }, obj);
      t[last] = val;
    }
    function num(v) { var n = parseFloat(v); return (isNaN(n) || n < 0) ? 0 : n; }

    var inputs = root.querySelectorAll('[data-input]');

    // Seed inputs from CONFIG so UI and config never drift.
    inputs.forEach(function (el) {
      var v = getPath(CONFIG, el.getAttribute('data-input'));
      if (v == null) return;
      if (el.type === 'checkbox') el.checked = !!v;
      else if (el.value === '') el.value = v;
    });

    function readState() {
      var s = JSON.parse(JSON.stringify(CONFIG));
      inputs.forEach(function (el) {
        var path = el.getAttribute('data-input');
        if (el.type === 'checkbox') setPath(s, path, el.checked);
        else setPath(s, path, num(el.value));
      });
      return s;
    }

    function compute(s) {
      var dist = s.commute.distanceEachWay * 2 * s.commute.daysPerWeek * s.commute.weeksPerMonth;
      var fullCharge = s.bycycle.batterySize * s.bycycle.electricityPrice;
      var charging = s.bycycle.rangePerCharge > 0 ? (dist / s.bycycle.rangePerCharge) * fullCharge : 0;
      var bikeCost = s.bycycle.ownershipMonths > 0 ? s.bycycle.bikePrice / s.bycycle.ownershipMonths : 0;
      var bycycle = bikeCost + charging + s.bycycle.maintenancePerMonth;

      var petrolFuel = s.petrol.fuelPerKm * dist;
      var electricCharge = s.electric.chargePerKm * dist;
      var petrol   = s.petrol.ownershipPerMonth   + petrolFuel     + s.petrol.parkingPerMonth;
      var electric = s.electric.ownershipPerMonth + electricCharge + s.electric.parkingPerMonth;
      var pub      = s.public.passPrice;
      var costPer100 = s.bycycle.rangePerCharge > 0 ? (fullCharge / s.bycycle.rangePerCharge) * 100 : 0;

      // time saved vs a car in the city (per one-way trip)
      var d1 = s.commute.distanceEachWay;
      var bikeMin = s.time.bikeSpeed > 0 ? (d1 / s.time.bikeSpeed) * 60 : 0;
      var carMin  = (s.time.carCitySpeed > 0 ? (d1 / s.time.carCitySpeed) * 60 : 0) + s.time.parkingOverheadMin;
      var savedTrip = Math.max(0, carMin - bikeMin);
      var savedDay = savedTrip * 2;
      var savedWeekMin = savedDay * s.commute.daysPerWeek;
      var savedYearMin = savedWeekMin * s.commute.weeksPerMonth * 12;

      var min = Math.min(bycycle, petrol, electric, pub);
      return {
        dist: dist, fullCharge: fullCharge, costPer100: costPer100,
        bycycle: bycycle, petrol: petrol, electric: electric, public: pub,
        cheapest: bycycle <= min + 0.5,
        savedTrip: savedTrip, savedDay: savedDay, savedWeekMin: savedWeekMin, savedYearMin: savedYearMin,
        byBike: bikeCost, byCharge: charging, byMaint: s.bycycle.maintenancePerMonth,
        peOwn: s.petrol.ownershipPerMonth, peFuel: petrolFuel, pePark: s.petrol.parkingPerMonth,
        elOwn: s.electric.ownershipPerMonth, elCharge: electricCharge, elPark: s.electric.parkingPerMonth,
        puPass: pub,
        maintFlags: { petrol: s.petrol.maintenanceIncluded, electric: s.electric.maintenanceIncluded }
      };
    }

    function out(key, str) { var el = root.querySelector('[data-output="' + key + '"]'); if (el) el.textContent = str; }

    var NOT_INCLUDED = root.getAttribute('data-not-included') || 'Not included';
    function setPark(m, val) {
      var el = root.querySelector('[data-output="' + m + 'Parking"]');
      var row = root.querySelector('[data-parking="' + m + '"]');
      if (val > 0) { if (el) el.textContent = kr(val); if (row) row.classList.remove('is-excluded'); }
      else { if (el) el.textContent = NOT_INCLUDED; if (row) row.classList.add('is-excluded'); }
    }

    function write(r) {
      out('monthlyCommuteDistance', km(r.dist));
      out('fullChargeCost', kr2(r.fullCharge));
      out('costPer100km', kr2(r.costPer100));
      out('bycycleTotal', kr(r.bycycle));
      out('bycycleBike', kr(r.byBike));
      out('bycycleCharge', kr(r.byCharge));
      out('bycycleMaint', kr(r.byMaint));
      out('petrolOwnership', kr(r.peOwn));
      out('petrolFuel', kr(r.peFuel));
      out('electricOwnership', kr(r.elOwn));
      out('electricCharge', kr(r.elCharge));
      out('publicPass', kr(r.puPass));
      setPark('petrol', r.pePark);
      setPark('electric', r.elPark);

      // winner headline: cheapest vs the most expensive alternative (usually a car)
      var vsPetrol = r.petrol - r.bycycle;
      out('winnerSave', vsPetrol > 0
        ? tpl(I18N.winnerSaveVs, { month: kr(vsPetrol), year: kr(vsPetrol * 12) })
        : I18N.winnerSaveFlat);

      var badge = root.querySelector('[data-winner-badge]');
      if (badge) badge.hidden = !r.cheapest;

      var modes = { petrol: r.petrol, electric: r.electric, public: r.public };
      Object.keys(modes).forEach(function (m) {
        out(m + 'Total', kr(modes[m]));
        var diff = modes[m] - r.bycycle;
        var diffEl = root.querySelector('[data-output="' + m + 'Diff"]');
        if (diffEl) {
          if (diff > 0) { diffEl.textContent = tpl(I18N.diffMore, { amount: kr(diff) }); diffEl.classList.remove('is-muted'); }
          else if (diff < 0) { diffEl.textContent = tpl(I18N.diffCheaper, { amount: kr(Math.abs(diff)) }); diffEl.classList.add('is-muted'); }
          else { diffEl.textContent = I18N.diffSame; diffEl.classList.add('is-muted'); }
        }
      });

      // maintenance-included footnotes (display only)
      ['petrol', 'electric'].forEach(function (m) {
        var footEl = root.querySelector('[data-foot="' + m + '"]');
        if (footEl) footEl.textContent = r.maintFlags[m] ? I18N.maintIncluded : I18N.maintExcluded;
      });

      // time saved band
      out('tsTrip', dur(r.savedTrip));
      out('tsDay', dur(r.savedDay));
      out('tsWeek', dur(r.savedWeekMin));
      out('tsYear', dur(r.savedYearMin));
      var workdays = r.savedYearMin / 60 / 8;
      out('tsCaption', workdays >= 1
        ? tpl(I18N.tsCaption, { days: fmtH.format(workdays) })
        : I18N.tsCaptionFlat);

      root.classList.toggle('is-empty', r.dist === 0);
    }

    function recalc() { write(compute(readState())); }

    // steppers
    root.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dial = btn.closest('[data-dial]');
        if (!dial) return;
        var input = dial.querySelector('[data-input]');
        if (!input) return;
        var step = parseFloat(input.step) || 1;
        var dir = parseFloat(btn.getAttribute('data-step')) || 1;
        var minA = parseFloat(input.min); var maxA = parseFloat(input.max);
        var v = num(input.value) + dir * step;
        if (!isNaN(maxA)) v = Math.min(v, maxA);
        if (!isNaN(minA)) v = Math.max(v, minA);
        var dec = (String(step).split('.')[1] || '').length;
        input.value = v.toFixed(dec);
        recalc();
      });
    });

    root.addEventListener('input', recalc);
    root.addEventListener('change', recalc);
    recalc();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var topics = document.querySelectorAll('.contact__topic');
    var formWrap = document.getElementById('contact-form-wrap');
    var subjectInput = document.getElementById('ContactForm-subject');
    var topicLabel = document.getElementById('contact-form-topic-label');
    var topicDesc = document.getElementById('contact-form-topic-desc');
    var selectedTopic = null;

    if (!topics.length || !formWrap) return;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function selectTopic(btn) {
      var isSame = selectedTopic === btn;

      // Deselect previous
      if (selectedTopic) selectedTopic.classList.remove('is-selected');

      // If clicking the same one again, close form
      if (isSame) {
        selectedTopic = null;
        formWrap.classList.remove('is-open');
        formWrap.setAttribute('aria-hidden', 'true');
        return;
      }

      selectedTopic = btn;
      btn.classList.add('is-selected');

      // Update subject field and labels
      var subject = btn.getAttribute('data-topic');
      var desc = btn.getAttribute('data-description');
      if (subjectInput) subjectInput.value = subject;
      if (topicLabel) topicLabel.textContent = subject;
      if (topicDesc) topicDesc.textContent = desc;

      // Open form and scroll to it on mobile only
      formWrap.classList.add('is-open');
      formWrap.setAttribute('aria-hidden', 'false');
      if (isMobile()) {
        setTimeout(function() {
          formWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 350);
      }
    }

    topics.forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectTopic(btn);
      });
    });

    // Foerste emne (Forudbestilling & salg) er valgt fra start (Nichlas
    // 02-09-2026) — formularen staar aaben, og et klik krӕver kun de faerreste.
    // Kun paa desktop uden scroll-bivirkning; selectTopic scroller kun paa mobil,
    // og der beholder vi auto-valget men uden scroll (formularen ligger under).
    if (topics[0]) {
      var autoScroll = isMobile;
      isMobile = function() { return false; };   // ingen scroll ved auto-valget
      selectTopic(topics[0]);
      isMobile = autoScroll;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-cancel"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-demo-cancel] [data-state]');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var status = (params.get('status') || '').toLowerCase();
    var city = params.get('city') || '';
    if (status !== 'ok' && status !== 'already') status = 'invalid';
    if (status === 'ok') {
      var bodyEl = root.querySelector('[data-state-block="ok"] [data-body]');
      if (bodyEl) {
        var template = city ? root.dataset.bodyWithCity : root.dataset.bodyNoCity;
        if (template) bodyEl.textContent = template.replace('__CITY__', city);
      }
    }
    root.setAttribute('data-state', status);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["development-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.ds');
  if (!section) return;

  /* ============================================================
     DESKTOP
     ============================================================ */
  var items    = section.querySelectorAll('.ds__item');
  var imgWraps = section.querySelectorAll('.ds__img-wrap');
  var captionEl = section.querySelector('#ds-caption');
  var defaultCaption = captionEl ? captionEl.textContent : '';

  function showSlide(id) {
    imgWraps.forEach(function (w) { w.classList.remove('is-active'); });
    var target = id
      ? section.querySelector('.ds__img-wrap[data-slide="' + id + '"]')
      : null;
    var fallback = section.querySelector('.ds__img-wrap[data-slide="default"]');
    (target || fallback).classList.add('is-active');
  }

  function setCaption(text) {
    if (!captionEl) return;
    captionEl.classList.add('is-fading');
    setTimeout(function () {
      captionEl.textContent = text;
      captionEl.classList.remove('is-fading');
    }, 200);
  }

  // Auto-activate first spec with an image
  var firstWithImg = section.querySelector('.ds__item[data-has-img="true"]');
  if (firstWithImg) {
    firstWithImg.classList.add('is-active');
    showSlide(firstWithImg.getAttribute('data-id'));
    setCaption(firstWithImg.getAttribute('data-label') || defaultCaption);
  }

  // Hover baerer markeringen (Nichlas 01-09-2026): ingen klik-tilstand at
  // vedligeholde — det man peger paa ER det markerede, og markeringen bliver
  // staaende paa det sidst pegede, saa billedet altid matcher en markeret raekke.
  items.forEach(function (item) {
    if (item.getAttribute('data-has-img') !== 'true') return;

    item.addEventListener('mouseenter', function () {
      if (item.classList.contains('is-active')) return;
      items.forEach(function (i) { i.classList.remove('is-active'); });
      item.classList.add('is-active');
      showSlide(item.getAttribute('data-id'));
      setCaption(item.getAttribute('data-label') || defaultCaption);
    });
  });

  /* ============================================================
     MOBILE
     ============================================================ */
  var mobCards   = section.querySelectorAll('.ds__mob-item');
  var mobBgs     = section.querySelectorAll('.ds__mob-bg');
  var mobOverlay = section.querySelector('.ds__mob-overlay');
  var sheet      = section.querySelector('#ds-sheet');
  var sheetPanel = section.querySelector('#ds-sheet-panel');
  var sheetImg   = section.querySelector('#ds-sheet-img');
  var sheetIcon  = section.querySelector('#ds-sheet-icon');
  var sheetLabel = section.querySelector('#ds-sheet-label');
  var sheetDesc  = section.querySelector('#ds-sheet-desc');
  var sheetBg    = section.querySelector('#ds-sheet-backdrop');

  function setMobBg(id) {
    mobBgs.forEach(function (b) { b.classList.remove('is-active'); });
    var target = id
      ? section.querySelector('.ds__mob-bg[data-mob-slide="' + id + '"]')
      : section.querySelector('.ds__mob-bg[data-mob-slide="default"]');
    if (target) target.classList.add('is-active');
  }

  function openSheet(card) {
    var id    = card.getAttribute('data-mob-id');
    var label = card.getAttribute('data-mob-label') || '';
    var img   = card.getAttribute('data-mob-img') || '';

    // Update background
    setMobBg(id);

    // Card states
    mobCards.forEach(function (c) { c.classList.remove('is-active'); });
    card.classList.add('is-active');

    // Sheet image
    if (sheetImg && img) {
      sheetImg.src = img;
      sheetImg.alt = label;
    }

    // Sheet icon — clone from card icon
    if (sheetIcon) {
      var cardIconSvg = card.querySelector('.ds__mob-item-icon svg');
      sheetIcon.innerHTML = cardIconSvg ? cardIconSvg.outerHTML : '';
    }

    // Sheet label
    if (sheetLabel) sheetLabel.textContent = label;
    if (sheetDesc) sheetDesc.textContent = card.getAttribute('data-mob-desc') || '';

    // Open
    if (mobOverlay) mobOverlay.classList.add('sheet-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    sheet.setAttribute('aria-hidden', 'true');
    if (mobOverlay) mobOverlay.classList.remove('sheet-open');
    document.body.style.overflow = '';
    mobCards.forEach(function (c) { c.classList.remove('is-active'); });
    setMobBg(null);
  }

  mobCards.forEach(function (card) {
    if (card.getAttribute('data-has-img') !== 'true') return;
    card.addEventListener('click', function () { openSheet(card); });
  });

  if (sheetBg) {
    sheetBg.addEventListener('click', closeSheet);
  }

  // Swipe down to dismiss
  var touchY0 = 0;
  var touchY1 = 0;
  var isSwiping = false;

  if (sheetPanel) {
    sheetPanel.addEventListener('touchstart', function (e) {
      touchY0 = e.touches[0].clientY;
      touchY1 = touchY0;
      isSwiping = false;
    }, { passive: true });

    sheetPanel.addEventListener('touchmove', function (e) {
      touchY1 = e.touches[0].clientY;
      var dy = touchY1 - touchY0;
      if (dy > 8) {
        isSwiping = true;
        var clamped = Math.max(0, dy);
        sheetPanel.style.transition = 'none';
        sheetPanel.style.transform = 'translateY(' + clamped + 'px)';
      }
    }, { passive: true });

    sheetPanel.addEventListener('touchend', function () {
      sheetPanel.style.transition = '';
      sheetPanel.style.transform = '';

      if (isSwiping && (touchY1 - touchY0) > 80) {
        closeSheet();
      }
      isSwiping = false;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet.getAttribute('aria-hidden') === 'false') {
      closeSheet();
    }
  });

  /* ============================================================
     GEOMETRY — desktop lightbox + mobile dropdown
     ============================================================ */
  var geoLightbox = document.getElementById('ds-geo-lightbox');
  var geoOpen     = document.getElementById('ds-geo-open');
  var geoClose    = document.getElementById('ds-geo-close');
  var geoX        = document.getElementById('ds-geo-x');

  function openGeo() {
    if (!geoLightbox) return;
    geoLightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeGeo() {
    if (!geoLightbox) return;
    geoLightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var geoOpenMob = document.getElementById('ds-geo-open-mob');

  if (geoOpen)    geoOpen.addEventListener('click', openGeo);
  if (geoOpenMob) geoOpenMob.addEventListener('click', openGeo);
  if (geoClose)   geoClose.addEventListener('click', closeGeo);
  if (geoX)       geoX.addEventListener('click', closeGeo);

  // Swipe down to dismiss geometry lightbox (desktop/tablet)
  var geoContent = geoLightbox ? geoLightbox.querySelector('.ds__geo-lightbox-content') : null;
  var geoTouchY0 = 0;
  var geoTouchY1 = 0;
  var geoSwiping = false;

  if (geoContent) {
    geoContent.addEventListener('touchstart', function (e) {
      geoTouchY0 = e.touches[0].clientY;
      geoTouchY1 = geoTouchY0;
      geoSwiping = false;
    }, { passive: true });

    geoContent.addEventListener('touchmove', function (e) {
      geoTouchY1 = e.touches[0].clientY;
      var dy = geoTouchY1 - geoTouchY0;
      if (dy > 8) {
        geoSwiping = true;
        geoContent.style.transition = 'none';
        geoContent.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
      }
    }, { passive: true });

    geoContent.addEventListener('touchend', function () {
      geoContent.style.transition = '';
      geoContent.style.transform = '';
      if (geoSwiping && (geoTouchY1 - geoTouchY0) > 80) {
        closeGeo();
      }
      geoSwiping = false;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && geoLightbox && geoLightbox.getAttribute('aria-hidden') === 'false') {
      closeGeo();
    }
  });

  /* ============================================================
     CATEGORY GROUPS — desktop/tablet accordion + computer-always-open
     ============================================================ */
  var groups = section.querySelectorAll('.ds__group');
  var computerMQ = window.matchMedia('(min-width: 1101px)');

  function setGroupOpen(group, open) {
    group.classList.toggle('is-open', open);
    var h = group.querySelector('.ds__group-hdr');
    if (h) h.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function expandAll() {
    groups.forEach(function (g) { setGroupOpen(g, true); });
  }

  function collapseToFirst() {
    groups.forEach(function (g, i) { setGroupOpen(g, i === 0); });
  }

  // Initial state for computer: all open (markup default is first-only).
  if (computerMQ.matches) expandAll();

  // React to viewport changes (devtools resize, rotation, etc.).
  computerMQ.addEventListener('change', function (e) {
    if (e.matches) expandAll(); else collapseToFirst();
  });

  groups.forEach(function (group) {
    var hdr = group.querySelector('.ds__group-hdr');
    if (!hdr) return;
    hdr.addEventListener('click', function () {
      // On computer the chevron is hidden + cursor is default; the click is a no-op.
      if (computerMQ.matches) return;
      var wasOpen = group.classList.contains('is-open');
      // Tablet: single-open accordion.
      groups.forEach(function (g) { setGroupOpen(g, false); });
      if (!wasOpen) setGroupOpen(group, true);
    });
  });

  /* ============================================================
     MOBILE — accordion on category groups
     ============================================================ */
  var mobGroups = section.querySelectorAll('.ds__mob-group');
  mobGroups.forEach(function (mg) {
    var mhdr = mg.querySelector('.ds__mob-group-hdr');
    if (!mhdr) return;
    mhdr.addEventListener('click', function () {
      var wasOpen = mg.classList.contains('is-open');
      mobGroups.forEach(function (g) {
        g.classList.remove('is-open');
        var h = g.querySelector('.ds__mob-group-hdr');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        mg.classList.add('is-open');
        mhdr.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-faq]');
  if (!root) return;
  var search = root.querySelector('[data-faq-search]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
  var items = Array.prototype.slice.call(root.querySelectorAll('.faq__item'));
  var empty = root.querySelector('[data-faq-empty]');
  var activeCat = 'all';

  function apply() {
    var term = (search.value || '').trim().toLowerCase();
    var shown = 0;
    items.forEach(function (it) {
      var catOk = activeCat === 'all' || it.getAttribute('data-faq-cat') === activeCat;
      var textOk = !term || (it.getAttribute('data-faq-text') || '').indexOf(term) !== -1;
      var visible = catOk && textOk;
      it.hidden = !visible;
      if (!visible) it.open = false;
      if (visible) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      activeCat = tab.getAttribute('data-faq-tab');
      apply();
    });
  });

  if (search) {
    search.addEventListener('input', function () {
      // A live search makes the category filter ambiguous — searching looks across all.
      if (search.value.trim() && activeCat !== 'all') {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-faq-tab') === 'all'); });
        activeCat = 'all';
      }
      apply();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('[data-ff-hero]');
  if (!hero) return;
  var seq = hero.querySelector('.hero-sequence');
  if (seq) {
    requestAnimationFrame(function () {
      seq.classList.add('is-loaded');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-how"] && !Shopify.designMode) return;
  try {
    

(function () {
  var steps = document.querySelector('[data-ff-steps]');
  if (!steps) return;
  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      steps.classList.add('is-visible');
      observer.unobserve(steps);
    }
  }, { threshold: 0.3 });
  observer.observe(steps);
})();

(function () {
  var section = document.querySelector('[data-ff-steps]');
  if (!section) return;
  var root = section.closest('.ff-how') || section;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('ff-how--js');
  var steps = section.querySelectorAll('.ff-how__step');
  var fired = false;
  var observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting || fired) return;
    fired = true;
    steps.forEach(function (step, i) {
      setTimeout(function () { step.classList.add('is-done'); }, 300 + i * 850);
    });
  }, { threshold: 0.35 });
  observer.observe(section);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-magic"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-ff-magic]');
  if (!section) return;
  var reveals = section.querySelectorAll('[data-ffm-reveal]');
  var fired = false;

  function onIntersect(entries) {
    if (!entries[0].isIntersecting || fired) return;
    fired = true;
    reveals.forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-visible'); }, i * 120);
    });
  }

  var observer = new IntersectionObserver(onIntersect, { threshold: 0.3 });
  observer.observe(section.querySelector('.ff-magic__content'));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixflow"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-fixflow]');
  if (!section) return;
  section.classList.add('fixflow--js');

  var reveals = section.querySelectorAll('[data-ff-reveal]');
  var steps = section.querySelectorAll('[data-ff-step]');
  var tracks = section.querySelectorAll('[data-ff-track]');
  var panel = section.querySelector('[data-ff-panel]');
  var cta = section.querySelector('[data-ff-cta]');
  var fired = false;

  function runSequence() {
    if (fired) return;
    fired = true;

    reveals.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add('is-visible');
      }, i * 120);
    });

    var headerDelay = reveals.length * 120 + 400;

    for (var i = 0; i < steps.length; i++) {
      (function (idx) {
        var stepDelay = headerDelay + idx * 850;

        setTimeout(function () {
          steps[idx].classList.add('is-done');
        }, stepDelay);

        if (tracks[idx]) {
          setTimeout(function () {
            tracks[idx].classList.add('is-filled');
          }, stepDelay + 400);
        }
      })(i);
    }

    var doneDelay = headerDelay + steps.length * 850;

    if (panel) {
      setTimeout(function () {
        panel.classList.add('is-lit');
      }, doneDelay + 250);
    }

    if (cta) {
      setTimeout(function () {
        cta.classList.add('is-visible');
      }, doneDelay + 400);
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) runSequence();
  }, { threshold: 0.5 });

  observer.observe(section.querySelector('.fixflow__content'));

  var bg = section.querySelector('[data-ff-parallax]');
  if (bg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    var parallax = function () {
      ticking = false;
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var progress = (vh - r.top) / (vh + r.height);
      var shift = (progress - 0.5) * r.height * 0.24;
      bg.style.transform = 'translateY(' + shift.toFixed(1) + 'px)';
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    parallax();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    // Back to top
    var btn = document.querySelector('.back-to-top');
    if (btn) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 400) {
          btn.classList.add('is-visible');
        } else {
          btn.classList.remove('is-visible');
        }
      }, { passive: true });
      btn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  })();

  (function() {
    var container = document.getElementById('footer-klaviyo-signup');
    if (!container) return;
    var apiKey = container.getAttribute('data-klaviyo-key');
    var listId = container.getAttribute('data-klaviyo-list');
    var emailForm = document.getElementById('footer-email-form');
    var nameStep = document.getElementById('footer-name-step');
    var successEl = document.getElementById('footer-success');
    var errorEl = document.getElementById('footer-error');
    var capturedEmail = '';

    function submitToKlaviyo(firstName) {
      var profileAttrs = { email: capturedEmail };
      if (firstName) profileAttrs.first_name = firstName;
      profileAttrs.properties = { pre_launch: true };

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer signup',
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      });
    }

    function showSuccess() {
      nameStep.setAttribute('hidden', '');
      successEl.removeAttribute('hidden');
      successEl.style.opacity = '0';
      requestAnimationFrame(function() {
        successEl.style.transition = 'opacity 0.5s ease';
        successEl.style.opacity = '1';
      });
    }

    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      capturedEmail = document.getElementById('footer-email').value.trim();
      if (!capturedEmail) return;

      errorEl.setAttribute('hidden', '');
      emailForm.querySelector('button[type="submit"]').disabled = true;

      var transitioned = false;
      function revealNameStep() {
        if (transitioned) return;
        transitioned = true;
        emailForm.setAttribute('hidden', '');
        nameStep.removeAttribute('hidden');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            nameStep.classList.add('is-visible');
            document.getElementById('footer-name-input').focus();
          });
        });
      }

      emailForm.classList.add('is-exiting');
      emailForm.addEventListener('transitionend', function handler(ev) {
        if (ev.propertyName !== 'transform') return;
        emailForm.removeEventListener('transitionend', handler);
        revealNameStep();
      });
      setTimeout(revealNameStep, 700);
    });

    document.getElementById('footer-name-submit').addEventListener('click', function() {
      var firstName = document.getElementById('footer-name-input').value.trim();
      this.disabled = true;
      submitToKlaviyo(firstName).then(function(res) {
        if (res.ok || res.status === 202) showSuccess();
        else throw new Error();
      }).catch(function() { showSuccess(); });
    });

    document.getElementById('footer-name-skip').addEventListener('click', function() {
      this.disabled = true;
      submitToKlaviyo(null).then(function(res) {
        if (res.ok || res.status === 202) showSuccess();
        else throw new Error();
      }).catch(function() { showSuccess(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founders-reservation"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slider = document.querySelector('.founders__slider');
    if (!slider) return;

    var slides    = slider.querySelectorAll('.founders__slide');
    var thumbs    = slider.querySelectorAll('.founders__thumb');
    var prevBtn   = slider.querySelector('.founders__thumb-arrow--prev');
    var nextBtn   = slider.querySelector('.founders__thumb-arrow--next');
    var stage     = slider.querySelector('.founders__stage');
    var pauseBtn  = stage && stage.querySelector('.founders__pause-btn');
    var current   = 0;
    var total     = slides.length;

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    function goTo(index) {
      if (index === current || index < 0 || index >= total) return;

      // Pause any playing video on current slide
      var oldVideo = slides[current].querySelector('video');
      if (oldVideo) {
        oldVideo.pause();
        slides[current].classList.remove('is-playing', 'is-paused');
      }

      slides[current].classList.remove('is-active');
      thumbs[current] && thumbs[current].classList.remove('is-active');

      current = index;
      slides[current].classList.add('is-active');
      thumbs[current] && thumbs[current].classList.add('is-active');

      // Scroll active thumb into view
      thumbs[current] && thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      updateArrows();
    }

    // Thumbnail clicks — match by data-target index
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(parseInt(thumb.getAttribute('data-target'), 10));
      });
    });

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    updateArrows();

    function toggleVideo(slide, video) {
      if (video.paused) {
        var promise = video.play();
        if (promise !== undefined) {
          promise.then(function() {
            slide.classList.add('is-playing');
            slide.classList.remove('is-paused');
          }).catch(function() {});
        } else {
          slide.classList.add('is-playing');
          slide.classList.remove('is-paused');
        }
      } else {
        video.pause();
      }
    }

    slides.forEach(function(slide) {
      var video = slide.querySelector('video');
      if (!video) return;

      slide.addEventListener('click', function(e) {
        if (e.target.closest('.founders__thumbs-wrap') || e.target.closest('.founders__thumb-arrow')) return;
        toggleVideo(slide, video);
      });

      video.addEventListener('pause', function() {
        slide.classList.remove('is-playing');
        slide.classList.add('is-paused');
        if (stage) stage.classList.remove('has-playing');
      });

      video.addEventListener('playing', function() {
        slide.classList.add('is-playing');
        slide.classList.remove('is-paused');
        if (stage) stage.classList.add('has-playing');
      });

      video.addEventListener('ended', function() {
        slide.classList.remove('is-playing', 'is-paused');
        if (stage) stage.classList.remove('has-playing');
      });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var playingVideo = slider.querySelector('.founders__slide.is-playing video');
        if (playingVideo) playingVideo.pause();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-apply"] && !Shopify.designMode) return;
  try {
    
(function() {
  var modal = document.getElementById('fp-apply-modal');
  if (!modal) return;

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('input:not([type="hidden"])');
    if (first) setTimeout(function() { first.focus(); }, 100);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-fp-apply-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal();
      return;
    }
    var closer = e.target.closest('[data-fp-apply-close]');
    if (closer) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  function compileBody(form) {
    var fields = [
      { label: 'Contact name', sel: '[name="contact[name]"]' },
      { label: 'Company name', sel: '[name="contact[company]"]' },
      { label: 'Street', sel: '[name="contact[street]"]' },
      { label: 'City', sel: '[name="contact[city]"]' },
      { label: 'Country', sel: '[name="contact[country]"]' },
      { label: 'Email', sel: '[name="contact[email]"]' },
      { label: 'Phone', sel: '[name="contact[phone]"]' },
      { label: 'Website', sel: '[name="contact[website]"]' },
      { label: 'Package interest', sel: '[name="contact[package_interest]"]' }
    ];
    var lines = ['--- FixFlow Partner Application ---', ''];
    fields.forEach(function(f) {
      var el = form.querySelector(f.sel);
      if (el && el.value) lines.push(f.label + ': ' + el.value);
    });
    var bodyField = form.querySelector('[name="contact[body]"]');
    if (bodyField) bodyField.value = lines.join('\n');
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var card = form.closest('.fp-apply__card') || form.closest('.fp-apply-modal__body');
    if (!card) return;

    compileBody(form);

    var btn = form.querySelector('.fp-apply__submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
    .then(function() {
      form.style.display = 'none';
      var success = card.querySelector('.fp-apply__success');
      if (success) success.removeAttribute('hidden');
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
    });
  }

  var forms = document.querySelectorAll('#FPApplyInline, #FPApplyModal');
  forms.forEach(function(f) { f.addEventListener('submit', handleSubmit); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fp-hero__ctas a[href*="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var hash = this.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') {
        var idx = hash.indexOf('#');
        if (idx === -1) return;
        hash = hash.substring(idx);
      }
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var hamburger = header && header.querySelector('.site-header__hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    var overlay = mobileMenu && mobileMenu.querySelector('.nav-overlay__backdrop');

    // Transparent at top → hides on scroll down → #fafafa on scroll up
    if (header) {
      var lastScrollY = window.scrollY;
      var ticking = false;
      var AT_TOP_THRESHOLD = 80;
      var SCROLL_UP_REVEAL = 60;
      var SCROLL_DOWN_HIDE = 40;  // matching deadband for the hide direction
      var scrollUpAccum = 0;
      var scrollDownAccum = 0;
      var wasScrollingDown = false;

      function updateHeader() {
        var currentScrollY = window.scrollY;
        var atTop = currentScrollY < AT_TOP_THRESHOLD;
        var delta = currentScrollY - lastScrollY;
        var scrollingDown = delta > 0;

        // Reset both accumulators on a real direction change so micro-bounces
        // (touchpad inertia, iOS rubber-band) don't constantly tip the header
        // between is-hidden and is-solid.
        if (scrollingDown !== wasScrollingDown) {
          scrollUpAccum = 0;
          scrollDownAccum = 0;
        }

        if (scrollingDown) {
          scrollDownAccum += delta;
        } else {
          scrollUpAccum += -delta;
        }

        if (atTop) {
          header.classList.remove('is-hidden', 'is-solid');
        } else if (scrollingDown && scrollDownAccum >= SCROLL_DOWN_HIDE) {
          header.classList.add('is-hidden');
          header.classList.remove('is-solid');
        } else if (!scrollingDown && scrollUpAccum >= SCROLL_UP_REVEAL) {
          header.classList.remove('is-hidden');
          header.classList.add('is-solid');
        }

        wasScrollingDown = scrollingDown;
        lastScrollY = currentScrollY;
        ticking = false;
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });

      updateHeader();
    }

    function openMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (hamburger) {
        hamburger.classList.add('is-active');
        hamburger.setAttribute('aria-expanded', 'true');
      }
      if (header) header.classList.add('menu-is-open');
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
      document.documentElement.setAttribute('scroll-lock', '');
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (hamburger) {
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
      if (header) header.classList.remove('menu-is-open');
      document.documentElement.removeAttribute('scroll-lock');
      document.documentElement.style.removeProperty('--scrollbar-width');
    }

    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() {
        if (hamburger.classList.contains('is-active')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    if (overlay) overlay.addEventListener('click', closeMobileMenu);

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMobileMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var hero = document.querySelector('.hero');
    if (!hero) return;

    var video = hero.querySelector('.hero__bg-video');

    var headerShown = false;
    var bodyShown = false;
    function showHeader() {
      if (headerShown) return;
      headerShown = true;
      hero.classList.add('is-header-loaded');
    }
    function showBody() {
      if (bodyShown) return;
      bodyShown = true;
      hero.classList.add('is-loaded');
    }

    // The video is the priority — header fades in once the first frame is
    // ready (loadeddata), body trails 250ms after playback actually starts.
    if (video) {
      // First frame decoded → headline + eyebrow can reveal.
      video.addEventListener('loadeddata', showHeader, { once: true });
      // Video is moving → bring in subline + buttons + USP bar.
      video.addEventListener('playing', function() {
        setTimeout(showBody, 250);
      }, { once: true });

      // Mobile browsers (iOS Safari especially) are strict about autoplay, so
      // we drive it ourselves instead of trusting the attribute alone: force
      // muted, then attempt play on every readiness signal and when the hero
      // enters the viewport. If the browser still blocks it (iOS Low Power Mode
      // disables ALL video autoplay by design), the first tap/click starts it
      // and the poster covers the gap until then.
      var started = false;
      function attemptPlay() {
        if (started) return;
        video.muted = true; // Safari honours the property, not just the attribute
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(function() { started = true; }).catch(function() {});
        }
      }
      ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function(ev) {
        video.addEventListener(ev, attemptPlay);
      });
      attemptPlay();

      // Play once the hero is actually on screen (covers tab-restore / bfcache).
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(e) { if (e.isIntersecting) attemptPlay(); });
        }, { threshold: 0.1 }).observe(video);
      }

      // Last resort: the first real user gesture always unlocks playback on iOS.
      var kick = function() {
        attemptPlay();
        if (started) {
          document.removeEventListener('touchend', kick);
          document.removeEventListener('click', kick);
        }
      };
      document.addEventListener('touchend', kick, { passive: true });
      document.addEventListener('click', kick);

      // Safety fallback: if the video stalls or fails (slow network, blocked
      // autoplay), reveal everything anyway so the page never feels frozen.
      setTimeout(function() {
        showHeader();
        showBody();
      }, 2000);
    } else {
      // No video element at all — reveal immediately.
      requestAnimationFrame(function() {
        setTimeout(function() { showHeader(); showBody(); }, 80);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-grid-2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.lifestyle-grid-2');
    if (!section) return;

    // ---- Header fade-in on scroll ----
    var header = section.querySelector('.lg2__header');
    if (header) {
      var headerObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) header.classList.add('is-visible');
          else header.classList.remove('is-visible');
        });
      }, { threshold: 0.15 });
      headerObs.observe(section);
    }

    var mode = section.getAttribute('data-mode');

    // ---- Colour definitions ----
    var DARK  = [42,  42,  40];
    var LIGHT = [250, 250, 250];
    var WHITE = [255, 255, 255];
    var BLACK = [29,  29,  27];

    var bgFrom, bgTo, textFrom, textTo;

    if (mode === 'light_to_dark') {
      bgFrom = LIGHT; bgTo = DARK; textFrom = BLACK; textTo = WHITE;
    } else if (mode === 'dark_to_light') {
      bgFrom = DARK;  bgTo = LIGHT; textFrom = WHITE; textTo = BLACK;
    } else if (mode === 'static_dark') {
      section.style.backgroundColor = 'rgb(42,42,40)';
      section.style.color = 'rgb(255,255,255)';
      section.classList.add('is-dark');
    }

    // ---- Helpers ----
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function lerp(a, b, t)    { return a + (b - a) * t; }
    function lerpRgb(c1, c2, t) {
      return 'rgb(' +
        Math.round(lerp(c1[0], c2[0], t)) + ',' +
        Math.round(lerp(c1[1], c2[1], t)) + ',' +
        Math.round(lerp(c1[2], c2[2], t)) + ')';
    }

    var eyebrow = section.querySelector('.lg2__eyebrow');
    var subline = section.querySelector('.lg2__subline');

    if (mode === 'static_dark' || mode === 'static_light') {
      // Static — no scroll lerp needed. Fall through to belt setup.
    } else {
      // ---- Scroll colour lerp ----
      var ticking = false;
      var lastProgress = -1;

      var updateColors = function() {
        var rect = section.getBoundingClientRect();
        var vh   = window.innerHeight;
        if (rect.bottom < -vh * 0.25 || rect.top > vh * 1.25) { ticking = false; return; }

        var raw      = (vh - rect.top) / (vh + rect.height);
        var progress = clamp((raw - 0.15) / (0.50 - 0.15), 0, 1);

        if (Math.abs(progress - lastProgress) < 0.002) { ticking = false; return; }
        lastProgress = progress;

        section.style.backgroundColor = lerpRgb(bgFrom, bgTo, progress);
        section.style.color           = lerpRgb(textFrom, textTo, progress);

        // Subline follows the body colour but muted.
        if (subline) {
          var sc = lerpRgb(textFrom, textTo, progress);
          subline.style.color = sc;
          subline.style.opacity = '0.62';
        }

        ticking = false;
      };

      window.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateColors);
      }, { passive: true });

      updateColors();
    }

    // ---- Drag to scrub (with momentum) ----
    var track = section.querySelector('#lg2-track');
    if (!track) return;

    var isDragging   = false;
    var dragIntent   = null;
    var touchStartY  = 0;
    var dragStartX   = 0;
    var dragBaseX    = 0;
    var currentX     = 0;
    var momentumRAF  = null;
    var velHistory   = [];
    var animDuration = 90;

    function getComputedX() {
      var t = window.getComputedStyle(track).transform;
      return (t && t !== 'none') ? new DOMMatrix(t).m41 : 0;
    }

    function applyX(x) {
      track.style.transform = 'translateX(' + x + 'px)';
      currentX = x;
    }

    function handOffToAnimation() {
      var halfWidth = track.scrollWidth / 2;
      var wrapped = ((currentX % halfWidth) + halfWidth) % halfWidth;
      var finalX  = wrapped - halfWidth;
      var delay   = -(Math.abs(finalX) / halfWidth) * animDuration;
      track.style.transform      = '';
      track.style.animationDelay = delay + 's';
      track.classList.remove('is-dragging');
    }

    function cancelMomentum() {
      if (momentumRAF) { cancelAnimationFrame(momentumRAF); momentumRAF = null; }
    }

    function startDrag(clientX) {
      cancelMomentum();
      isDragging = true;
      dragStartX = clientX;
      animDuration = parseFloat(window.getComputedStyle(track).animationDuration) || 90;
      dragBaseX  = track.classList.contains('is-dragging') ? currentX : getComputedX();
      currentX   = dragBaseX;
      velHistory = [{ x: clientX, t: performance.now() }];
      track.classList.add('is-dragging');
      track.style.transform = 'translateX(' + dragBaseX + 'px)';
    }

    function moveDrag(clientX) {
      if (!isDragging) return;
      var now = performance.now();
      velHistory.push({ x: clientX, t: now });
      while (velHistory.length > 1 && now - velHistory[0].t > 80) velHistory.shift();
      applyX(dragBaseX + (clientX - dragStartX));
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;

      var vel = 0;
      if (velHistory.length >= 2) {
        var a = velHistory[0], b = velHistory[velHistory.length - 1];
        var dt = b.t - a.t;
        if (dt > 0) vel = (b.x - a.x) / dt * 16;
      }
      vel = Math.max(-60, Math.min(60, vel));

      var friction = 0.88;
      (function momentum() {
        vel *= friction;
        if (Math.abs(vel) < 0.25) {
          handOffToAnimation();
          momentumRAF = null;
          return;
        }
        applyX(currentX + vel);
        momentumRAF = requestAnimationFrame(momentum);
      })();
    }

    // Mouse
    track.addEventListener('mousedown', function(e) { e.preventDefault(); startDrag(e.clientX); });
    document.addEventListener('mousemove', function(e) { moveDrag(e.clientX); });
    document.addEventListener('mouseup', endDrag);

    // Touch — detect intent before committing to a horizontal drag
    track.addEventListener('touchstart', function(e) {
      dragIntent  = null;
      touchStartY = e.touches[0].clientY;
      dragStartX  = e.touches[0].clientX;
      animDuration = parseFloat(window.getComputedStyle(track).animationDuration) || 90;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - dragStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);

      if (!dragIntent) {
        if (dx < 6 && dy < 6) return;
        dragIntent = dx > dy ? 'horizontal' : 'vertical';
        if (dragIntent === 'horizontal') {
          cancelMomentum();
          isDragging = true;
          dragBaseX  = track.classList.contains('is-dragging') ? currentX : getComputedX();
          currentX   = dragBaseX;
          velHistory = [{ x: e.touches[0].clientX, t: performance.now() }];
          track.classList.add('is-dragging');
          track.style.transform = 'translateX(' + dragBaseX + 'px)';
        }
      }

      if (dragIntent === 'horizontal') {
        e.preventDefault();
        moveDrag(e.touches[0].clientX);
      }
    }, { passive: false });

    track.addEventListener('touchend', function() {
      if (dragIntent === 'horizontal') endDrag();
      else { isDragging = false; dragIntent = null; }
    });

    track.addEventListener('dragstart', function(e) { e.preventDefault(); });

    // ---- Lightbox ----
    var lightbox  = document.getElementById('lg2-lightbox');
    var lbImg     = document.getElementById('lg2-lightbox-img');
    var lbClose   = document.getElementById('lg2-lightbox-close');
    var originSnap = null;
    var closeTimer = null;
    var lbOpen     = false;
    var dragDist   = 0;

    if (!lightbox || !lbImg) return;

    function resetLightbox() {
      lbImg.className = 'lg2__lightbox-img';
      lbImg.removeAttribute('style');
      lbImg.src = '';
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      originSnap = null;
      lbOpen = false;
    }

    function openLightbox(img) {
      if (lbOpen) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      resetLightbox();

      var rect = img.getBoundingClientRect();
      originSnap = { top: rect.top, left: rect.left, width: rect.width, height: rect.height };

      var src = img.src;
      lbImg.src = src.replace(/width=\d+/, 'width=1800');

      lbImg.className = 'lg2__lightbox-img';
      lbImg.style.top    = originSnap.top + 'px';
      lbImg.style.left   = originSnap.left + 'px';
      lbImg.style.width  = originSnap.width + 'px';
      lbImg.style.height = originSnap.height + 'px';
      lbImg.style.borderRadius = '16px';
      lbImg.style.opacity = '1';

      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lbOpen = true;

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (!lbOpen) return;
          lbImg.classList.add('is-animating');

          var natW = img.naturalWidth || 1200;
          var natH = img.naturalHeight || 1500;
          var ratio = natW / natH;
          var maxW = window.innerWidth * 0.9;
          var maxH = window.innerHeight * 0.85;
          var finalW, finalH;
          if (maxW / maxH > ratio) { finalH = maxH; finalW = finalH * ratio; }
          else { finalW = maxW; finalH = finalW / ratio; }

          lbImg.style.top    = ((window.innerHeight - finalH) / 2) + 'px';
          lbImg.style.left   = ((window.innerWidth - finalW) / 2) + 'px';
          lbImg.style.width  = finalW + 'px';
          lbImg.style.height = finalH + 'px';
          lbImg.style.borderRadius = '8px';
        });
      });
    }

    function closeLightbox() {
      if (!lbOpen || !originSnap) return;
      lbOpen = false;

      lbImg.className = 'lg2__lightbox-img is-closing';
      lbImg.style.top    = originSnap.top + 'px';
      lbImg.style.left   = originSnap.left + 'px';
      lbImg.style.width  = originSnap.width + 'px';
      lbImg.style.height = originSnap.height + 'px';
      lbImg.style.borderRadius = '16px';
      lbImg.style.opacity = '0';

      lightbox.classList.remove('is-active');
      document.body.style.overflow = '';

      closeTimer = setTimeout(function() { closeTimer = null; resetLightbox(); }, 500);
    }

    track.addEventListener('mousedown', function() { dragDist = 0; });
    track.addEventListener('mousemove', function() { if (isDragging) dragDist++; });

    track.addEventListener('click', function(e) {
      if (dragDist > 4) return;
      var img = e.target.closest('.lg2__img');
      if (img) openLightbox(img);
    });

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && lbOpen) closeLightbox(); });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.lifestyle-grid');
    if (!section) return;

    // ---- Header fade-in on scroll ----
    var header = section.querySelector('.lg__header');
    if (header) {
      var headerObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            header.classList.add('is-visible');
          } else {
            header.classList.remove('is-visible');
          }
        });
      }, { threshold: 0.15 });
      headerObs.observe(section);
    }

    var mode = section.getAttribute('data-mode');

    // ---- Color definitions ----
    var DARK  = [42,  42,  40];   // slightly lifted from #1D1D1B
    var LIGHT = [250, 250, 250];  // #fafafa
    var WHITE = [255, 255, 255];
    var BLACK = [29,  29,  27];

    var bgFrom, bgTo, textFrom, textTo;

    if (mode === 'light_to_dark') {
      bgFrom = LIGHT; bgTo = DARK; textFrom = BLACK; textTo = WHITE;
    } else if (mode === 'dark_to_light') {
      bgFrom = DARK;  bgTo = LIGHT; textFrom = WHITE; textTo = BLACK;
    } else if (mode === 'static_dark') {
      section.style.backgroundColor = 'rgb(42,42,40)';
      section.style.color = 'rgb(255,255,255)';
    }
    // static_light — nothing to do

    if (mode === 'static_dark' || mode === 'static_light') return;

    // ---- Helpers ----
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
    function lerp(a, b, t)    { return a + (b - a) * t; }
    function lerpRgb(c1, c2, t) {
      return 'rgb(' +
        Math.round(lerp(c1[0], c2[0], t)) + ',' +
        Math.round(lerp(c1[1], c2[1], t)) + ',' +
        Math.round(lerp(c1[2], c2[2], t)) + ')';
    }

    // ---- Eyebrow colour ----
    var eyebrows = section.querySelectorAll('.lg__eyebrow, .lg__callout-label');
    var GREEN  = [153, 255, 207];
    var ORANGE = [180,  75,  10];
    var eyebrowFrom, eyebrowTo;
    if (mode === 'dark_to_light') {
      eyebrowFrom = GREEN; eyebrowTo = ORANGE;
    } else if (mode === 'light_to_dark') {
      eyebrowFrom = ORANGE; eyebrowTo = GREEN;
    }

    // ---- Scroll colour lerp ----
    var ticking = false;

    var lastProgress = -1;

    function updateColors() {
      var rect     = section.getBoundingClientRect();
      var vh       = window.innerHeight;
      // Early-exit when the section is offscreen. Stops the per-frame
      // layout reads + style writes from contributing to scroll jank.
      if (rect.bottom < -vh * 0.25 || rect.top > vh * 1.25) { ticking = false; return; }

      var raw      = (vh - rect.top) / (vh + rect.height);
      var progress = clamp((raw - 0.15) / (0.50 - 0.15), 0, 1);

      // Skip the DOM writes entirely if progress hasn't actually changed
      // enough to matter — saves work on tiny scroll deltas.
      if (Math.abs(progress - lastProgress) < 0.002) { ticking = false; return; }
      lastProgress = progress;

      section.style.backgroundColor = lerpRgb(bgFrom, bgTo, progress);
      section.style.color           = lerpRgb(textFrom, textTo, progress);

      if (eyebrowFrom && eyebrowTo) {
        var c = lerpRgb(eyebrowFrom, eyebrowTo, progress);
        eyebrows.forEach(function(el) { el.style.color = c; });
      }

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateColors);
    }, { passive: true });

    updateColors();

    // ---- Drag to scrub (with momentum) ----
    var track = section.querySelector('#lg-track');
    if (!track) return;

    var isDragging   = false;
    var dragIntent   = null; // 'horizontal' | 'vertical' | null
    var touchStartY  = 0;
    var dragStartX   = 0;
    var dragBaseX    = 0;
    var currentX     = 0;   // live position in px
    var momentumRAF  = null;
    var velHistory   = [];  // [{x, t}] — last 80ms of pointer positions
    var animDuration = 70;  // captured before animation is frozen

    function getComputedX() {
      var t = window.getComputedStyle(track).transform;
      return (t && t !== 'none') ? new DOMMatrix(t).m41 : 0;
    }

    function applyX(x) {
      track.style.transform = 'translateX(' + x + 'px)';
      currentX = x;
    }

    function handOffToAnimation() {
      var halfWidth = track.scrollWidth / 2;
      // Wrap into [-halfWidth, 0)
      var wrapped = ((currentX % halfWidth) + halfWidth) % halfWidth;
      var finalX  = wrapped - halfWidth;
      // Use animDuration captured before animation was frozen — not computed style
      var delay   = -(Math.abs(finalX) / halfWidth) * animDuration;
      track.style.transform      = '';
      track.style.animationDelay = delay + 's';
      track.classList.remove('is-dragging');
    }

    function cancelMomentum() {
      if (momentumRAF) { cancelAnimationFrame(momentumRAF); momentumRAF = null; }
    }

    function startDrag(clientX) {
      cancelMomentum();
      isDragging = true;
      dragStartX = clientX;
      // Read duration before animation is frozen (computed style returns 0 after animation:none)
      animDuration = parseFloat(window.getComputedStyle(track).animationDuration) || 70;
      // Capture visual position before freezing animation
      dragBaseX  = track.classList.contains('is-dragging') ? currentX : getComputedX();
      currentX   = dragBaseX;
      velHistory = [{ x: clientX, t: performance.now() }];
      track.classList.add('is-dragging');
      track.style.transform = 'translateX(' + dragBaseX + 'px)';
    }

    function moveDrag(clientX) {
      if (!isDragging) return;
      var now = performance.now();
      velHistory.push({ x: clientX, t: now });
      // Keep only last 80ms
      while (velHistory.length > 1 && now - velHistory[0].t > 80) velHistory.shift();
      applyX(dragBaseX + (clientX - dragStartX));
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;

      // Compute release velocity (px per 16ms frame)
      var vel = 0;
      if (velHistory.length >= 2) {
        var a = velHistory[0], b = velHistory[velHistory.length - 1];
        var dt = b.t - a.t;
        if (dt > 0) vel = (b.x - a.x) / dt * 16;
      }

      // Clamp to avoid wild flings
      vel = Math.max(-60, Math.min(60, vel));

      var friction = 0.88;

      (function momentum() {
        vel *= friction;
        if (Math.abs(vel) < 0.25) {
          handOffToAnimation();
          momentumRAF = null;
          return;
        }
        applyX(currentX + vel);
        momentumRAF = requestAnimationFrame(momentum);
      })();
    }

    // Mouse
    track.addEventListener('mousedown', function(e) {
      e.preventDefault();
      startDrag(e.clientX);
    });
    document.addEventListener('mousemove', function(e) { moveDrag(e.clientX); });
    document.addEventListener('mouseup', endDrag);

    // Touch — detect intent before committing to horizontal drag
    track.addEventListener('touchstart', function(e) {
      dragIntent  = null;
      touchStartY = e.touches[0].clientY;
      dragStartX  = e.touches[0].clientX;
      animDuration = parseFloat(window.getComputedStyle(track).animationDuration) || 70;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - dragStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);

      if (!dragIntent) {
        // Need at least 6px movement to determine intent
        if (dx < 6 && dy < 6) return;
        dragIntent = dx > dy ? 'horizontal' : 'vertical';
        if (dragIntent === 'horizontal') {
          // Commit to drag from current position
          cancelMomentum();
          isDragging = true;
          dragBaseX  = track.classList.contains('is-dragging') ? currentX : getComputedX();
          currentX   = dragBaseX;
          velHistory = [{ x: e.touches[0].clientX, t: performance.now() }];
          track.classList.add('is-dragging');
          track.style.transform = 'translateX(' + dragBaseX + 'px)';
        }
      }

      if (dragIntent === 'horizontal') {
        e.preventDefault();
        moveDrag(e.touches[0].clientX);
      }
    }, { passive: false });

    track.addEventListener('touchend', function() {
      if (dragIntent === 'horizontal') endDrag();
      else { isDragging = false; dragIntent = null; }
    });

    // Prevent browser image/text drag
    track.addEventListener('dragstart', function(e) { e.preventDefault(); });

    // ---- Lightbox ----
    var lightbox  = document.getElementById('lg-lightbox');
    var lbImg     = document.getElementById('lg-lightbox-img');
    var lbClose   = document.getElementById('lg-lightbox-close');
    var originSnap = null;
    var closeTimer = null;
    var lbOpen     = false;
    var dragDist   = 0;

    if (!lightbox || !lbImg) return;

    function resetLightbox() {
      lbImg.className = 'lg__lightbox-img';
      lbImg.removeAttribute('style');
      lbImg.src = '';
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      originSnap = null;
      lbOpen = false;
    }

    function openLightbox(img) {
      if (lbOpen) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      resetLightbox();

      var rect = img.getBoundingClientRect();
      originSnap = { top: rect.top, left: rect.left, width: rect.width, height: rect.height };

      var src = img.src;
      lbImg.src = src.replace(/width=\d+/, 'width=1800');

      lbImg.className = 'lg__lightbox-img';
      lbImg.style.top    = originSnap.top + 'px';
      lbImg.style.left   = originSnap.left + 'px';
      lbImg.style.width  = originSnap.width + 'px';
      lbImg.style.height = originSnap.height + 'px';
      lbImg.style.borderRadius = '16px';
      lbImg.style.opacity = '1';

      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lbOpen = true;

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (!lbOpen) return;
          lbImg.classList.add('is-animating');

          var natW = img.naturalWidth || 1200;
          var natH = img.naturalHeight || 1600;
          var ratio = natW / natH;
          var maxW = window.innerWidth * 0.9;
          var maxH = window.innerHeight * 0.85;
          var finalW, finalH;
          if (maxW / maxH > ratio) {
            finalH = maxH; finalW = finalH * ratio;
          } else {
            finalW = maxW; finalH = finalW / ratio;
          }

          lbImg.style.top    = ((window.innerHeight - finalH) / 2) + 'px';
          lbImg.style.left   = ((window.innerWidth - finalW) / 2) + 'px';
          lbImg.style.width  = finalW + 'px';
          lbImg.style.height = finalH + 'px';
          lbImg.style.borderRadius = '8px';
        });
      });
    }

    function closeLightbox() {
      if (!lbOpen || !originSnap) return;
      lbOpen = false;

      lbImg.className = 'lg__lightbox-img is-closing';
      lbImg.style.top    = originSnap.top + 'px';
      lbImg.style.left   = originSnap.left + 'px';
      lbImg.style.width  = originSnap.width + 'px';
      lbImg.style.height = originSnap.height + 'px';
      lbImg.style.borderRadius = '16px';
      lbImg.style.opacity = '0';

      lightbox.classList.remove('is-active');
      document.body.style.overflow = '';

      closeTimer = setTimeout(function() {
        closeTimer = null;
        resetLightbox();
      }, 500);
    }

    track.addEventListener('mousedown', function() { dragDist = 0; });
    track.addEventListener('mousemove', function() { if (isDragging) dragDist++; });

    track.addEventListener('click', function(e) {
      if (dragDist > 4) return;
      var img = e.target.closest('.lg__img');
      if (img) openLightbox(img);
    });

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lbOpen) closeLightbox();
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-lifestyle-statement]');
    if (!section) return;

    var media = section.querySelector('[data-ls-media]');
    var words = section.querySelectorAll('[data-ls-word]');
    var total = words.length;
    var ticking = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqMobile = window.matchMedia('(max-width: 768px)');

    if (reducedMotion) return;

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function smoothstep(edge0, edge1, x) {
      var t = clamp01((x - edge0) / (edge1 - edge0));
      return t * t * (3 - 2 * t);
    }

    function update() {
      ticking = false;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      // Early-exit when the section is well outside the viewport. Without this
      // guard the loop below writes ~60 CSS custom properties on every scroll
      // frame across the whole page lifetime — blowing the frame budget and
      // causing visible flicker on the backdrop-filter elements (header,
      // page-nav, founders thumbs) when the compositor drops frames.
      if (rect.bottom < -vh * 0.25 || rect.top > vh * 1.25) return;
      var sH = section.offsetHeight;

      var raw = (vh - rect.top) / (vh + sH);

      /* Parallax — smooth vertical travel (kept within the media over-scan
         so reducing the zoom still never reveals an edge). Disabled on mobile,
         where the media has no over-scan so the 4:5 image shows in full. */
      var pProgress = clamp01(raw);
      if (mqMobile.matches) {
        media.style.transform = 'none';
      } else {
        var shift = (pProgress - 0.5) * -8;
        media.style.transform = 'translate3d(0,' + shift + '%,0)';
      }

      /* In-view class for accent line */
      if (raw > 0.25 && raw < 0.75) {
        section.classList.add('is-in-view');
      } else if (raw >= 0.75) {
        section.classList.remove('is-in-view');
      }

      /* Word reveal — fade in towards center, fully visible at mid-scroll,
         then reverse out as you scroll past. */
      var fadeInStart = 0.28;
      var fadeInEnd = 0.48;
      var holdStart = 0.48;
      var holdEnd = 0.56;
      var fadeOutStart = 0.56;
      var fadeOutEnd = 0.76;
      var spread = 0.72;
      var wordWindow = 1 - spread;

      var visibility;
      if (raw <= fadeInStart) {
        visibility = 0;
      } else if (raw < fadeInEnd) {
        visibility = clamp01((raw - fadeInStart) / (fadeInEnd - fadeInStart));
      } else if (raw <= holdEnd) {
        visibility = 1;
      } else if (raw < fadeOutEnd) {
        visibility = 1 - clamp01((raw - fadeOutStart) / (fadeOutEnd - fadeOutStart));
      } else {
        visibility = 0;
      }

      for (var i = 0; i < total; i++) {
        var wordStart = (i / total) * spread;
        var wordEnd = wordStart + wordWindow;

        var wordIn = smoothstep(wordStart, wordEnd, clamp01((raw - fadeInStart) / (fadeInEnd - fadeInStart)));
        var wordOut = smoothstep(wordStart, wordEnd, clamp01((raw - fadeOutStart) / (fadeOutEnd - fadeOutStart)));

        var o, blur;
        if (raw <= holdEnd) {
          o = wordIn;
          blur = (1 - wordIn) * 4;
        } else {
          o = 1 - wordOut;
          blur = wordOut * 4;
        }

        words[i].style.setProperty('--word-o', o.toFixed(3));
        words[i].style.setProperty('--word-blur', blur.toFixed(1) + 'px');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maintainability-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-maintainability]');
    if (!section) return;

    var stats = section.querySelectorAll('[data-maint-value]');
    if (!stats.length) return;

    var animated = false;

    function animateValue(el, target, duration) {
      var start = 0;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target);
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          stats.forEach(function (el) {
            var target = parseInt(el.getAttribute('data-maint-value'), 10);
            if (!isNaN(target)) {
              animateValue(el, target, 1500);
            } else {
              el.textContent = el.getAttribute('data-maint-value');
            }
          });
          obs.disconnect();
        }
      });
    }, { threshold: 0.3 });

    obs.observe(section.querySelector('[data-maint-stats]'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-page-nav]');
    if (!bar) return;

    /* [data-page-nav-trigger] (Black Month-heroen) går forud for .hero, så baren også kommer frem på sider uden den gamle hero. */
    var trigger = document.querySelector('[data-page-nav-trigger]') || document.querySelector('.hero');
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var pastTrigger = false;
    var footerVisible = false;

    function updateVisibility() {
      if (pastTrigger && !footerVisible) {
        bar.classList.add('is-visible');
        document.body.classList.add('has-page-nav');
      } else {
        bar.classList.remove('is-visible');
        document.body.classList.remove('has-page-nav');
      }
    }

    if (trigger) {
      var triggerObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            pastTrigger = true;
          } else if (entry.isIntersecting) {
            pastTrigger = false;
          }
          updateVisibility();
        });
      }, { threshold: 0 });
      triggerObs.observe(trigger);
    }

    if (footer) {
      var footerObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
          updateVisibility();
        });
      }, { threshold: 0.05 });
      footerObs.observe(footer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-final"]) return;
  try {
    
  (function () {
    var pwPage = document.querySelector('.pw-page--final-only');
    if (!pwPage) return;

    var geoData = {};
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { geoData = d; })
      .catch(function () {});

    function submitToKlaviyo(email, firstName, source, container) {
      var apiKey = container.getAttribute('data-klaviyo-key');
      var listId = container.getAttribute('data-klaviyo-list');
      if (!apiKey || !listId) return Promise.reject(new Error('Klaviyo not configured'));
      var profileAttrs = { email: email };
      if (firstName) profileAttrs.first_name = firstName;
      var props = { pre_launch: true, signup_source: source };
      if (geoData.country_name) props.country = geoData.country_name;
      if (geoData.city) props.city = geoData.city;
      profileAttrs.properties = props;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Password page signup — ' + source,
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    }

    pwPage.querySelectorAll('[data-pw-signup]').forEach(function (container) {
      var source = container.getAttribute('data-pw-signup');
      var form = container.querySelector('[data-pw-email-form]');
      if (!form) return;
      var emailInput = form.querySelector('[data-pw-email-input]');
      var errorEl = container.querySelector('[data-pw-error]');
      var successEl = container.querySelector('[data-pw-success]');
      var successSubEl = container.querySelector('[data-pw-success-sub]');

      function showSuccess() {
        if (form) form.setAttribute('hidden', '');
        if (successEl) {
          successEl.removeAttribute('hidden');
          successEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successEl.style.transition = 'opacity 0.5s ease';
            successEl.style.opacity = '1';
          });
        }
        if (successSubEl) {
          successSubEl.removeAttribute('hidden');
          successSubEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successSubEl.style.transition = 'opacity 0.8s ease 0.3s';
            successSubEl.style.opacity = '1';
          });
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (errorEl) { errorEl.setAttribute('hidden', ''); errorEl.textContent = ''; }
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        submitToKlaviyo(email, null, source, container)
          .then(function (r) { if (r.ok || r.status === 202) showSuccess(); else throw new Error('Request failed'); })
          .catch(function () { showSuccess(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-founders"]) return;
  try {
    
  (function () {
    var pwPage = document.querySelector('.pw-page--founders-only');
    if (!pwPage) return;

    var launchIso = pwPage.getAttribute('data-pw-launch-iso');
    var launchTarget = launchIso ? new Date(launchIso).getTime() : 0;

    var geoData = {};
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { geoData = d; })
      .catch(function () {});

    function submitToKlaviyo(email, firstName, source, container) {
      var apiKey = container.getAttribute('data-klaviyo-key');
      var listId = container.getAttribute('data-klaviyo-list');
      if (!apiKey || !listId) return Promise.reject(new Error('Klaviyo not configured'));
      var profileAttrs = { email: email };
      if (firstName) profileAttrs.first_name = firstName;
      var props = { pre_launch: true, signup_source: source };
      if (geoData.country_name) props.country = geoData.country_name;
      if (geoData.city) props.city = geoData.city;
      profileAttrs.properties = props;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Password page signup — ' + source,
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    }

    pwPage.querySelectorAll('[data-pw-signup]').forEach(function (container) {
      var source = container.getAttribute('data-pw-signup');
      var form = container.querySelector('[data-pw-email-form]');
      if (!form) return;
      var emailInput = form.querySelector('[data-pw-email-input]');
      var errorEl = container.querySelector('[data-pw-error]');
      var nameStep = container.querySelector('[data-pw-name-step]');
      var successEl = container.querySelector('[data-pw-success]');
      var successSubEl = container.querySelector('[data-pw-success-sub]');
      var capturedEmail = '';

      function showSuccess() {
        if (form) form.setAttribute('hidden', '');
        if (nameStep) nameStep.setAttribute('hidden', '');
        if (successEl) {
          successEl.removeAttribute('hidden');
          successEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successEl.style.transition = 'opacity 0.5s ease';
            successEl.style.opacity = '1';
          });
        }
        if (successSubEl) {
          successSubEl.removeAttribute('hidden');
          successSubEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successSubEl.style.transition = 'opacity 0.8s ease 0.3s';
            successSubEl.style.opacity = '1';
          });
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        capturedEmail = (emailInput.value || '').trim();
        if (errorEl) { errorEl.setAttribute('hidden', ''); errorEl.textContent = ''; }
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        var transitioned = false;
        function revealNameStep() {
          if (transitioned) return;
          transitioned = true;
          form.setAttribute('hidden', '');
          if (nameStep) {
            nameStep.removeAttribute('hidden');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nameStep.classList.add('is-visible');
                var ni = nameStep.querySelector('[data-pw-name-input]');
                if (ni) ni.focus();
              });
            });
          }
        }
        form.classList.add('is-exiting');
        form.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'transform') return;
          form.removeEventListener('transitionend', handler);
          revealNameStep();
        });
        setTimeout(revealNameStep, 700);
      });

      if (nameStep) {
        var nameSubmit = nameStep.querySelector('[data-pw-name-submit]');
        var nameSkip = nameStep.querySelector('[data-pw-name-skip]');
        var nameInput = nameStep.querySelector('[data-pw-name-input]');
        if (nameSubmit) {
          nameSubmit.addEventListener('click', function () {
            var firstName = nameInput ? (nameInput.value || '').trim() : '';
            nameSubmit.disabled = true;
            submitToKlaviyo(capturedEmail, firstName, source, container)
              .then(function (r) { if (r.ok || r.status === 202) showSuccess(); else throw new Error('Request failed'); })
              .catch(function () { showSuccess(); });
          });
        }
        if (nameSkip) {
          nameSkip.addEventListener('click', function () {
            nameSkip.disabled = true;
            submitToKlaviyo(capturedEmail, null, source, container)
              .then(function (r) { if (r.ok || r.status === 202) showSuccess(); else throw new Error('Request failed'); })
              .catch(function () { showSuccess(); });
          });
        }
      }
    });

    /* Mini-countdown */
    var miniCountdown = pwPage.querySelector('[data-pw-mini-countdown]');
    if (launchTarget > 0 && miniCountdown) {
      var miniEls = {
        days: miniCountdown.querySelector('[data-pw-mini-count="days"]'),
        hours: miniCountdown.querySelector('[data-pw-mini-count="hours"]'),
        minutes: miniCountdown.querySelector('[data-pw-mini-count="minutes"]')
      };
      var prev = { days: null, hours: null, minutes: null };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = launchTarget - Date.now();
        if (diff <= 0) {
          ['days','hours','minutes'].forEach(function (k) { if (miniEls[k]) miniEls[k].textContent = '00'; });
          miniCountdown.classList.add('is-live');
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var next = { days: pad(d), hours: pad(h), minutes: pad(m) };
        Object.keys(next).forEach(function (k) {
          if (next[k] === prev[k]) return;
          if (miniEls[k]) miniEls[k].textContent = next[k];
          prev[k] = next[k];
        });
        return true;
      }
      if (tick() !== false) {
        var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 60000);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-hero"]) return;
  try {
    
  (function () {
    var pwPage = document.querySelector('.pw-page--hero-only');
    if (!pwPage) return;

    var launchIso = pwPage.getAttribute('data-pw-launch-iso');
    var launchTarget = launchIso ? new Date(launchIso).getTime() : 0;

    /* Geo lookup */
    var geoData = {};
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { geoData = d; })
      .catch(function () {});

    /* Klaviyo submitter */
    function submitToKlaviyo(email, firstName, source, container) {
      var apiKey = container.getAttribute('data-klaviyo-key');
      var listId = container.getAttribute('data-klaviyo-list');
      if (!apiKey || !listId) return Promise.reject(new Error('Klaviyo not configured'));
      var profileAttrs = { email: email };
      if (firstName) profileAttrs.first_name = firstName;
      var props = { pre_launch: true, signup_source: source };
      if (geoData.country_name) props.country = geoData.country_name;
      if (geoData.city) props.city = geoData.city;
      profileAttrs.properties = props;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Password page signup — ' + source,
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    }

    /* Hero signup form binding */
    pwPage.querySelectorAll('[data-pw-signup]').forEach(function (container) {
      var source = container.getAttribute('data-pw-signup');
      var form = container.querySelector('[data-pw-email-form]');
      if (!form) return;
      var emailInput = form.querySelector('[data-pw-email-input]');
      var errorEl = container.querySelector('[data-pw-error]');
      var nameStep = container.querySelector('[data-pw-name-step]');
      var successEl = container.querySelector('[data-pw-success]');
      var successSubEl = container.querySelector('[data-pw-success-sub]');
      var capturedEmail = '';

      function showSuccess() {
        if (form) form.setAttribute('hidden', '');
        if (nameStep) nameStep.setAttribute('hidden', '');
        if (successEl) {
          successEl.removeAttribute('hidden');
          successEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successEl.style.transition = 'opacity 0.5s ease';
            successEl.style.opacity = '1';
          });
        }
        if (successSubEl) {
          successSubEl.removeAttribute('hidden');
          successSubEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successSubEl.style.transition = 'opacity 0.8s ease 0.3s';
            successSubEl.style.opacity = '1';
          });
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        capturedEmail = (emailInput.value || '').trim();
        if (errorEl) { errorEl.setAttribute('hidden', ''); errorEl.textContent = ''; }
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        var transitioned = false;
        function revealNameStep() {
          if (transitioned) return;
          transitioned = true;
          form.setAttribute('hidden', '');
          if (nameStep) {
            nameStep.removeAttribute('hidden');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nameStep.classList.add('is-visible');
                var ni = nameStep.querySelector('[data-pw-name-input]');
                if (ni) ni.focus();
              });
            });
          }
        }
        form.classList.add('is-exiting');
        form.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'transform') return;
          form.removeEventListener('transitionend', handler);
          revealNameStep();
        });
        setTimeout(revealNameStep, 700);
      });

      if (nameStep) {
        var nameSubmit = nameStep.querySelector('[data-pw-name-submit]');
        var nameSkip = nameStep.querySelector('[data-pw-name-skip]');
        var nameInput = nameStep.querySelector('[data-pw-name-input]');
        if (nameSubmit) {
          nameSubmit.addEventListener('click', function () {
            var firstName = nameInput ? (nameInput.value || '').trim() : '';
            nameSubmit.disabled = true;
            submitToKlaviyo(capturedEmail, firstName, source, container)
              .then(function (r) { if (r.ok || r.status === 202) showSuccess(); else throw new Error('Request failed'); })
              .catch(function () { showSuccess(); });
          });
        }
        if (nameSkip) {
          nameSkip.addEventListener('click', function () {
            nameSkip.disabled = true;
            submitToKlaviyo(capturedEmail, null, source, container)
              .then(function (r) { if (r.ok || r.status === 202) showSuccess(); else throw new Error('Request failed'); })
              .catch(function () { showSuccess(); });
          });
        }
      }
    });

    /* Countdown ticker (hero) */
    var heroCountdown = pwPage.querySelector('[data-pw-countdown]');
    if (launchTarget > 0 && heroCountdown) {
      var heroEls = {
        days: heroCountdown.querySelector('[data-pw-count="days"]'),
        hours: heroCountdown.querySelector('[data-pw-count="hours"]'),
        minutes: heroCountdown.querySelector('[data-pw-count="minutes"]'),
        seconds: heroCountdown.querySelector('[data-pw-count="seconds"]')
      };
      var prev = { days: null, hours: null, minutes: null, seconds: null };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = launchTarget - Date.now();
        if (diff <= 0) {
          ['days','hours','minutes','seconds'].forEach(function (k) {
            if (heroEls[k]) heroEls[k].textContent = '00';
          });
          heroCountdown.classList.add('is-live');
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        var next = { days: pad(d), hours: pad(h), minutes: pad(m), seconds: pad(sec) };
        Object.keys(next).forEach(function (k) {
          if (next[k] === prev[k]) return;
          if (heroEls[k]) heroEls[k].textContent = next[k];
          prev[k] = next[k];
        });
        return true;
      }
      if (tick() !== false) {
        var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 1000);
      }
    }

    /* Password reveal toggles */
    var eyeBtn = document.getElementById('pw-eye');
    var pwInput = document.getElementById('password-input');
    if (eyeBtn && pwInput) {
      eyeBtn.addEventListener('click', function () {
        var isPassword = pwInput.type === 'password';
        pwInput.type = isPassword ? 'text' : 'password';
        eyeBtn.querySelector('.pw-page__eye-open').style.display = isPassword ? 'none' : '';
        eyeBtn.querySelector('.pw-page__eye-closed').style.display = isPassword ? '' : 'none';
        eyeBtn.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
        pwInput.focus();
      });
    }

    /* Locale switcher dropdown */
    var localeSwitcher = pwPage.querySelector('[data-pw-locale-switcher]');
    if (localeSwitcher) {
      var localeToggle = localeSwitcher.querySelector('[data-pw-locale-toggle]');
      var localeMenu = localeSwitcher.querySelector('[data-pw-locale-menu]');
      function closeLocale() {
        localeSwitcher.removeAttribute('data-pw-locale-open');
        if (localeToggle) localeToggle.setAttribute('aria-expanded', 'false');
        if (localeMenu) localeMenu.setAttribute('hidden', '');
      }
      function openLocale() {
        localeSwitcher.setAttribute('data-pw-locale-open', '');
        if (localeToggle) localeToggle.setAttribute('aria-expanded', 'true');
        if (localeMenu) localeMenu.removeAttribute('hidden');
      }
      if (localeToggle && localeMenu) {
        localeToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (localeSwitcher.hasAttribute('data-pw-locale-open')) closeLocale();
          else openLocale();
        });
        document.addEventListener('click', function (e) {
          if (!localeSwitcher.contains(e.target)) closeLocale();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeLocale();
        });
      }
    }

    var toggle = document.getElementById('pw-toggle');
    var pwForm = document.getElementById('pw-form');
    if (toggle && pwForm) {
      if (!pwForm.hasAttribute('hidden')) pwForm.classList.add('is-open');
      toggle.addEventListener('click', function () {
        if (pwForm.hasAttribute('hidden')) {
          pwForm.removeAttribute('hidden');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              pwForm.classList.add('is-open');
              var input = pwForm.querySelector('input');
              if (input) input.focus();
            });
          });
        } else {
          pwForm.classList.remove('is-open');
          pwForm.addEventListener('transitionend', function handler() {
            pwForm.setAttribute('hidden', '');
            pwForm.removeEventListener('transitionend', handler);
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-moment"]) return;
  try {
    
  (function () {
    var pwPage = document.querySelector('.pw-page--moment-only');
    if (!pwPage) return;
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            revealObserver.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      pwPage.querySelectorAll('.reveal-up').forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      pwPage.querySelectorAll('.reveal-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var pwPage = document.querySelector('.pw-page--rest');
    if (!pwPage) return;

    var launchIso = pwPage.getAttribute('data-pw-launch-iso');
    var launchTarget = launchIso ? new Date(launchIso).getTime() : 0;

    /* ============================================================
       Geo lookup (best-effort)
       ============================================================ */
    var geoData = {};
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { geoData = d; })
      .catch(function () {});

    /* ============================================================
       Klaviyo submitter — shared across all 3 forms
       ============================================================ */
    function submitToKlaviyo(email, firstName, source, container) {
      var apiKey = container.getAttribute('data-klaviyo-key');
      var listId = container.getAttribute('data-klaviyo-list');
      if (!apiKey || !listId) return Promise.reject(new Error('Klaviyo not configured'));

      var profileAttrs = { email: email };
      if (firstName) profileAttrs.first_name = firstName;
      var props = { pre_launch: true, signup_source: source };
      if (geoData.country_name) props.country = geoData.country_name;
      if (geoData.city) props.city = geoData.city;
      profileAttrs.properties = props;

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Password page signup — ' + source,
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    }

    /* ============================================================
       Bind [data-pw-signup] containers in this section (founders + final)
       ============================================================ */
    pwPage.querySelectorAll('[data-pw-signup]').forEach(function (container) {
      var source = container.getAttribute('data-pw-signup');
      var form = container.querySelector('[data-pw-email-form]');
      if (!form) return;
      var emailInput = form.querySelector('[data-pw-email-input]');
      var errorEl = container.querySelector('[data-pw-error]');
      var nameStep = container.querySelector('[data-pw-name-step]');
      var noNameStep = form.hasAttribute('data-pw-no-name');
      var successEl = container.querySelector('[data-pw-success]');
      var successSubEl = container.querySelector('[data-pw-success-sub]');
      var capturedEmail = '';

      function showSuccess() {
        if (form) form.setAttribute('hidden', '');
        if (nameStep) nameStep.setAttribute('hidden', '');
        if (successEl) {
          successEl.removeAttribute('hidden');
          successEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successEl.style.transition = 'opacity 0.5s ease';
            successEl.style.opacity = '1';
          });
        }
        if (successSubEl) {
          successSubEl.removeAttribute('hidden');
          successSubEl.style.opacity = '0';
          requestAnimationFrame(function () {
            successSubEl.style.transition = 'opacity 0.8s ease 0.3s';
            successSubEl.style.opacity = '1';
          });
        }
      }

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.removeAttribute('hidden');
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        capturedEmail = (emailInput.value || '').trim();
        if (errorEl) { errorEl.setAttribute('hidden', ''); errorEl.textContent = ''; }

        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        if (noNameStep) {
          submitToKlaviyo(capturedEmail, null, source, container)
            .then(function (r) {
              if (r.ok || r.status === 202) showSuccess();
              else throw new Error('Request failed');
            })
            .catch(function () { showSuccess(); });
          return;
        }

        // Two-step: slide email form out, slide name step in.
        var transitioned = false;
        function revealNameStep() {
          if (transitioned) return;
          transitioned = true;
          form.setAttribute('hidden', '');
          if (nameStep) {
            nameStep.removeAttribute('hidden');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nameStep.classList.add('is-visible');
                var nameInput = nameStep.querySelector('[data-pw-name-input]');
                if (nameInput) nameInput.focus();
              });
            });
          }
        }
        form.classList.add('is-exiting');
        form.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'transform') return;
          form.removeEventListener('transitionend', handler);
          revealNameStep();
        });
        setTimeout(revealNameStep, 700);
      });

      if (!noNameStep && nameStep) {
        var nameSubmit = nameStep.querySelector('[data-pw-name-submit]');
        var nameSkip = nameStep.querySelector('[data-pw-name-skip]');
        var nameInput = nameStep.querySelector('[data-pw-name-input]');

        if (nameSubmit) {
          nameSubmit.addEventListener('click', function () {
            var firstName = nameInput ? (nameInput.value || '').trim() : '';
            nameSubmit.disabled = true;
            submitToKlaviyo(capturedEmail, firstName, source, container)
              .then(function (r) {
                if (r.ok || r.status === 202) showSuccess();
                else throw new Error('Request failed');
              })
              .catch(function () { showSuccess(); });
          });
        }
        if (nameSkip) {
          nameSkip.addEventListener('click', function () {
            nameSkip.disabled = true;
            submitToKlaviyo(capturedEmail, null, source, container)
              .then(function (r) {
                if (r.ok || r.status === 202) showSuccess();
                else throw new Error('Request failed');
              })
              .catch(function () { showSuccess(); });
          });
        }
      }
    });

    /* ============================================================
       Mini-countdown (Founders section "Sales open in ...")
       Hero countdown lives in password-hero.liquid.
       ============================================================ */
    var miniCountdown = pwPage.querySelector('[data-pw-mini-countdown]');
    if (launchTarget > 0 && miniCountdown) {
      var miniEls = {
        days: miniCountdown.querySelector('[data-pw-mini-count="days"]'),
        hours: miniCountdown.querySelector('[data-pw-mini-count="hours"]'),
        minutes: miniCountdown.querySelector('[data-pw-mini-count="minutes"]')
      };
      var prev = { days: null, hours: null, minutes: null };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = launchTarget - Date.now();
        if (diff <= 0) {
          ['days','hours','minutes'].forEach(function (k) {
            if (miniEls[k]) miniEls[k].textContent = '00';
          });
          miniCountdown.classList.add('is-live');
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var next = { days: pad(d), hours: pad(h), minutes: pad(m) };
        Object.keys(next).forEach(function (k) {
          if (next[k] === prev[k]) return;
          if (miniEls[k]) miniEls[k].textContent = next[k];
          prev[k] = next[k];
        });
        return true;
      }
      if (tick() !== false) {
        var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 60000);
      }
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* ──────────────────────────────────────────────────────────
     ACC-PROD — variant logic, qty stepper, gallery, pair-add
     The cart form posts through cart-drawer.js's global submit
     interceptor, so we don't need to handle add-to-cart here for
     the main form. We DO handle the pair-add buttons inline.
     ────────────────────────────────────────────────────────── */
  function initAccProd() {
    var section = document.querySelector('[data-acc-prod]');
    if (!section) return;

    var jsonEl = section.querySelector('[data-acc-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); }
    catch (e) { console.error('acc-prod: JSON parse failed', e); return; }
    if (!product || !product.variants || !product.variants.length) return;

    var current = null;
    try {
      var urlVid = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
      if (urlVid) current = product.variants.find(function (v) { return v.id === urlVid; }) || null;
    } catch (e) { /* old browsers */ }
    if (!current) current = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var selected = [current.option1, current.option2, current.option3];

    /* The store's base currency was flipped EUR -> DKK, so a hardcoded € lied on every
       accessory page. Same contract as moneyFormat() in sections/bike-configurator.liquid. */
    var ACC_CURRENCY = (section.getAttribute('data-currency') || 'DKK').toUpperCase();
    /* Anyday's contract locks 4 interest-free instalments. Not a monthly plan. */
    var INSTALMENT_COUNT = 4;

    function money(cents) {
      var n = Math.round(cents / 100).toLocaleString('da-DK');
      if (ACC_CURRENCY === 'EUR') return '\u20ac' + n;
      if (ACC_CURRENCY === 'DKK') return n + ' kr';
      try {
        return new Intl.NumberFormat('da-DK', { style: 'currency', currency: ACC_CURRENCY, maximumFractionDigits: 0 }).format(cents / 100);
      } catch (e) {
        return n + ' ' + ACC_CURRENCY;
      }
    }

    function animatePrice(el, from, to) {
      if (!el || from === to) { if (el) el.textContent = money(to); return; }
      var start = performance.now();
      var diff = to - from;
      el.classList.add('is-flashing');
      function tick(now) {
        var t = Math.min(1, (now - start) / 500);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = money(Math.round(from + diff * eased));
        if (t < 1) requestAnimationFrame(tick);
        else setTimeout(function () { el.classList.remove('is-flashing'); }, 250);
      }
      requestAnimationFrame(tick);
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.option1 === opts[0] &&
          (opts[1] == null || v.option2 === opts[1]) &&
          (opts[2] == null || v.option3 === opts[2]);
      });
    }

    var priceEl = section.querySelector('[data-acc-price]');
    var priceCompareEl = section.querySelector('[data-acc-price-compare]');
    var stickyPriceEl = section.querySelector('[data-acc-sticky-price]');
    var variantIdInput = section.querySelector('[data-acc-variant-id]');
    var addBtn = section.querySelector('[data-acc-add]');
    var addLabel = section.querySelector('[data-acc-add-label]');
    var stickyAdd = section.querySelector('[data-acc-sticky-add]');
    var klarnaEl = section.querySelector('[data-acc-klarna]');
    var galleryImg = section.querySelector('[data-acc-gallery-img]');
    var thumbs = section.querySelectorAll('[data-acc-thumb]');
    var lastPriceCents = current.price;

    function applyVariant(next) {
      var prevPrice = current.price;
      current = next;
      selected = [next.option1, next.option2, next.option3];

      if (variantIdInput) variantIdInput.value = next.id;
      if (section.dataset.productUrl) {
        try {
          var params = new URLSearchParams(window.location.search);
          params.set('variant', next.id);
          window.history.replaceState({}, '', section.dataset.productUrl + '?' + params.toString());
        } catch (e) { /* ignore */ }
      }

      animatePrice(priceEl, prevPrice, next.price);
      animatePrice(stickyPriceEl, lastPriceCents, next.price);
      lastPriceCents = next.price;
      if (priceCompareEl) {
        if (next.compare_at_price && next.compare_at_price > next.price) {
          priceCompareEl.textContent = money(next.compare_at_price);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.hidden = true;
        }
      }

      if (klarnaEl && klarnaEl.dataset.klarnaTemplate) {
        var tpl = klarnaEl.dataset.klarnaTemplate;
        var instalment = money(Math.round(next.price / INSTALMENT_COUNT));
        /* Preferred: the setting carries a {amount} placeholder, so the text can say
           "4 rentefri rater" without the pattern eating the 4. Fall back to stripping
           the setting's own currency, before OR after the number — the old before-only
           pattern never matched the Danish "10 €/måned" and left it frozen. */
        klarnaEl.textContent = tpl.indexOf('{amount}') > -1
          ? tpl.replace('{amount}', instalment)
          : tpl.replace(/(€\s?)?\d[\d.,]*(\s?(kr|€))?/, instalment);
      }

      [addBtn, stickyAdd].forEach(function (b) {
        if (!b) return;
        b.disabled = !next.available;
      });
      if (addLabel) addLabel.textContent = next.available ? 'Add to cart' : 'Sold out';
      if (stickyAdd) stickyAdd.textContent = next.available ? 'Add to cart' : 'Sold out';

      [next.option1, next.option2, next.option3].forEach(function (val, idx) {
        if (val == null) return;
        var label = section.querySelector('[data-acc-option-value="' + (idx + 1) + '"]');
        if (label) label.textContent = ' - ' + val;
      });

      section.querySelectorAll('[data-acc-option]').forEach(function (btn) {
        var pos = Number(btn.dataset.optionPosition);
        var val = btn.dataset.optionValue;
        var isActive = selected[pos - 1] === val;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive);
      });

      if (next.featured_media_id && galleryImg && product.media) {
        var media = product.media.find(function (m) { return m.id === next.featured_media_id; });
        if (media && media.src && galleryImg.getAttribute('src') !== media.src) {
          galleryImg.style.opacity = '0';
          setTimeout(function () {
            galleryImg.setAttribute('src', media.src);
            galleryImg.style.opacity = '1';
            thumbs.forEach(function (t) {
              t.classList.toggle('is-active', Number(t.dataset.mediaId) === next.featured_media_id);
            });
          }, 180);
        }
      }
    }

    section.querySelectorAll('[data-acc-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = Number(this.dataset.optionPosition);
        var val = this.dataset.optionValue;
        selected[pos - 1] = val;
        var match = findVariant(selected);
        if (match) applyVariant(match);
      });
    });

    var qtyInput = section.querySelector('[data-acc-qty-input]');
    section.querySelectorAll('[data-acc-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var cur = parseInt(qtyInput.value, 10) || 1;
        var delta = this.dataset.accQty === 'inc' ? 1 : -1;
        qtyInput.value = Math.max(1, cur + delta);
      });
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = this.dataset.mediaSrc;
        if (!src || !galleryImg) return;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        galleryImg.style.opacity = '0';
        setTimeout(function () {
          galleryImg.setAttribute('src', src);
          galleryImg.style.opacity = '1';
        }, 180);
      });
    });

    section.querySelectorAll('[data-acc-pair-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(this.dataset.variantId, 10);
        if (!vid) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('Cart add failed: ' + r.status);
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (window.refreshCartDrawer) {
            return window.refreshCartDrawer().then(function () {
              if (window.openCartDrawer) window.openCartDrawer();
            });
          }
        }).catch(function (err) {
          console.error('Pair add failed', err);
        }).finally(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
      });
    });

    var stickyBar = section.querySelector('[data-acc-sticky]');
    var mainAdd = section.querySelector('.acc-prod__add');
    if (stickyBar && mainAdd && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(mainAdd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccProd);
  } else {
    initAccProd();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-numbers"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var section=document.querySelector('[data-production-numbers]');
    if(!section) return;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vals=section.querySelectorAll('[data-pn-value]');
    function animate(el){
      var raw=el.getAttribute('data-pn-value');
      var m=raw.match(/^(\D*)(\d[\d.,]*)(.*)$/);
      if(!m || reduce){ return; }
      var pre=m[1], numStr=m[2].replace(/,/g,''), suf=m[3];
      var target=parseFloat(numStr);
      if(isNaN(target)) return;
      var dec=(numStr.split('.')[1]||'').length;
      var dur=1100, start=null;
      function step(ts){
        if(!start) start=ts;
        var p=Math.min((ts-start)/dur,1);
        var e=1-Math.pow(1-p,3);
        var cur=(target*e).toFixed(dec);
        el.textContent=pre+cur+suf;
        if(p<1) requestAnimationFrame(step);
        else el.textContent=raw;
      }
      el.textContent=pre+'0'+suf;
      requestAnimationFrame(step);
    }
    var seen=false;
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting && !seen){ seen=true; vals.forEach(animate); obs.disconnect(); }
      });
    },{threshold:0.35});
    obs.observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-peek"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-production-peek]');
    if (!section) return;

    var track = section.querySelector('[data-pp-track]');
    if (!track) return;

    // Click anywhere on the strip (including images) toggles between paused and
    // playing. The visibility observer still auto-pauses when off-screen but
    // only auto-resumes if the visitor hasn't explicitly paused.
    var userPaused = false;
    var inView = false;

    function applyState() {
      if (userPaused || !inView) {
        track.classList.add('is-paused');
      } else {
        track.classList.remove('is-paused');
      }
    }

    track.addEventListener('click', function () {
      userPaused = !userPaused;
      applyState();
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting;
        applyState();
      });
    }, { threshold: 0.05 });

    obs.observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.review-form');
    if (!section) return;

    var CITY_MAP = {
      Denmark: ['Copenhagen', 'Aarhus', 'Odense', 'Aalborg'],
      Netherlands: ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven'],
      Germany: ['Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt']
    };

    section.querySelectorAll('[data-city-target]').forEach(function (countryEl) {
      var cityEl = document.getElementById(countryEl.getAttribute('data-city-target'));
      if (!cityEl) return;
      function populate() {
        var cities = CITY_MAP[countryEl.value] || [];
        cityEl.innerHTML = '<option value="" disabled selected>' + cityEl.getAttribute('data-placeholder') + '</option>';
        cities.forEach(function (c) {
          cityEl.innerHTML += '<option value="' + c + '">' + c + '</option>';
        });
      }
      cityEl.setAttribute('data-placeholder', cityEl.options[0] ? cityEl.options[0].text : '');
      countryEl.addEventListener('change', populate);
      populate();
    });

    var form = section.querySelector('form');
    var successEl = section.querySelector('[data-review-success]');

    var copyBtn = section.querySelector('.review-form__copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.closest('.review-form__coupon-code').getAttribute('data-coupon');
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
          setTimeout(function () {
            copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
          }, 2000);
        });
      });
    }

    var MAX_TAGS = 3;
    var tagBtns = section.querySelectorAll('.review-form__tag');
    var tagInput = section.querySelector('.review-form__tags-input');

    function updateTags() {
      var selected = [];
      tagBtns.forEach(function (btn) {
        if (btn.classList.contains('is-selected')) {
          selected.push(btn.getAttribute('data-tag'));
        }
      });
      if (tagInput) tagInput.value = selected.join(', ');
      tagBtns.forEach(function (btn) {
        if (!btn.classList.contains('is-selected') && selected.length >= MAX_TAGS) {
          btn.classList.add('is-max-reached');
        } else {
          btn.classList.remove('is-max-reached');
        }
      });
    }

    tagBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-max-reached')) return;
        btn.classList.toggle('is-selected');
        updateTags();
      });
    });

    var fileInput = section.querySelector('.review-form__photo-input');
    if (!fileInput) return;

    var drop = fileInput.closest('[data-photo-drop]');
    var placeholder = drop.querySelector('[data-photo-placeholder]');
    var preview = drop.querySelector('[data-photo-preview]');
    var previewImg = drop.querySelector('[data-photo-preview-img]');
    var removeBtn = drop.querySelector('[data-photo-remove]');
    var dataField = drop.parentElement.querySelector('[data-photo-data]');
    var MAX_SIZE = 600;
    var QUALITY = 0.6;

    function resizeAndEncode(file) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () {
          var w = img.width;
          var h = img.height;
          if (w > MAX_SIZE || h > MAX_SIZE) {
            if (w > h) {
              h = Math.round(h * MAX_SIZE / w);
              w = MAX_SIZE;
            } else {
              w = Math.round(w * MAX_SIZE / h);
              h = MAX_SIZE;
            }
          }
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          var dataUrl = canvas.toDataURL('image/jpeg', QUALITY);
          previewImg.src = dataUrl;
          dataField.value = dataUrl;
          placeholder.style.display = 'none';
          preview.style.display = 'block';
          fileInput.style.display = 'none';
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) {
        resizeAndEncode(fileInput.files[0]);
      }
    });

    removeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      previewImg.src = '';
      dataField.value = '';
      fileInput.value = '';
      placeholder.style.display = '';
      preview.style.display = 'none';
      fileInput.style.display = '';
    });

    var uploadUrl = section.getAttribute('data-upload-url') || '';

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('.review-form__submit');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending\u2026';

        var lines = ['--- Test Ride Review ---', ''];
        var fields = [
          { label: 'Rating', sel: 'input[name="contact[rating]"]:checked' },
          { label: 'Name', sel: '[name="contact[name]"]' },
          { label: 'Email', sel: '[name="contact[email]"]' },
          { label: 'Country', sel: '[name="contact[country]"]' },
          { label: 'City', sel: '[name="contact[city]"]' },
          { label: 'Review', sel: '[name="contact[review_text]"]' },
          { label: 'Tags', sel: '.review-form__tags-input' }
        ];
        fields.forEach(function (f) {
          var el = form.querySelector(f.sel);
          if (el && el.value) lines.push(f.label + ': ' + el.value);
        });

        var photoUpload = Promise.resolve(null);
        if (uploadUrl && dataField && dataField.value) {
          var b64 = dataField.value.split(',')[1];
          photoUpload = fetch(uploadUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image: b64, filename: 'review-' + Date.now() + '.jpg' })
          })
          .then(function (r) { return r.json(); })
          .then(function (d) { return d.url || null; })
          .catch(function () { return null; });
        }

        photoUpload.then(function (photoUrl) {
          if (photoUrl) lines.push('Photo: ' + photoUrl);
          var bodyField = form.querySelector('[id^="review-body-"]');
          if (bodyField) bodyField.value = lines.join('\n');

          var fd = new FormData(form);
          fd.delete('contact[photo_data]');
          fd.delete('contact[review_text]');

          var params = new URLSearchParams();
          fd.forEach(function (v, k) { params.append(k, v); });

          return fetch(form.action, {
            method: 'POST',
            body: params,
            headers: { 'Accept': 'text/html' }
          });
        }).then(function (res) {
          if (!res || !res.ok) throw new Error('submit failed');
          form.style.display = 'none';
          successEl.style.display = '';
          successEl.classList.add('is-visible');
        }).catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Try again';
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pad = function (i) { return (i < 10 ? '0' : '') + i; };
    function inView(el, cb, th) {
      if (!('IntersectionObserver' in window)) { cb(); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } }); }, { threshold: th || 0.25 });
      io.observe(el);
    }

    /* B · Film: sektionen står fast; lodret rulning fører strimlen ind fra højre */
    function film(root) {
      var pin = root.querySelector('[data-ss-pin]');
      var track = root.querySelector('[data-ss-track]');
      var cards = [].slice.call(root.querySelectorAll('[data-ss-card]'));
      var bar = root.querySelector('[data-ss-bar]');
      var count = root.querySelector('[data-ss-count]');
      var head = root.querySelector('.ss__head');
      var total = cards.length, dist = 0, raf = 0;
      if (RM) { root.classList.add('is-static'); return; }
      function size() {
        var vw = window.innerWidth;
        dist = track.scrollWidth + vw * 0.15;
        root.style.height = (window.innerHeight + dist * (vw < 900 ? 0.9 : 0.7)) + 'px';
        paint();
      }
      function paint() {
        raf = 0;
        var r = root.getBoundingClientRect();
        var span = root.offsetHeight - window.innerHeight;
        var p = Math.min(Math.max(-r.top / span, 0), 1);
        var vw = window.innerWidth;
        var tx = vw * 0.85 - p * dist;
        track.style.setProperty('--tx', tx.toFixed(1) + 'px');
        if (bar) bar.style.setProperty('--p', p.toFixed(4));
        if (head) { head.style.setProperty('--hy', (p * -8).toFixed(1) + 'px'); }
        var best = 0, bd = 1e9, mid = vw * 0.42;
        cards.forEach(function (c, i) {
          var cr = c.getBoundingClientRect();
          var d = (cr.left + cr.width / 2 - mid) / vw;
          if (Math.abs(d) < bd) { bd = Math.abs(d); best = i; }
          var a = Math.min(Math.abs(d), 1);
          c.style.setProperty('--cy', (a * a * 48).toFixed(1) + 'px');
          c.style.setProperty('--cr', (Math.max(-1, Math.min(1, d)) * 2.5).toFixed(2) + 'deg');
          c.querySelector('img').style.setProperty('--ks', (1 + a * 0.22).toFixed(3));
        });
        if (count) count.textContent = pad(best + 1) + ' / ' + pad(total);
      }
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      window.addEventListener('resize', size);
      size();
    }

    /* C · Kameraet: zoom ind på detaljen, kugle og tråd, teksten ind fra højre */
    function camera(root) {
      var stage = root.querySelector('[data-ss-stage]');
      var img = root.querySelector('[data-ss-cam-img]');
      var svg = root.querySelector('[data-ss-thread]');
      var ball = svg.querySelector('.ss-cam__ball'), ring = svg.querySelector('.ss-cam__ring'), line = svg.querySelector('.ss-cam__line');
      var copies = [].slice.call(root.querySelectorAll('[data-ss-copy]'));
      var thumbs = [].slice.call(root.querySelectorAll('[data-ss-thumb]'));
      var num = root.querySelector('[data-ss-num]');
      var scenes = [].slice.call(root.querySelectorAll('[data-ss-scene]'));
      var panel = root.querySelector('[data-ss-panel]');
      var total = copies.length, cur = 0, timer = 0, auto = !RM, visible = false, DUR = 4800;
      function frame(i, instant) {
        var c = copies[i];
        var W = stage.clientWidth, H = stage.clientHeight;
        var fx = parseFloat(c.dataset.fx) / 100, fy = parseFloat(c.dataset.fy) / 100, z = parseFloat(c.dataset.zoom) || 1;
        var tx = W * 0.42 - fx * W * z, ty = H * 0.5 - fy * H * z;
        tx = Math.min(0, Math.max(W - W * z, tx)); ty = Math.min(0, Math.max(H - H * z, ty));
        if (instant) img.style.transition = 'none';
        img.style.transform = 'translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) scale(' + z + ')';
        if (instant) { void img.offsetWidth; img.style.transition = ''; }
        var bx = tx + fx * W * z, by = ty + fy * H * z;
        var scene = false;
        scenes.forEach(function (sc) { var on = +sc.dataset.ssScene === i; sc.classList.toggle('is-on', on); if (on) scene = true; });
        if (panel) panel.classList.toggle('is-scene', scene);
        svg.classList.remove('is-on');
        if (scene || z <= 1.01) return;
        var up = by > H * 0.35 ? -1 : 1;
        var dx = Math.min(70, W * 0.1), x2 = bx + dx, y2 = by + up * dx;
        var x3 = Math.min(W - 18, x2 + Math.min(140, W * 0.2));
        ball.setAttribute('cx', bx); ball.setAttribute('cy', by); ring.setAttribute('cx', bx); ring.setAttribute('cy', by);
        line.setAttribute('d', 'M' + bx + ' ' + by + 'L' + x2 + ' ' + y2 + 'L' + x3 + ' ' + y2);
        line.style.setProperty('--len', (dx * 1.42 + (x3 - x2) + 4).toFixed(0));
        setTimeout(function () { if (copies[cur] === c) svg.classList.add('is-on'); }, instant || RM ? 0 : 1300);
      }
      function go(i, instant) {
        var prev = cur;
        cur = (i + total) % total;
        copies.forEach(function (c, j) {
          c.classList.toggle('is-out', j === prev && j !== cur);
          c.classList.toggle('is-on', j === cur);
        });
        setTimeout(function () { copies[prev].classList.remove('is-out'); }, 600);
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === cur); t.classList.remove('is-play'); t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
        if (num) num.textContent = pad(cur + 1) + ' / ' + pad(total);
        frame(cur, instant);
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (!auto || !visible) return;
        var t = thumbs[cur];
        t.style.setProperty('--dur', DUR + 'ms');
        requestAnimationFrame(function () { t.classList.add('is-play'); });
        timer = setTimeout(function () { go(cur + 1); }, DUR);
      }
      function stop() { auto = false; clearTimeout(timer); thumbs.forEach(function (t) { t.classList.remove('is-play'); }); }
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { stop(); go(j); }); });
      root.querySelector('[data-ss-prev]').addEventListener('click', function () { stop(); go(cur - 1); });
      root.querySelector('[data-ss-next]').addEventListener('click', function () { stop(); go(cur + 1); });
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var d = e.changedTouches[0].clientX - sx; if (Math.abs(d) > 40) { stop(); go(cur + (d < 0 ? 1 : -1)); } sx = null; });
      root.addEventListener('mouseenter', function () { clearTimeout(timer); thumbs[cur].classList.remove('is-play'); });
      root.addEventListener('mouseleave', schedule);
      root.addEventListener('focusin', stop);
      window.addEventListener('resize', function () { frame(cur, true); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) schedule(); else clearTimeout(timer); }); }, { threshold: 0.4 }).observe(root);
      } else { visible = true; }
      frame(0, true);
      inView(root, function () { root.classList.add('is-in'); go(0); }, 0.4);
    }

    function boot() {
      document.querySelectorAll('[data-ss]').forEach(function (root) {
        if (root.dataset.ssReady) return; root.dataset.ssReady = '1'; root.classList.add('is-arm');
        var t = root.dataset.ss;
        if (t === 'camera') camera(root); else film(root);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-viewer"] && !Shopify.designMode) return;
  try {
    
  // Lazy-load spec-viewer videos on intersection (saves ~3 MB of below-fold downloads)
  (function() {
    var lazyVideos = document.querySelectorAll('.spec-viewer video[data-lazy-src]');
    if (!lazyVideos.length || !('IntersectionObserver' in window)) {
      lazyVideos.forEach(function(v) {
        if (v.dataset.lazySrc) { v.src = v.dataset.lazySrc; v.load(); }
      });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        // Only the default (first) video loads when the section enters view; the
        // per-spec videos load on demand when their spec is selected. Keeps the
        // reach-the-viewport moment light instead of pulling every clip at once.
        card.querySelectorAll('video.spec-viewer__bg-img--default[data-lazy-src]').forEach(function(v) {
          if (!v.src && v.dataset.lazySrc) { v.src = v.dataset.lazySrc; v.load(); }
        });
        io.unobserve(card);
      });
    }, { rootMargin: '0px' });
    document.querySelectorAll('.spec-viewer').forEach(function(card) { io.observe(card); });
  })();

  (function() {
    document.querySelectorAll('.spec-viewer__pills').forEach(function(container) {
      var card = container.closest('.spec-viewer');
      var wraps = container.querySelectorAll('.spec-viewer__pill-wrap');
      var activeIndex = null;

      function playFromStart(el) {
        if (!el || el.tagName !== 'VIDEO') return;
        // If the lazy src hasn't been assigned yet, do it now so the first
        // play starts from frame 0.
        if (!el.src && el.dataset.lazySrc) {
          el.src = el.dataset.lazySrc;
          el.load();
        }
        try { el.currentTime = 0; } catch (e) { /* not yet seekable — load handler will retry */ }
        var attempt = el.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
        // Ensure rewind happens even if the metadata wasn't loaded yet when we called currentTime.
        var onMeta = function () {
          try { el.currentTime = 0; } catch (e) {}
          el.removeEventListener('loadedmetadata', onMeta);
        };
        if (!el.duration) el.addEventListener('loadedmetadata', onMeta);
      }

      function pauseAndRewind(el) {
        if (!el || el.tagName !== 'VIDEO') return;
        el.pause();
        try { el.currentTime = 0; } catch (e) {}
      }

      function setImage(idx) {
        if (!card) return;
        var all = card.querySelectorAll('.spec-viewer__bg-img');
        all.forEach(function(img) {
          if (img.classList.contains('is-active')) pauseAndRewind(img);
          img.classList.remove('is-active');
        });
        var next = null;
        if (idx === null) {
          next = card.querySelector('.spec-viewer__bg-img--default');
        } else {
          next = card.querySelector('.spec-viewer__bg-img[data-spec-index="' + idx + '"]')
              || card.querySelector('.spec-viewer__bg-img--default');
        }
        if (next) {
          next.classList.add('is-active');
          playFromStart(next);
        }
      }

      var mobilePanel = card ? card.querySelector('.spec-viewer__mobile-panel-text') : null;
      var isMobile = function() { return window.innerWidth <= 768; };

      function setMobilePanel(text) {
        if (!mobilePanel) return;
        if (text) {
          mobilePanel.textContent = text;
          mobilePanel.classList.remove('is-empty');
        } else {
          mobilePanel.classList.add('is-empty');
        }
      }

      function open(wrap, idx, opts) {
        opts = opts || {};
        var body = wrap.querySelector('.spec-viewer__pill-body');
        var btn  = wrap.querySelector('.spec-viewer__pill');
        wrap.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        if (isMobile()) {
          var p = body.querySelector('p');
          setMobilePanel(p ? p.textContent : '');
          // Centre the active pill in the horizontal strip so the visitor can
          // see there are pills on either side (otherwise the last visible
          // pill on the right makes it look like there are no more).
          if (!opts.skipScroll) {
            try {
              wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } catch (e) { /* older Safari may throw on the options form */ }
          }
        } else {
          body.style.height = body.scrollHeight + 'px';
        }
        setImage(idx);
        activeIndex = idx;
      }

      function close(wrap) {
        var body = wrap.querySelector('.spec-viewer__pill-body');
        var btn  = wrap.querySelector('.spec-viewer__pill');
        wrap.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
        if (!isMobile()) {
          body.style.minWidth = body.offsetWidth + 'px';
          body.style.height = '0';
          body.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            body.style.minWidth = '';
            body.removeEventListener('transitionend', handler);
          });
        }
      }

      wraps.forEach(function(wrap, idx) {
        var btn = wrap.querySelector('.spec-viewer__pill');
        if (!btn) return;
        btn.addEventListener('click', function() {
          // One spec is always selected — clicking the already-active pill
          // keeps it open rather than toggling back to an empty state.
          if (activeIndex === idx) return;
          if (activeIndex !== null) close(wraps[activeIndex]);
          open(wrap, idx);
        });
      });

      // Prev/next arrows (mobile) — step through the specs in order, wrapping
      // around at the ends. Reuses the same open/close logic as the pills.
      function goToSpec(idx) {
        if (idx === activeIndex) return;
        if (activeIndex !== null) close(wraps[activeIndex]);
        open(wraps[idx], idx);
      }

      if (card) {
        card.querySelectorAll('[data-spec-arrow]').forEach(function(arrow) {
          arrow.addEventListener('click', function() {
            var n = wraps.length;
            if (!n) return;
            var dir = arrow.getAttribute('data-spec-arrow') === 'next' ? 1 : -1;
            var idx;
            if (activeIndex === null) {
              idx = dir === 1 ? 0 : n - 1;
            } else {
              idx = (activeIndex + dir + n) % n;
            }
            goToSpec(idx);
          });
        });
      }

      // Select the first spec on first view so one spec is always active.
      // We wait until the card enters the viewport (threshold 0.5) to preserve
      // lazy video loading; skipScroll avoids nudging the page on auto-select.
      if (card && wraps.length > 0 && 'IntersectionObserver' in window) {
        var startedAuto = false;
        var autoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || startedAuto) return;
            if (activeIndex !== null) { autoIo.disconnect(); return; } // user already chose
            startedAuto = true;
            open(wraps[0], 0, { skipScroll: true });
            autoIo.disconnect();
          });
        }, { threshold: 0.5 });
        autoIo.observe(card);
      } else if (card && wraps.length > 0) {
        // No IntersectionObserver support — select the first spec immediately.
        open(wraps[0], 0, { skipScroll: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride-demo-days"] && !Shopify.designMode) return;
  try {
    
  // One owner per system: GTM owns GA4, this file owns Meta.
  //
  // GA4 gets the dataLayer push only. GTM has triggers on these event names (added
  // 2026-08-18) and fires the GA4 tags itself. Do NOT also call gtag() here, or every
  // booking lands in GA4 twice.
  //
  // Meta is called directly. It could live in GTM too, but the eventId below has to
  // survive to a server-side CAPI call, and keeping the pixel next to the code that
  // knows the Calendly invitee is the shorter path. window.fbq exists because the
  // pixel base tag fires on all pages.
  //
  // eventId is derived from the Calendly invitee UUID because it is the one identifier
  // the browser and the server both see. Never a random: a random cannot dedupe.
  function trPushConversion(fbEvent, gaEvent, params, eventId) {
    params = params || {};
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', fbEvent, params, eventId ? { eventID: eventId } : {});
      }
    } catch (err) {}
    (window.dataLayer = window.dataLayer || []).push(
      Object.assign({ event: gaEvent }, params, eventId ? { event_id: eventId } : {})
    );
  }

  (function () {
    // Shared lead-capture modal. Triggered by any [data-dd-open] button - the
    // city cards' "Notify me" fallback when a city has no open dates yet.
    var modal = document.getElementById('dd-signup-modal');
    if (!modal) return;
    var WORKER_URL = modal.dataset.workerUrl;
    if (!WORKER_URL) return;

    // City waitlist → Klaviyo client API (public company id, the same path as the footer signup).
    // One subscription call carries email consent (email only, no SMS), the list and the city
    // properties; an event records the consent wording she saw. Sends nothing by itself: the list
    // is single opt-in and no flow listens to it (Nichlas 20-10-2026: manual mail when a city opens).
    var KL_REV = '2025-10-15';
    var WAITLIST_CITY = {
      copenhagen: ['copenhagen', 'København'], koebenhavn: ['copenhagen', 'København'],
      aalborg: ['aalborg', 'Aalborg'], aarhus: ['aarhus', 'Aarhus'], odense: ['odense', 'Odense']
    };
    function klPost(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(modal.dataset.klCompany || ''), {
        method: 'POST',
        // No keepalive: Chrome refuses keepalive on a request that needs a CORS preflight (revision header).
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', revision: KL_REV },
        body: JSON.stringify(body)
      });
    }
    function klaviyoWaitlist(p) {
      var ok = { status: 200, body: { ok: true } };
      if (p.website) return Promise.resolve(ok); // honeypot: answer ok, store nothing
      var c = WAITLIST_CITY[String(p.event_tag || '').replace(/^private-ride-/, '')];
      var listId = modal.dataset.klList || '';
      if (!modal.dataset.klCompany || !listId || !c) return Promise.resolve({ status: 500, body: { ok: false, code: 'config' } });
      var props = { lead_city: c[1] };
      props['testride_waitlist_' + c[0]] = new Date().toISOString();
      function subscribe(withPhone) {
        var attrs = { email: p.email, properties: Object.assign({}, props),
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        if (p.first_name) attrs.first_name = p.first_name;
        // Klaviyo validates phone_number strictly; a number it rejects must not cost the signup.
        if (p.phone) { if (withPhone) attrs.phone_number = p.phone; else attrs.properties.phone_entered = p.phone; }
        return klPost('subscriptions', { data: { type: 'subscription',
          attributes: { custom_source: 'Website · Prøvetur-venteliste · ' + c[1],
            profile: { data: { type: 'profile', attributes: attrs } } },
          relationships: { list: { data: { type: 'list', id: listId } } } } });
      }
      return subscribe(true)
        .then(function (r) { return (r.status === 400 && p.phone) ? subscribe(false) : r; })
        .then(function (r) {
          if (!r.ok) return { status: r.status, body: { ok: false, code: r.status === 400 ? 'email' : 'upstream' } };
          klPost('events', { data: { type: 'event', attributes: {
            properties: { city: c[1], city_slug: c[0], event_tag: p.event_tag, page: p.page, locale: p.locale, consent_text: p.consent_text },
            metric: { data: { type: 'metric', attributes: { name: 'Test Ride Waitlist Joined' } } },
            profile: { data: { type: 'profile', attributes: { email: p.email } } } } } }).catch(function () {});
          return ok;
        });
    }

    var i18nEl = document.getElementById('dd-i18n');
    var i18n = i18nEl ? i18nEl.dataset : {};

    var titleEl = modal.querySelector('[data-dd-title]');
    var subEl = modal.querySelector('[data-dd-sub]');
    var eventTagIn = modal.querySelector('[data-dd-event-tag]');
    var form = modal.querySelector('[data-dd-form]');
    var successEl = modal.querySelector('[data-dd-success]');
    var errorEl = modal.querySelector('[data-dd-error]');
    var submitBtn = modal.querySelector('[data-dd-submit]');
    var countrySel = modal.querySelector('[data-dd-country]');
    var phoneInput = modal.querySelector('[data-dd-phone]');
    var lastOpener = null;
    var isNotify = false;
    var notifyCity = '';
    // Write the label into the button's .by__lbl span, never over the button itself: replacing the span
    // with a bare text node drops the Bylys label colour, and the button read dark-on-dark (live 19-10-2026).
    var submitLbl = submitBtn ? (submitBtn.querySelector('.by__lbl') || submitBtn) : null;
    function setSubmitLabel(t) { if (submitLbl) submitLbl.textContent = t; }
    var defaultSubmitLabel = submitLbl ? submitLbl.textContent : '';
    // Notify mode (city waitlist) swaps the demo-day wording for its own. Defaults are the
    // demo-day strings as rendered, so the demo path is untouched.
    var swap = [
      [modal.querySelector('[data-dd-eyebrow]'), 'notifyEyebrow'],
      [modal.querySelector('[data-dd-phone-hint]'), 'notifyPhoneHint'],
      [modal.querySelector('[data-dd-consent]'), 'notifyConsent'],
      [modal.querySelector('[data-dd-success-title]'), 'notifySuccessTitle'],
      [modal.querySelector('[data-dd-success-body]'), 'notifySuccessBody']
    ].filter(function (p) { return p[0]; }).map(function (p) {
      return { el: p[0], key: p[1], demo: p[0].textContent };
    });
    function applyMode(notify, city) {
      swap.forEach(function (s) {
        var t = notify && i18n[s.key] ? i18n[s.key] : s.demo;
        s.el.textContent = t.replace('__CITY__', city || '');
      });
      if (phoneInput) phoneInput.required = !notify;
    }

    function syncPhonePlaceholder() {
      if (!countrySel || !phoneInput) return;
      var opt = countrySel.options[countrySel.selectedIndex];
      phoneInput.placeholder = opt && opt.dataset.placeholder ? opt.dataset.placeholder : '';
    }
    if (countrySel) {
      countrySel.addEventListener('change', syncPhonePlaceholder);
      syncPhonePlaceholder();
    }

    function digitsValidator(range) {
      var parts = String(range || '').split('-').map(function (s) { return parseInt(s.trim(), 10); });
      var min = parts[0];
      var max = parts[1] || min;
      return function (count) { return count >= min && count <= max; };
    }

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      setTimeout(function () {
        var firstInput = form.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }, 350);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    function resetModal() {
      form.reset();
      form.hidden = false;
      successEl.hidden = true;
      errorEl.hidden = true;
    }

    function attachOpenHandlers() {
      document.querySelectorAll('[data-dd-open]').forEach(function (btn) {
        if (btn.dataset.bound === '1') return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          lastOpener = btn;
          var city = btn.dataset.city || '';
          var eventTag = btn.dataset.eventTag || '';
          isNotify = btn.dataset.notify === '1';
          notifyCity = city;

          if (isNotify) {
            // No-date city - reframe the modal as a "notify me when we open" ask.
            var tmpl = i18n.notifyTitle || 'Get notified when we come to __CITY__';
            titleEl.textContent = tmpl.replace('__CITY__', city);
            subEl.textContent = '';
            setSubmitLabel(i18n.submitNotify || defaultSubmitLabel);
          } else {
            var date = btn.dataset.date || '';
            var time = btn.dataset.time || '';
            var location = btn.dataset.location || '';
            titleEl.textContent = city + (date ? ' - ' + date : '');
            subEl.textContent = location + (time ? ', ' + time : '');
            setSubmitLabel(defaultSubmitLabel);
          }
          eventTagIn.value = eventTag;

          resetModal();
          applyMode(isNotify, city);
          openModal();
        });
      });
    }
    attachOpenHandlers();

    modal.querySelectorAll('[data-dd-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      errorEl.hidden = true;

      var opt = countrySel.options[countrySel.selectedIndex];
      var countryCode = opt.value;
      var allowedDigits = opt.dataset.digits;
      var rawDigits = (phoneInput.value || '').replace(/\D/g, '').replace(/^0+/, '');
      // City waitlist: phone is optional, so only a number that was typed is checked.
      var isValid = (isNotify && !rawDigits) || digitsValidator(allowedDigits)(rawDigits.length);
      if (!isValid) {
        var parts = allowedDigits.split('-');
        var digitsWord = i18n.phoneDigits || 'digits';
        var expected = parts.length === 1 ? parts[0] + ' ' + digitsWord : parts[0] + ' - ' + parts[1] + ' ' + digitsWord;
        var phoneTmpl = i18n.errorPhone || 'Please enter a valid phone number (__EXPECTED__ after __CODE__).';
        errorEl.textContent = phoneTmpl.replace('__EXPECTED__', expected).replace('__CODE__', countryCode);
        errorEl.hidden = false;
        phoneInput.focus();
        return;
      }
      var fullPhone = rawDigits ? countryCode + rawDigits : '';
      var emailVal = (form.querySelector('input[name="email"]').value || '').trim();
      if (isNotify && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailVal)) {
        errorEl.textContent = i18n.notifyErrorEmail || i18n.errorGeneric || 'Please check your email address.';
        errorEl.hidden = false;
        form.querySelector('input[name="email"]').focus();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitLbl.textContent;
      setSubmitLabel((isNotify && i18n.notifySubmitting) || i18n.submitting || 'Reserving…');

      var fd = new FormData(form);
      var payload = {
        email: (fd.get('email') || '').trim(),
        first_name: (fd.get('first_name') || '').trim(),
        phone: fullPhone,
        event_tag: (fd.get('event_tag') || '').trim()
      };
      if (isNotify) {
        // City waitlist: Klaviyo profile + consent + event (klaviyoWaitlist above, no worker).
        // The consent wording she saw travels with it, so we can show what she agreed to.
        payload.page = location.pathname + location.search;
        payload.locale = i18n.locale || '';
        payload.consent_text = (modal.querySelector('[data-dd-consent]') || {}).textContent || '';
        payload.website = fd.get('website') || '';
      }

      (isNotify ? klaviyoWaitlist(payload) : fetch(WORKER_URL.replace(/\/$/, '') + '/demo-signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (r) {
        return r.json().then(function (body) { return { status: r.status, body: body }; })
          .catch(function () { return { status: r.status, body: null }; });
      }))
      .then(function (res) {
        if (res.status >= 200 && res.status < 300 && res.body && res.body.ok) {
          form.hidden = true;
          successEl.hidden = false;
          // Both paths hand us name, email and phone, so both are a Lead.
          trPushConversion(
            'Lead',
            isNotify ? 'test_ride_notify_submit' : 'demo_day_signup',
            {
              content_name: isNotify ? 'Test ride notify' : 'Demo day signup',
              city: isNotify ? notifyCity : (payload.event_tag || '')
            }
            // No eventID: nothing sends this one server-side yet, and the only stable
            // identifier we hold here is the email, which does not belong in an event ID.
          );
        } else if (res.status === 409) {
          errorEl.textContent = i18n.errorCapacity || (res.body && res.body.error) || 'Fully booked.';
          errorEl.hidden = false;
        } else {
          // Never show the worker's own (English, technical) message to a rider.
          errorEl.textContent = (res.body && res.body.code === 'email' && i18n.notifyErrorEmail) || i18n.errorGeneric || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      })
      .catch(function () {
        errorEl.textContent = i18n.errorNetwork || 'Network error. Please try again.';
        errorEl.hidden = false;
      })
      .finally(function () {
        submitBtn.disabled = false;
        setSubmitLabel(submitBtn.dataset.originalText || defaultSubmitLabel);
      });
    });
  })();

  /* ============================================================
     Calendly - private 1-on-1 bookings + the online walkthrough, embedded
     in an on-page modal. The Calendly css/js are lazy-loaded on the first
     [data-calendly-open] click (nothing is fetched otherwise). Clicking a
     button opens our branded modal and renders the Calendly inline widget
     for that URL; if the widget fails to load we fall back to a new tab.
     Opens and completed bookings push dataLayer events for GTM/ads.
     ============================================================ */
  (function () {
    var triggers = document.querySelectorAll('[data-calendly-open]');
    var inlineEls = document.querySelectorAll('[data-calendly-inline]');
    var modal = document.getElementById('tr-cal-modal');
    if (!triggers.length && !inlineEls.length) return;

    var embed = modal ? modal.querySelector('[data-cal-embed]') : null;
    var lastOpener = null;
    var inlineCity = '';
    var BRAND = '0a8f5b'; // brand green - Calendly primary colour
    var calendlyPromise = null;

    function widgetReady() {
      return window.Calendly && typeof window.Calendly.initInlineWidget === 'function';
    }

    // Inject Calendly's css + js on the first open only, so the widget costs
    // nothing on visits where nobody books. Concurrent clicks share one
    // in-flight promise; we resolve even on error so openModal can fall back.
    function loadCalendly() {
      if (calendlyPromise) return calendlyPromise;
      calendlyPromise = new Promise(function (resolve) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.appendChild(link);
        var script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = function () { resolve(); };
        script.onerror = function () { resolve(); };
        document.head.appendChild(script);
      });
      return calendlyPromise;
    }

    // Meta's _fbp/_fbc travel to Calendly in salesforce_uuid, a free-text tracking field meant
    // for exactly this: carrying an external id through a booking. Calendly returns it on the
    // webhook as payload.tracking.salesforce_uuid, and the n8n Schedule workflow splits it back
    // apart. Without it the server-side Schedule event has no browser identity, and if Meta keeps
    // the server copy when deduplicating against the browser event, the booking loses its link to
    // the ad that produced it. Added 2026-09-08 after Event Match Quality showed fbp at 0%.
    function metaIds() {
      function cookie(n) {
        var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
        return m ? decodeURIComponent(m[2]) : '';
      }
      var fbc = cookie('_fbc');
      if (!fbc) {
        try {
          var id = new URLSearchParams(window.location.search).get('fbclid');
          if (id) fbc = 'fb.1.' + Date.now() + '.' + id;
        } catch (e) {}
      }
      var pair = cookie('_fbp') + '~' + fbc;
      return pair === '~' ? '' : pair;
    }

    // Landing-page variant (2026-10-19): on a ?view=lp-… page the variant and Meta's ad_id ride in the
    // same salesforce_uuid field as segments 3 and 4: '<fbp>~<fbc>~<lp-variant>~<ad_id>'. Not in utm_*:
    // the Calendly widget copies the page's own utm_* (ad name, ad set name) onto the booking and would
    // collide (found by marketing-analytics 19-10). n8n Tl2hKQ3KkIhKZFhc reads segments 3-4.
    // Program: 3 - Website/Landingssider/README.md.
    function landingIds() {
      try {
        var q = new URLSearchParams(window.location.search);
        var view = q.get('view');
        if (!view || !/^lp-[a-z0-9-]{1,40}$/.test(view)) return null;
        var ad = q.get('ad_id');
        return { view: view, ad: (ad && /^[0-9]{15,20}$/.test(ad)) ? ad : '' };
      } catch (e) { return null; }
    }

    function brandUrl(base) {
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var url = base + sep + 'hide_gdpr_banner=1&primary_color=' + BRAND;
      var fb = metaIds();
      var lp = landingIds();
      if (lp) fb = (fb || '~') + '~' + lp.view + '~' + lp.ad;
      if (fb) url += '&salesforce_uuid=' + encodeURIComponent(fb);
      return url;
    }

    function openModal(url, btn) {
      var dl = (window.dataLayer = window.dataLayer || []);
      if (btn && btn.getAttribute('data-walkthrough') === '1') {
        dl.push({ event: 'online_walkthrough_open' });
      } else {
        dl.push({ event: 'test_ride_calendar_open', city: (btn && btn.getAttribute('data-city')) || '' });
      }
      if (!modal || !embed || !widgetReady()) { window.open(url, '_blank', 'noopener'); return; }
      lastOpener = btn || null;
      embed.innerHTML = '';
      window.Calendly.initInlineWidget({ url: brandUrl(url), parentElement: embed });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      // Tear down the iframe so a re-open starts clean.
      setTimeout(function () { if (!modal.classList.contains('is-open')) embed.innerHTML = ''; }, 300);
      if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('data-calendly-url');
        if (!url) return;
        loadCalendly().then(function () { openModal(url, btn); });
      });
    });

    if (modal) {
      modal.querySelectorAll('[data-cal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }

    // Inline embed(s): render Calendly straight on the page (single-city landing
    // pages), no pop-up. Loaded lazily as the booking section nears the viewport,
    // so it costs nothing up top. Reuses loadCalendly() + brandUrl(); bookings are
    // tracked by the shared calendly.event_scheduled listener below.
    if (inlineEls.length) {
      inlineCity = inlineEls[0].getAttribute('data-city') || '';
      var renderInline = function () {
        // The div carries class 'calendly-inline-widget' + data-url, so Calendly's
        // widget.js auto-initialises AND auto-resizes it (no internal scroll) the
        // moment the script loads. We only lazy-load the script when it nears view.
        loadCalendly();
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { renderInline(en.target); obs.unobserve(en.target); }
          });
        }, { rootMargin: '400px 0px' });
        inlineEls.forEach(function (el) { io.observe(el); });
      } else {
        inlineEls.forEach(renderInline);
      }

      // Calendly reports its content height for inline embeds as it moves through
      // steps (calendar -> times -> form). Grow the box to match, so the whole form
      // shows and the PAGE scrolls - not the widget inside a fixed box.
      window.addEventListener('message', function (e) {
        if (!e.data || e.data.event !== 'calendly.page_height') return;
        if (typeof e.origin === 'string' && e.origin.indexOf('calendly.com') === -1) return;
        var px = e.data.payload && e.data.payload.height;
        if (px) inlineEls.forEach(function (el) { el.style.height = px; });
      });
    }

    window.addEventListener('message', function (e) {
      if (!e.data || e.data.event !== 'calendly.event_scheduled') return;
      if (typeof e.origin === 'string' && e.origin.indexOf('calendly.com') === -1) return;
      // lp-proevetur har også prøveturskortet (snippets/testride-calendly) med egen modal. Kom bookingen
      // derfra, sender den modal selv Schedule + test_ride_booked; her ville den tælle to gange (19-10-2026).
      var trc = document.getElementById('trc-modal');
      if (trc && trc.classList.contains('is-open')) return;

      // Which calendar was open decides what we just booked. The 15-minute online
      // walkthrough and a 30-minute physical test ride are not the same conversion.
      // If the modal is open the booking came from it (walkthrough or a card pop-up);
      // otherwise it came from an inline on-page widget, which is always a test ride.
      var modalOpen = !!(modal && modal.classList.contains('is-open'));
      var isWalkthrough = modalOpen && !!(lastOpener && lastOpener.getAttribute('data-walkthrough') === '1');
      var bookedCity = modalOpen ? ((lastOpener && lastOpener.getAttribute('data-city')) || '') : inlineCity;

      // Calendly hands back the invitee URI. Its UUID is the one identifier the server
      // sees too, so it is what makes browser and CAPI events dedupe as one booking.
      var payload = (e.data && e.data.payload) || {};
      var inviteeUri = (payload.invitee && payload.invitee.uri) || '';
      var eventId = inviteeUri ? 'cal_' + inviteeUri.split('/').pop() : '';

      trPushConversion(
        'Schedule',
        isWalkthrough ? 'online_walkthrough_booked' : 'test_ride_booked',
        {
          content_name: isWalkthrough ? 'Online walkthrough' : 'City U test ride',
          booking_type: isWalkthrough ? 'online_walkthrough' : 'private_test_ride',
          city: bookedCity
        },
        eventId
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var seq = document.getElementById('tr-hero-sequence');
    if (seq) {
      requestAnimationFrame(function () {
        setTimeout(function () { seq.classList.add('is-loaded'); }, 80);
      });
    }

    // Smooth scroll for in-page anchor buttons
    document.querySelectorAll('.tr-smooth-scroll').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rails = document.querySelectorAll('[data-how-rail]');
    rails.forEach(function (rail) {
      var steps = rail.querySelectorAll('[data-how-step]');
      var tracks = rail.querySelectorAll('[data-how-track]');
      if (!steps.length) return;
      // Markér at JS er i live FØR observeren, ellers blinker teksten væk.
      rail.setAttribute('data-how-ready', '');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        steps.forEach(function (s) { s.classList.add('is-done'); });
        tracks.forEach(function (t) { t.classList.add('is-filled'); });
        return;
      }

      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || fired) return;
        fired = true;
        io.disconnect();
        // 600 ms pr. trin. FixFlow kører 850, men den har flere trin og et
        // panel bagefter; tre trin på 850 føles langsomt lige over en CTA.
        steps.forEach(function (step, i) {
          var d = i * 600;
          setTimeout(function () { step.classList.add('is-done'); }, d);
          if (tracks[i]) setTimeout(function () { tracks[i].classList.add('is-filled'); }, d + 320);
        });
      }, { threshold: 0.35 });
      io.observe(rail);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlider(slider) {
      var slides   = slider.querySelectorAll('.tr-sp__slide');
      var thumbs   = slider.querySelectorAll('.tr-sp__thumb');
      var prevBtn  = slider.querySelector('.tr-sp__thumb-arrow--prev');
      var nextBtn  = slider.querySelector('.tr-sp__thumb-arrow--next');
      var stage    = slider.querySelector('.tr-sp__stage');
      var pauseBtn = stage && stage.querySelector('.tr-sp__pause-btn');
      var current  = 0;
      var total    = slides.length;

      function updateArrows() {
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === total - 1;
      }

      function goTo(index) {
        if (index === current || index < 0 || index >= total) return;
        var oldVideo = slides[current].querySelector('video');
        if (oldVideo) {
          oldVideo.pause();
          slides[current].classList.remove('is-playing', 'is-paused');
        }
        slides[current].classList.remove('is-active');
        thumbs[current] && thumbs[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        thumbs[current] && thumbs[current].classList.add('is-active');
        thumbs[current] && thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        updateArrows();
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          goTo(parseInt(thumb.getAttribute('data-target'), 10));
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
      updateArrows();

      slides.forEach(function(slide) {
        var playBtn = slide.querySelector('.tr-sp__play-btn');
        var video   = slide.querySelector('video');
        if (!playBtn || !video) return;

        playBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (video.paused) {
            var p = video.play();
            if (p !== undefined) {
              p.then(function() {
                slide.classList.add('is-playing');
                slide.classList.remove('is-paused');
              }).catch(function() {});
            } else {
              slide.classList.add('is-playing');
              slide.classList.remove('is-paused');
            }
          } else {
            video.pause();
          }
        });

        video.addEventListener('pause', function() {
          slide.classList.remove('is-playing');
          slide.classList.add('is-paused');
          if (stage) stage.classList.remove('has-playing');
        });

        video.addEventListener('playing', function() {
          slide.classList.add('is-playing');
          slide.classList.remove('is-paused');
          if (stage) stage.classList.add('has-playing');
        });

        video.addEventListener('ended', function() {
          slide.classList.remove('is-playing', 'is-paused');
          if (stage) stage.classList.remove('has-playing');
        });
      });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function() {
          var playing = slider.querySelector('.tr-sp__slide.is-playing video');
          if (playing) playing.pause();
        });
      }
    }

    document.querySelectorAll('.tr-sp__slider-wrap').forEach(function(slider) {
      initSlider(slider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('tr-sticky-cta');
    if (!bar) return;
    if (bar.hasAttribute('data-smart')) { smart(bar); return; }
    // Bjælken rendres med [hidden] (ingen flash før JS). Audit 30-10-2026: attributten blev aldrig fjernet her,
    // så knappen var død på alle fem sider (10 af 10 målinger). Smart-grenen gjorde det allerede.
    bar.hidden = false;
    bar.setAttribute('aria-hidden', 'true');

    var targetSel = bar.getAttribute('data-hide-when') || '#private-rides';
    var target = document.querySelector(targetSel);

    // Reveal only after the user scrolls past the first viewport, and hide while
    // the booking section itself is on screen (they're already there).
    var bookingVisible = false;
    var scrolledEnough = false;

    function sync() {
      var show = scrolledEnough && !bookingVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-bottom-bar', show);
    }

    if ('IntersectionObserver' in window && target) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bookingVisible = e.isIntersecting; });
        sync();
      }, { rootMargin: '0px 0px -35% 0px' });
      io.observe(target);
    }

    function onScroll() {
      scrolledEnough = window.pageYOffset > (window.innerHeight * 0.6);
      sync();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var btn = bar.querySelector('[data-tr-sticky-btn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        (window.dataLayer = window.dataLayer || []).push({ event: 'test_ride_sticky_click' });
        var href = btn.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex !== -1) {
          var el = document.getElementById(href.slice(hashIndex + 1));
          if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      });
    }

    // Koncept A. Tre betingelser før bjælken vises: cookievalget er truffet, siden
    // er rullet 60 % af første skærm, og bookingsektionen er ikke på skærmen.
    function smart(bar) {
      var targetSel = bar.getAttribute('data-hide-when') || '#private-rides';
      var target = document.querySelector(targetSel);
      var variant = bar.getAttribute('data-variant') || '';
      var bookingVisible = false, scrolledEnough = false, consentDone = false;
      bar.hidden = false;

      function sync() {
        var show = consentDone && scrolledEnough && !bookingVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
        if (show) document.body.style.setProperty('--tr-bar-h', bar.offsetHeight + 'px');
        document.body.classList.toggle('has-bottom-bar', show);
      }

      function bannerShowing() {
        var b = document.getElementById('shopify-pc__banner');
        if (!b) return false;
        var r = b.getBoundingClientRect();
        var cs = window.getComputedStyle(b);
        return r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden';
      }
      function decided() {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp) {
          try {
            var c = cp.currentVisitorConsent && cp.currentVisitorConsent();
            if (c && (c.marketing !== '' || c.analytics !== '' || c.preferences !== '')) return true;
          } catch (e) {}
          try {
            if (typeof cp.shouldShowBanner === 'function' && !cp.shouldShowBanner()) return true;
          } catch (e) {}
          return false;
        }
        return null;
      }
      function checkConsent() {
        if (consentDone) return;
        var d = decided();
        if (d === true || (d === null && !bannerShowing() && document.readyState === 'complete')) {
          consentDone = true;
          sync();
        }
      }
      document.addEventListener('visitorConsentCollected', function () { consentDone = true; sync(); });
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], checkConsent);
      }
      var tries = 0;
      var poll = setInterval(function () {
        checkConsent();
        if (consentDone || ++tries > 40) clearInterval(poll);
      }, 500);

      if ('IntersectionObserver' in window && target) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { bookingVisible = e.isIntersecting; });
          sync();
        }, { rootMargin: '0px 0px -35% 0px' }).observe(target);
      }
      function onScroll() {
        scrolledEnough = window.pageYOffset > (window.innerHeight * 0.6);
        sync();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // Annoncetrafik har sine egne utm_*, som Calendly-widgetten kopierer til bookingen. Så
      // fjernes vores fra linkene, så de to sæt ikke kolliderer (Landingssider/README.md §5).
      if (/[?&]utm_[a-z]+=/i.test(window.location.search)) {
        bar.querySelectorAll('[data-calendly-url]').forEach(function (a) {
          var clean = (a.getAttribute('data-calendly-url') || '').split('?')[0];
          a.setAttribute('data-calendly-url', clean);
          a.setAttribute('href', clean);
        });
      }

      bar.querySelectorAll('[data-tr-sticky-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          (window.dataLayer = window.dataLayer || []).push({
            event: 'cta_klik',
            placering: 'tr_sticky',
            maal: btn.getAttribute('data-cta-target') || 'test_ride',
            variant: variant,
            city: btn.getAttribute('data-city') || ''
          });
          if (btn.hasAttribute('data-tr-sticky-scroll')) {
            var href = btn.getAttribute('href') || '';
            var k = href.indexOf('#');
            var el = k !== -1 ? document.getElementById(href.slice(k + 1)) : null;
            if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.test-ride');
  if (!section) return;
  var img = section.querySelector('.test-ride__bg-img');
  if (!img) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced) section.classList.add('test-ride--js');

  function update() {
    if (reduced) return;
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    if (rect.bottom < 0 || rect.top > vh) return;
    /* Vinduet staar stille mens sektionen kommer ind, og udvider sig naar
       dens top passerer 55% af viewporten — fuldt aabent ved 5%. */
    var progress = (vh * 0.55 - rect.top) / (vh * 0.5);
    progress = Math.max(0, Math.min(1, progress));
    var e = progress * progress * (3 - 2 * progress);   /* smoothstep */
    var v = (24 * (1 - e)).toFixed(2);
    var h = (22 * (1 - e)).toFixed(2);
    var r = (36 * (1 - e)).toFixed(1);
    img.style.clipPath = 'inset(' + v + '% ' + h + '% ' + v + '% ' + h + '% round ' + r + 'px)';
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  /* Tags on one line: shrink the text in 0.5px steps (11px down to 9px) until the row fits.
     Only if it still overflows at 9px do the last tags become "+N". Nichlas 16-10-2026. */
  (function () {
    var MAX = 11, MIN = 9;
    function setSize(tags, fs) {
      tags.forEach(function (t) {
        t.style.fontSize = fs + 'px';
        t.style.padding = '3px ' + Math.round(fs * 0.73) + 'px';
      });
    }
    function fitRow(row) {
      if (!row.offsetWidth) return;
      row.classList.add('is-fit');
      var tags = Array.prototype.slice.call(row.querySelectorAll('.tr__card-tag:not(.tr__card-tag--more)'));
      var more = row.querySelector('.tr__card-tag--more');
      if (more) more.remove();
      tags.forEach(function (t) { t.style.display = ''; });
      var fits = function () { return row.scrollWidth <= row.clientWidth + 1; };
      var fs = MAX;
      setSize(tags, fs);
      while (!fits() && fs > MIN) { fs -= 0.5; setSize(tags, fs); }
      var hidden = 0;
      if (!fits()) {
        more = document.createElement('span');
        more.className = 'tr__card-tag tr__card-tag--more';
        row.appendChild(more);
        setSize([more], fs);
        while (!fits() && hidden < tags.length - 1) {
          tags[tags.length - 1 - hidden].style.display = 'none';
          hidden++;
          more.textContent = '+' + hidden;
        }
      }
    }
    function fitAll() {
      document.querySelectorAll('.tr__card-tags').forEach(fitRow);
    }
    var timer;
    function later() { clearTimeout(timer); timer = setTimeout(fitAll, 120); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll); else fitAll();
    window.addEventListener('load', fitAll);
    window.addEventListener('resize', later);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.tr__filter-btn, .tr__bar-row, .tr__load-more-btn')) later();
    });
  })();

  (function () {
    var anchor = document.getElementById('testimonials');
    if (!anchor) return;
    var section = anchor.closest('section') || anchor.parentElement;

    var filterBtns = section.querySelectorAll('.tr__filter-btn');
    var barRows = section.querySelectorAll('.tr__bar-row[data-bar-filter]');
    var grid = section.querySelector('.tr__grid');

    /* ── Load-more (desktop only) ── */
    var loadMoreBtn = section.querySelector('.tr__load-more-btn');
    var isDesktop = window.innerWidth > 600;
    var visibleRows = 2;

    function getColCount() {
      if (window.innerWidth > 900) return 3;
      if (window.innerWidth > 600) return 2;
      return 0;
    }

    function applyRowLimit() {
      if (!grid || !isDesktop) return;
      var cols = getColCount();
      if (!cols) return;
      var cards = grid.querySelectorAll('.tr__card:not(.is-filtered-out)');
      var maxVisible = visibleRows * cols;
      var hasHidden = false;
      cards.forEach(function (card, i) {
        if (i < maxVisible) {
          card.classList.remove('is-row-hidden');
        } else {
          card.classList.add('is-row-hidden');
          hasHidden = true;
        }
      });
      if (loadMoreBtn) {
        loadMoreBtn.style.display = hasHidden ? '' : 'none';
      }
    }

    function revealMoreRows() {
      visibleRows += 2;
      var cols = getColCount();
      if (!cols) return;
      var cards = grid.querySelectorAll('.tr__card:not(.is-filtered-out)');
      var maxVisible = visibleRows * cols;
      var hasHidden = false;
      cards.forEach(function (card, i) {
        if (i < maxVisible && card.classList.contains('is-row-hidden')) {
          card.classList.add('is-row-revealing');
          card.offsetHeight;
          card.classList.remove('is-row-hidden');
          card.classList.remove('is-row-revealing');
        } else if (i >= maxVisible) {
          hasHidden = true;
        }
      });
      if (loadMoreBtn) {
        loadMoreBtn.style.display = hasHidden ? '' : 'none';
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', revealMoreRows);
    }

    if (isDesktop) applyRowLimit();

    function applyFilter(filter) {
      if (!grid) return;
      var cards = grid.querySelectorAll('.tr__card');
      filterBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-filter') === filter);
      });
      barRows.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-bar-filter') === filter);
      });
      cards.forEach(function (card) {
        if (filter === 'all' || card.getAttribute('data-rating') === filter) {
          card.classList.remove('is-filtered-out');
        } else {
          card.classList.add('is-filtered-out');
        }
      });
      visibleRows = 2;
      applyRowLimit();
    }

    if (filterBtns.length && grid) {
      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyFilter(btn.getAttribute('data-filter'));
        });
      });
    }

    barRows.forEach(function (row) {
      row.addEventListener('click', function () {
        var star = row.getAttribute('data-bar-filter');
        var isActive = row.classList.contains('is-active');
        applyFilter(isActive ? 'all' : star);
      });
    });

    if (!grid || window.innerWidth > 600) return;

    var SPEED = 0.15;
    var raf = null;
    var stopped = false;
    var maxScroll = grid.scrollWidth - grid.clientWidth;

    window.addEventListener('resize', function () {
      maxScroll = grid.scrollWidth - grid.clientWidth;
    }, { passive: true });

    function step() {
      if (stopped) return;
      if (maxScroll > 0) {
        grid.scrollLeft += SPEED;
        if (grid.scrollLeft >= maxScroll) grid.scrollLeft = 0;
      }
      raf = requestAnimationFrame(step);
    }

    // The moment the rider takes control, hand it over for good - no resume,
    // no snap back to the first review. Restore scroll-snap for clean swiping.
    function stopAuto() {
      if (stopped) return;
      stopped = true;
      if (raf) cancelAnimationFrame(raf);
      grid.classList.remove('is-autoscrolling');
    }

    grid.addEventListener('touchstart', stopAuto, { passive: true, once: true });
    grid.addEventListener('wheel', stopAuto, { passive: true, once: true });

    grid.classList.add('is-autoscrolling');
    raf = requestAnimationFrame(step);
  })();

  /* ── Review iframe modal ── */
  (function () {
    var modal = document.getElementById('tr-iframe-modal');
    if (!modal) return;
    var iframe = modal.querySelector('.tr-iframe-modal__frame');
    var loaded = false;

    function openModal() {
      if (!loaded && iframe) {
        iframe.src = iframe.getAttribute('data-src');
        loaded = true;
      }
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-review-open]')) {
        e.preventDefault();
        openModal();
        return;
      }
      if (e.target.closest('[data-review-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    window.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'bycycle-review-close') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
